(function () {
  "use strict";

  var productJsonCache = {};
  var HOT_TUB_COVER_MAX_SIZE_INCHES = 119;
  var SWIM_SPA_MIN_LONG_SIDE_INCHES = 120;
  var SWIM_SPA_MAX_LONG_SIDE_INCHES = 252;
  var SWIM_SPA_PRODUCT_URL = "/products/custom-swim-spa-cover-easy-to-use-durable-protection-for-all-swim-spas";
  var ROLLAWAY_SWIM_SPA_PRODUCT_URL = "/products/custom-rollaway-swim-spa-cover";
  var HOT_TUB_SIZE_HINT = "Measure the spa shell edge to edge, not your cover (covers warp over time). Round up to the nearest half inch.";
  var REGULAR_SIZE_MAX_INCHES = 96;
  var SWIM_SPA_SIZE_CONTEXT_MESSAGE = "That's swim spa size (120 in. or more). Switch to the swim spa builder for a proper fit, or request a custom quote.";
  var SWIM_SPA_MIN_LONG_SIDE_MESSAGE = "Swim spa covers start at 120 in. on the longest side. For smaller covers, please order a regular spa cover or regular rollaway spa cover.";
  var ROLLAWAY_SWIM_SPA_MIN_LONG_SIDE_MESSAGE = SWIM_SPA_MIN_LONG_SIDE_MESSAGE;
  var SWIM_SPA_MAX_LONG_SIDE_MESSAGE = "Swim spa covers are available up to 252 in. / 21 ft. on the longest side. For larger covers, please contact us for a custom quote.";
  var SWIM_SPA_TWO_OVERSIZED_SIDES_MESSAGE = "Swim spa covers can only be oversized on one side. If both A and B are over 96 in., please contact us for a custom quote.";
  var HOT_TUB_TWO_OVERSIZED_SIDES_MESSAGE = "Hot tub covers can only be oversized on one side. If both A and B are over 96 in., please contact us for a custom quote.";
  var CLASSIC_THICKNESS_WARNING_MESSAGE = "❄️ Cold weather note: Classic Cover Thickness (4\" - 2\") is best for mild climates. For outdoor use in cold weather, choose Premium (5\" - 3\") or Extreme (6\" - 4\") for better durability and performance.";
  var CORNER_RADIUS_MEASURED_VALUE = "I measured my corner radius.";
  var CORNER_RADIUS_HELP_VALUE = "I need help measuring my corner radius.";
  var CORNER_RADIUS_HELP_MESSAGE = "Good to proceed. You can complete the order and a staff member will contact you for assistance.";
  var CORNER_RADIUS_HELP_SUMMARY = "Staff member will contact you for assistance.";
  var BUILDER_NOTE_START = "----- Spa-Migo Builder Details START ";
  var BUILDER_NOTE_END = "----- Spa-Migo Builder Details END ";
  var localeTranslations = {
    fr: {
      "4.7 (2,000+ reviews)": "4,7 (2 000+ avis)",
      "Made in Canada": "Fabriqué au Canada",
      "Build": "Configurer",
      "SALE": "Soldes",
      "Cover preview": "Aperçu de la couverture",
      "Product media": "Médias du produit",
      "Expand current image": "Agrandir l’image actuelle",
      "Selected specs": "Spécifications sélectionnées",
      "Specifications selectionnees": "Spécifications sélectionnées",
      "All our covers include:": "Toutes nos couvertures comprennent :",
      " (FREE - valued at $49.99)": " (GRATUIT - valeur de 49,99 $)",
      "Rollaway one-person opening": "Ouverture enroulable par une seule personne",
      "Chemical Resistant Liner": "Doublure résistante aux produits chimiques",
      "Integrated rollaway strap system": "Système de sangles enroulables intégré",
      "Custom-fit hot tub sizing": "Dimensions sur mesure pour spa",
      "10-Year Warranty": "Garantie de 10 ans",
      "Made for Year-Round Use": "Conçue pour une utilisation toute l’année",
      "Sealed Vapor Barrier": "Barrière pare-vapeur scellée",
      "1.5 Lbs Foam Density": "Mousse de densité 1,5 lb",
      "4 Locking Straps": "4 sangles verrouillables",
      "Steam Stoppers": "Butées de vapeur",
      "2 Reinforced Handles": "2 poignées renforcées",
      "Do you have additional questions?": "Avez-vous d’autres questions ?",
      "Call +1 (866) 515-6446": "Appelez le +1 (866) 515-6446",
      "Find Your Hot Tub Model": "Trouvez votre modèle de spa",
      "Find Your Swim Spa Model": "Trouvez votre modèle de spa de nage",
      "Optional": "Facultatif",
      "Search by brand, model, or product code.": "Recherchez par marque, modèle ou code produit.",
      "Search by brand, model, or product code": "Rechercher par marque, modèle ou code produit",
      "Search brand, model or product code...": "Rechercher une marque, un modèle ou un code produit...",
      "Hot tub brand / model": "Marque / modèle du spa",
      "Example: Jacuzzi J-365, Bullfrog A7": "Exemple : Jacuzzi J-365, Bullfrog A7",
      "Optional, but helpful if you know it.": "Facultatif, mais utile si vous le connaissez.",
      "Searching...": "Recherche en cours...",
      "We cannot find this model in our website database. Please enter your measurements below or": "Nous ne trouvons pas ce modèle dans notre base de données. Veuillez entrer vos mesures ci-dessous ou",
      "Enter your own measurements for": "Entrez vos propres mesures pour",
      "Using model name:": "Nom du modèle utilisé :",
      "Hot tub model": "Modèle de spa",
      "Hot Tub Model": "Modèle de spa",
      "Swim Spa Model": "Modèle de spa de nage",
      "Custom Swim Spa Covers": "Couvertures de spa de nage sur mesure",
      "Choose the skirt length that matches your existing cover.": "Choisissez la longueur de jupe correspondant à votre couverture actuelle.",
      "contact us": "contactez-nous",
      "for assistance.": "pour obtenir de l’aide.",
      "Something went wrong. Please try again.": "Une erreur est survenue. Veuillez réessayer.",
      "Select cover type": "Sélectionnez le type de couverture",
      "Traditional swim spa cover": "Couverture traditionnelle de spa de nage",
      "Rollaway swim spa cover": "Couverture enroulable de spa de nage",
      "Traditional hot tub cover": "Couverture traditionnelle de spa",
      "Rollaway hot tub cover": "Couverture enroulable de spa",
      "Regular cover": "Couverture régulière",
      "Rollaway cover": "Couverture enroulable",
      "Regular insulated cover": "Couverture isolée régulière",
      "Custom Hot Tub Cover": "Couverture de spa sur mesure",
      "Custom cover": "Couverture sur mesure",
      "The everyday classic.": "Le classique du quotidien.",
      "Best for energy savings, snow load, and everyday replacement.": "Idéale pour les économies d’énergie, la charge de neige et le remplacement courant.",
      "The premium upgrade.": "La version haut de gamme.",
      "Best for fast access, lighter handling, and larger spans.": "Idéale pour un accès rapide, une manipulation plus légère et les grandes portées.",
      "Order summary": "Résumé de la commande",
      "Your price": "Votre prix",
      "ADD TO CART": "AJOUTER AU PANIER",
      "Trusted by 10,000+ hot tub owners in North America": "Adoptée par plus de 10 000 propriétaires de spa en Amérique du Nord",
      "Trusted by 10,000+ spa owners in North America": "Adoptée par plus de 10 000 propriétaires de spa en Amérique du Nord",
      "Price details": "Détails du prix",
      "Included": "Inclus",
      "Custom sizing": "Dimensions sur mesure",
      "Production/spec review": "Révision de la production et des spécifications",
      "Shipping": "Livraison",
      "Free": "Gratuite",
      "Selected upgrades": "Options sélectionnées",
      "Estimated total": "Total estimé",
      "Secure checkout": "Paiement sécurisé",
      "Your order is safe and secure.": "Votre commande est sécurisée.",
      "256-bit SSL encrypted": "Chiffré SSL 256 bits",
      "AquaTEX™ Included": "AquaTEX™ inclus",
      "AquaTEX™ Advantage": "Avantage AquaTEX™",
      "Upgrade": "Surclassement",
      "Every rollaway cover includes waterproof AquaTEX™ fabric for flexible handling, UV resistance, and easy cleaning.": "Chaque couverture enroulable comprend un tissu AquaTEX™ imperméable pour une manipulation souple, une résistance aux UV et un nettoyage facile.",
      "Upgrade to AquaTEX fabric for a lighter, stronger, weather-resistant spa cover.": "Passez au tissu AquaTEX pour une couverture de spa plus légère, plus robuste et résistante aux intempéries.",
      "Waterproof fabric": "Tissu imperméable",
      "UV and mold resistant": "Résistant aux UV et à la moisissure",
      "Easy to clean": "Facile à nettoyer",
      "3× stronger, 25% lighter": "3× plus résistant, 25 % plus léger",
      "AquaTEX™ premium fabric": "Tissu AquaTEX™ haut de gamme",
      "Upgrade to AquaTEX™": "Passez à AquaTEX™",
      "Waterproof": "Imperméable",
      "Premium woven texture": "Texture tissée haut de gamme",
      "This field is required.": "Ce champ est obligatoire.",
      "❄️ Cold weather note: Classic Cover Thickness (4\" - 2\") is best for mild climates. For outdoor use in cold weather, choose Premium (5\" - 3\") or Extreme (6\" - 4\") for better durability and performance.": "❄️ Note pour temps froid : l’épaisseur Classic (4 po - 2 po) convient mieux aux climats doux. Pour une utilisation extérieure par temps froid, choisissez Premium (5 po - 3 po) ou Extreme (6 po - 4 po) pour une meilleure durabilité et performance.",
      "Size": "Taille",
      "Select size": "Sélectionnez la taille",
      "Selected size": "Taille sélectionnée",
      "One size": "Taille unique",
      "Choose the closest factory size, then edit measurements below if needed.": "Choisissez la taille d’usine la plus proche, puis modifiez les mesures ci-dessous au besoin.",
      "Select your size. You can adjust measurements below.": "Sélectionnez votre taille. Vous pouvez ajuster les mesures ci-dessous.",
      "Need a different size ?": "Besoin d’une taille différente ?",
      "Configure your custom cover": "Configurez votre couverture sur mesure",
      "Measurements": "Mesures",
      "These measurements are prefilled from the selected size. Edit them if your cover needs a correction.": "Ces mesures sont préremplies à partir de la taille sélectionnée. Modifiez-les si votre couverture nécessite une correction.",
      "Prefilled from the selected size. Edit if needed.": "Prérempli à partir de la taille sélectionnée. Modifiez au besoin.",
      "Measure the spa shell edge to edge, not your cover (covers warp over time). Round up to the nearest half inch.": "Mesurez la coque du spa bord à bord, pas votre housse (les housses se déforment avec le temps). Arrondissez au demi-pouce supérieur.",
      "Raised waterfalls, speakers, or fountains?": "Cascades, haut-parleurs ou fontaines surélevés ?",
      "and we'll build around them.": "et nous l'adapterons.",
      "That's swim spa size (120 in. or more). Switch to the swim spa builder for a proper fit, or request a custom quote.": "C’est une taille de spa de nage (120 po ou plus). Utilisez le configurateur pour spa de nage pour un ajustement parfait, ou demandez une soumission personnalisée.",
      "Contact us": "Contactez-nous",
      "Swim spa covers start at 120 in. on the longest side. For smaller covers, please order a regular spa cover or regular rollaway spa cover.": "Les couvertures de spa de nage commencent à 120 po sur le côté le plus long. Pour les couvertures plus petites, commandez une couverture de spa régulière ou une couverture de spa enroulable régulière.",
      "Rollaway swim spa covers start over 96 in. on the longest side. For 96 in. or smaller, order a regular rollaway hot tub cover.": "Les couvertures enroulables pour spa de nage commencent au-dessus de 96 po sur le cote le plus long. Pour 96 po ou moins, commandez une couverture enroulable pour spa.",
      "For rollaway covers over 96 in. on the longest side. Enter the outside edge-to-edge measurements and round up to the nearest half inch.": "Pour les couvertures enroulables de plus de 96 po sur le cote le plus long. Entrez les mesures bord a bord et arrondissez au demi-pouce superieur.",
      "Swim spa covers are available up to 252 in. / 21 ft. on the longest side. For larger covers, please contact us for a custom quote.": "Les couvertures de spa de nage sont offertes jusqu’à 252 po / 21 pi sur le côté le plus long. Pour les couvertures plus grandes, veuillez nous contacter pour une soumission personnalisée.",
      "Swim spa covers can only be oversized on one side. If both A and B are over 96 in., please contact us for a custom quote.": "Les couvertures de spa de nage ne peuvent être surdimensionnées que sur un côté. Si A et B dépassent 96 po, veuillez nous contacter pour une soumission personnalisée.",
      "Hot tub covers can only be oversized on one side. If both A and B are over 96 in., please contact us for a custom quote.": "Les couvertures de spa ne peuvent être surdimensionnées que sur un côté. Si A et B dépassent 96 po, veuillez nous contacter pour une soumission personnalisée.",
      "Request a quote": "Demander une soumission",
      "Open the rollaway swim spa builder": "Ouvrir le configurateur enroulable pour spa de nage",
      "Open the swim spa builder": "Ouvrir le configurateur pour spa de nage",
      "Cover type": "Type de couverture",
      "Traditional": "Traditionnelle",
      "Rollaway": "Enroulable",
      "5 in. - 4 in. - 3 in.": "5 po - 4 po - 3 po",
      "5 in. to 4 in. to 3 in.": "5 po à 4 po à 3 po",
      "Swim Spa Cover Length": "Longueur de couverture de spa de nage",
      "Swim Spa Cover Length 13 ft - 14.9 ft": "Longueur de couverture de spa de nage 13 pi - 14,9 pi",
      "Swim Spa Cover Length 15 ft - 16.9 ft": "Longueur de couverture de spa de nage 15 pi - 16,9 pi",
      "Swim Spa Cover Length 17 ft - 18.9 ft": "Longueur de couverture de spa de nage 17 pi - 18,9 pi",
      "Swim Spa Cover Length 19 ft - 21 ft": "Longueur de couverture de spa de nage 19 pi - 21 pi",
      "Rollaway Spa Cover Length": "Longueur de couverture enroulable de spa",
      "Rollaway Spa Cover Length 13 ft - 14.9 ft": "Longueur de couverture enroulable de spa 13 pi - 14,9 pi",
      "Rollaway Spa Cover Length 15 ft - 16.9 ft": "Longueur de couverture enroulable de spa 15 pi - 16,9 pi",
      "Rollaway Spa Cover Length 17 ft - 18.9 ft": "Longueur de couverture enroulable de spa 17 pi - 18,9 pi",
      "Rollaway Spa Cover Length 19 ft - 20.9 ft": "Longueur de couverture enroulable de spa 19 pi - 20,9 pi",
      "Recommended": "Recommandé",
      "selected": "sélectionnés",
      "skirt": "jupe",
      "thickness": "épaisseur",
      "Cut": "Pli",
      "Shape": "Forme",
      "A length": "Longueur A",
      "B width": "Largeur B",
      "C corner radius": "Rayon d’angle C",
      "D corner radius": "Rayon d’angle D",
      "C dimension": "Dimension C",
      "D dimension": "Dimension D",
      "Speaker pockets": "Pochettes pour haut-parleurs",
      "Strap placement": "Emplacement des sangles",
      "Measurements & build": "Mesures et conception",
      "Cover choices": "Choix de couverture",
      "Added items": "Articles ajoutés",
      "Select cover thickness": "Sélectionnez l’épaisseur de la couverture",
      "Selectionnez l'epaisseur": "Sélectionnez l’épaisseur",
      "Selectionnez l'epaisseur de la housse": "Sélectionnez l’épaisseur de la couverture",
      "Select cover shape": "Sélectionnez la forme de la couverture",
      "Select cover size": "Sélectionnez la taille de la couverture",
      "Round up to the next larger size. If your size is not listed, enter your exact measurements.": "Arrondissez à la taille supérieure. Si votre taille n’est pas indiquée, entrez vos mesures exactes.",
      "Round up to the next larger size. Regular hot tub covers are available up to 96 in.": "Arrondissez à la taille supérieure. Les couvertures de spa régulières sont offertes jusqu’à 96 po.",
      "Available up to 96 x 96 in. For larger covers, please contact us or call +1 866-515-6446.": "Offert jusqu’à 96 x 96 po. Pour une couverture plus grande, veuillez nous contacter ou appeler le +1 866-515-6446.",
      "Enter the outside edge-to-edge measurements. Round up to the nearest half inch.": "Entrez les mesures d’un bord extérieur à l’autre. Arrondissez au demi-pouce supérieur.",
      "Length A (in.)": "Longueur A (po)",
      "Width B (in.)": "Largeur B (po)",
      "Fold orientation": "Orientation du pli",
      "For rectangular covers, choose which direction the center hinge runs.": "Pour les couvertures rectangulaires, choisissez le sens du joint central.",
      "For rectangular or elliptical covers, choose which direction the center hinge runs.": "Pour les couvertures rectangulaires ou elliptiques, choisissez le sens du joint central.",
      "For rectangular, elliptical, or cut-corner covers, choose which direction the center hinge runs.": "Pour les couvertures rectangulaires, elliptiques ou à coins coupés, choisissez le sens du joint central.",
      "Fold A": "Pli A",
      "Fold B": "Pli B",
      "Cut A in half.": "Couper A en deux.",
      "Cut B in half.": "Couper B en deux.",
      "Roll orientation": "Sens d’enroulement",
      "Choose which way the cover rolls up. Either end of that direction works, so pick the one that clears your railing, wall, or steps.": "Choisissez le sens d’enroulement du couvercle de spa. Les deux bouts de ce sens conviennent : choisissez celui qui dégage votre rampe, votre mur ou vos marches.",
      "Roll direction": "Sens d’enroulement",
      "Along": "Sur",
      "Roll A": "Enroulement A",
      "Roll B": "Enroulement B",
      "Rolls along A.": "S’enroule dans le sens de A.",
      "Rolls along B.": "S’enroule dans le sens de B.",
      "Rounded square / rectangle": "Carré arrondi / rectangle",
      "Rounded Square / Rectangle": "Carré arrondi / rectangle",
      "Square / rectangle": "Carré / rectangle",
      "Square / Rectangle": "Carré / rectangle",
      "Square": "Carré",
      "Circle / round": "Cercle / rond",
      "Circle / Round": "Cercle / rond",
      "Round": "Rond",
      "Bowed Sides / Elliptical": "Côtés arqués / elliptique",
      "Octagon": "Octogone",
      "Four Cut Corners": "Quatre coins coupés",
      "One Cut Corner / Rounded Corners": "Un coin coupé / coins arrondis",
      "Two Cut Corners / Rounded Corners": "Deux coins coupés / coins arrondis",
      "Custom Shape": "Forme personnalisée",
      "Select corner radius": "Sélectionnez le rayon d’angle",
      "I measured my corner radius.": "J’ai mesuré mon rayon d’angle.",
      "I need help measuring my corner radius.": "J’ai besoin d’aide pour mesurer mon rayon d’angle.",
      "Good to proceed. You can complete the order and a staff member will contact you for assistance.": "Vous pouvez continuer. Vous pouvez terminer la commande et un membre de notre équipe vous contactera pour vous aider.",
      "Staff member will contact you for assistance.": "Un membre de notre équipe vous contactera pour vous aider.",
      "Corner radius": "Rayon d’angle",
      "Example: 8": "Exemple : 8",
      "Select material and color": "Sélectionnez le matériau et la couleur",
      "Upgrade to AquaTEX for a 3x stronger, 25% lighter spa cover.": "Passez à AquaTEX pour une couverture de spa 3 fois plus résistante et 25 % plus légère.",
      "Upgrade to AquaTEX™ for a 3x stronger, 25% lighter spa cover.": "Passez à AquaTEX™ pour une couverture de spa 3 fois plus résistante et 25 % plus légère.",
      "Black Vinyl": "Vinyle noir",
      "Charcoal Vinyl": "Vinyle charbon",
      "Grey Vinyl": "Vinyle gris",
      "Brown Vinyl": "Vinyle brun",
      "AquaTEX Charcoal": "AquaTEX charbon",
      "AquaTEX Grey": "AquaTEX gris",
      "Black AquaTEX™": "AquaTEX™ noir",
      "Brown AquaTEX™": "AquaTEX™ brun",
      "Grey AquaTEX™": "AquaTEX™ gris",
      "Chestnut Brown Vinyl": "Vinyle brun châtaigne",
      "Charcoal Grey Vinyl": "Vinyle gris charbon",
      "Select skirt length": "Sélectionnez la longueur de la jupe",
      "We recommend a skirt of 5 in. or longer for most hot tubs. Match your existing cover when possible; some models require 6 in.": "Nous recommandons une jupe de 5 po ou plus pour la plupart des spas. Dans la mesure du possible, choisissez la même longueur que sur votre couverture actuelle; certains modèles nécessitent une jupe de 6 po.",
      "No skirt": "Sans jupe",
      "Strap placement": "Emplacement des sangles",
      "Handle sides": "Côtés des poignées",
      "Hinge sides": "Côtés du joint",
      "Corners": "Coins",
      "One per side": "Une par côté",
      "Cover upgrades": "Améliorations de couverture",
      "Fully Insulated Hinge": "Joint entièrement isolé",
      "Insulates the hinge with heat-sealed foam to prevent heat loss.": "Isole le joint avec une mousse thermoscellée pour prévenir la perte de chaleur.",
      "Upgraded Vapor Barrier": "Barrière pare-vapeur améliorée",
      "Upgraded Vapor Barrier (2x Thickness)": "Barrière pare-vapeur améliorée (épaisseur 2x)",
      "Blocks water from penetrating into the foam cores by doubling the protective layer.": "Empêche l’eau de pénétrer dans les noyaux de mousse en doublant la couche protectrice.",
      "2 Lbs Foam Density": "Mousse de densité 2 lb",
      "Higher weight resistance and stronger insulation.": "Résistance au poids accrue et meilleure isolation.",
      "Reinforced Hinge": "Joint renforcé",
      "Extra durability for covers using lifters.": "Durabilité accrue pour les couvertures avec levier de couvercle de spa.",
      "Bundle with accessories": "Ajouter des accessoires",
      "ThermoFloat Spa Blanket": "Couverture de spa ThermoFloat",
      "Insulating solar blanket that helps reduce heat loss and condensation.": "Couverture solaire isolante qui aide à réduire la perte de chaleur et la condensation.",
      "Basic Cover Protector": "Protecteur de couverture de base",
      "Lightweight weather cover for UV, rain, snow, dust, and debris protection.": "Protection légère contre les UV, la pluie, la neige, la poussière et les débris.",
      "AquaTEX™ Cover Protector": "Protecteur de couverture AquaTEX™",
      "Heavy-duty cover protector made with AquaTEX™ fabric.": "Protecteur robuste fabriqué avec du tissu AquaTEX™.",
      "Hydraulic Cover Lifter": "Levier hydraulique de couvercle de spa",
      "Assisted lifting for easier cover opening and storage.": "Levage assisté pour ouvrir et ranger la couverture plus facilement.",
      "Hydraulic Cradle Lifter": "Levier hydraulique à berceau pour couvercle de spa",
      "Floor-mounted cradle lifter that helps open, store, and close the cover with less effort.": "Levier à berceau monté au sol qui aide à ouvrir, ranger et fermer la couverture avec moins d'effort.",
      "LiftAble Hydraulic Lifter": "Levier hydraulique LiftAble de couvercle de spa",
      "Top and undermount-compatible lifter for premium installations.": "Levier de couvercle de spa compatible avec montage supérieur et sous-montage pour les installations haut de gamme.",
      "Select lifter plates": "Sélectionnez les plaques pour levier de couvercle de spa",
      "Lifter Plates": "Plaques pour levier de couvercle de spa",
      "Hot Spring and Caldera brand hot tubs often use proprietary lifters that need specific metal plates. Plates will be installed based on your selection.": "Les spas Hot Spring et Caldera utilisent souvent des leviers propriétaires qui nécessitent des plaques métalliques spécifiques. Les plaques seront installées selon votre sélection.",
      "No Lifter Plates Needed": "Aucune plaque pour levier de couvercle de spa requise",
      "No metal plates are needed. The lifter is not attached directly to the cover.": "Aucune plaque métallique n'est nécessaire. Le levier n'est pas fixé directement à la couverture.",
      "Hot Spring / Caldera Standard Lifter Plates": "Plaques pour levier standard Hot Spring / Caldera",
      "Requires metal plates installed in the sides and rear of the cover.": "Nécessite des plaques métalliques installées sur les côtés et à l'arrière de la couverture.",
      "Hot Spring / Caldera Uprite Lifter Plates": "Plaques pour levier Uprite Hot Spring / Caldera",
      "Requires metal plates installed in the sides of the cover.": "Nécessite des plaques métalliques installées sur les côtés de la couverture.",
      "Dimension A / length (in.)": "Dimension A / longueur (po)",
      "Dimension B / width (in.)": "Dimension B / largeur (po)",
      "Dimension C / corner radius (in.)": "Dimension C / rayon d’angle (po)",
      "Dimension D (in.)": "Dimension D (po)",
      "Diameter A (in.)": "Diamètre A (po)",
      "Dimension C / cut corner (in.)": "Dimension C / coin coupé (po)",
      "Dimension D / cut depth (in.)": "Dimension D / profondeur de coupe (po)",
      "Dimension C (in.)": "Dimension C (po)",
      "Dimension A / length (in.) — always the longest side": "Dimension A / longueur (po) — toujours le côté le plus long",
      "Dimension A / across (in.) — always the longest": "Dimension A / d’un bord à l’autre (po) — toujours la plus longue",
      "Dimension B / side (in.)": "Dimension B / côté (po)",
      "Dimension C / widest point (in.)": "Dimension C / point le plus large (po)",
      "Dimension D / corner radius (in.) — leave blank if the other corners are square": "Dimension D / rayon d’angle (po) — laisser vide si les autres coins sont carrés",
      "Four cut corners": "Quatre coins coupés",
      "One cut corner": "Un coin coupé",
      "Two cut corners": "Deux coins coupés",
      "Custom / other": "Personnalisée / autre",
      "cut": "coupe",
      "radius": "rayon",
      "Tri-Fold": "Pliage en trois",
      "Bi-Fold": "Pliage en deux",
      "With Raised Waterfall": "Avec cascade surélevée",
      "Without Raised Waterfall": "Sans cascade surélevée",
      "Cover Thickness": "Épaisseur de la couverture",
      "Cover Shape": "Forme de la couverture",
      "Cover Length A": "Longueur A de la couverture",
      "Cover Width B": "Largeur B de la couverture",
      "Cover Dimension C": "Dimension C de la couverture",
      "Corner Radius": "Rayon d’angle",
      "Speaker Pocket Count": "Nombre de pochettes pour haut-parleurs",
      "Material & Color": "Matériau et couleur",
      "Skirt Length": "Longueur de jupe",
      "Fold Orientation": "Orientation du pli",
      "Cover Upgrades": "Améliorations de couverture",
      "Bundle Accessories": "Accessoires groupés",
      "Custom Hot Tub Covers": "Couvertures de spa sur mesure",
      "Length A": "Longueur A",
      "Width B": "Largeur B",
      "Radius": "Rayon"
    }
  };

  var defaultFields = [
    {
      id: "cover_thickness",
      title: { en: "Select cover thickness", fr: "Selectionnez l'epaisseur" },
      type: "cards",
      property: "Cover Thickness",
      required: true,
      options: [
        { id: "classic", label: "Classic", value: "Classic (4 in. - 2 in.)", description: "4 in. - 2 in.", key: "thickness:classic" },
        { id: "premium", label: "Premium", value: "Premium (5 in. - 3 in.)", description: "5 in. - 3 in.", key: "thickness:premium", priceCents: 7999 },
        { id: "extreme", label: "Extreme", value: "Extreme (6 in. - 4 in.)", description: "6 in. - 4 in.", key: "thickness:extreme", priceCents: 14999 }
      ]
    },
    {
      id: "cover_shape",
      title: "Select cover shape",
      type: "shapes",
      property: "Cover Shape",
      required: true,
      options: [
        { id: "rounded-square", label: "Rounded square / rectangle", value: "Rounded square / rectangle", selected: true },
        { id: "square", label: "Square", value: "Square" },
        { id: "round", label: "Circle / round", value: "Circle / round" },
        { id: "four-cut", label: "Four cut corners", value: "Four Cut Corners" },
        { id: "one-cut", label: "One cut corner", value: "One Cut Corner / Rounded Corners" },
        { id: "two-cut", label: "Two cut corners", value: "Two Cut Corners / Rounded Corners" },
        { id: "octagon", label: "Octagon", value: "Octagon" },
        { id: "custom-shape", label: "Custom / other", value: "Custom Shape" }
      ]
    },
    {
      id: "cover_size",
      title: "Select cover size",
      type: "number_pair",
      required: true,
      hint: "Available up to 96 x 96 in. For larger covers, please contact us or call +1 866-515-6446.",
      inputs: [
        { id: "length_a", label: "Length A (in.)", property: "Cover Length A", min: 36, max: HOT_TUB_COVER_MAX_SIZE_INCHES, step: 0.5 },
        { id: "width_b", label: "Width B (in.)", property: "Cover Width B", min: 36, max: HOT_TUB_COVER_MAX_SIZE_INCHES, step: 0.5 }
      ]
    },
    {
      id: "fold_orientation",
      title: "Fold orientation",
      type: "pills",
      property: "Fold Orientation",
      required: true,
      hint: "For rectangular covers, choose which direction the center hinge runs.",
      visibleWhen: {
        field: "cover_shape",
        in: ["Rounded Square / Rectangle", "Square / Rectangle", "Rounded square / rectangle", "Square"]
      },
      options: [
        {
          id: "fold-across-width-b",
          label: "Fold A",
          value: "Fold A",
          key: "fold:across-width-b",
          selected: true
        },
        {
          id: "fold-across-length-a",
          label: "Fold B",
          value: "Fold B",
          key: "fold:across-length-a"
        }
      ]
    },
    {
      id: "corner_radius_mode",
      title: "Select corner radius",
      type: "choices",
      property: "Corner Radius Measurement",
      required: true,
      options: [
        { id: "measured", label: CORNER_RADIUS_MEASURED_VALUE, value: CORNER_RADIUS_MEASURED_VALUE, selected: true },
        { id: "need-help", label: CORNER_RADIUS_HELP_VALUE, value: CORNER_RADIUS_HELP_VALUE }
      ]
    },
    {
      id: "corner_radius",
      title: "Corner radius",
      type: "number",
      property: "Corner Radius",
      required: true,
      min: 0,
      max: 24,
      step: 0.5,
      placeholder: "Example: 8",
      visibleWhen: { field: "corner_radius_mode", notEquals: "I need help measuring my corner radius." }
    },
    {
      id: "material_color",
      title: "Select material and color",
      type: "swatches",
      property: "Material & Color",
      required: true,
      hint: "",
      options: [
        { id: "black-vinyl", label: "Black Vinyl", value: "Black Vinyl", key: "material:black-vinyl", swatch: "#171717", selected: true },
        { id: "charcoal-vinyl", label: "Charcoal Vinyl", value: "Charcoal Vinyl", key: "material:charcoal-vinyl", swatch: "#414750" },
        { id: "grey-vinyl", label: "Grey Vinyl", value: "Grey Vinyl", key: "material:grey-vinyl", swatch: "#7b8792" },
        { id: "brown-vinyl", label: "Brown Vinyl", value: "Brown Vinyl", key: "material:brown-vinyl", swatch: "#6f5645" },
        { id: "aquatex-charcoal", label: "AquaTEX Charcoal", value: "AquaTEX Charcoal", key: "material:aquatex-charcoal", swatch: "#28323a" },
        { id: "aquatex-grey", label: "AquaTEX Grey", value: "AquaTEX Grey", key: "material:aquatex-grey", swatch: "#98a4ad" }
      ]
    },
    {
      id: "skirt_length",
      title: "Select skirt length",
      type: "pills",
      property: "Skirt Length",
      required: true,
      hint: "We recommend a skirt of 5 in. or longer for most hot tubs. Match your existing cover when possible; some models require 6 in.",
      options: [
        { id: "none", label: "No skirt", value: "No Skirt", key: "skirt:none" },
        { id: "1", label: "1 in.", value: "1 in.", key: "skirt:1" },
        { id: "2", label: "2 in.", value: "2 in.", key: "skirt:2" },
        { id: "3", label: "3 in.", value: "3 in.", key: "skirt:3" },
        { id: "4", label: "4 in.", value: "4 in.", key: "skirt:4", priceCents: 1499 },
        { id: "5", label: "5 in.", value: "5 in.", key: "skirt:5", priceCents: 1999 },
        { id: "6", label: "6 in.", value: "6 in.", key: "skirt:6", priceCents: 2999 },
        { id: "7", label: "7 in.", value: "7 in.", key: "skirt:7", priceCents: 3499 }
      ]
    },
    {
      id: "strap_placement",
      title: "Strap placement",
      type: "pills",
      property: "Strap Placement",
      required: true,
      options: [
        { id: "handle-sides", label: "Handle sides", value: "Handle Sides", selected: true },
        { id: "hinge-sides", label: "Hinge sides", value: "Hinge Sides" },
        { id: "corners", label: "Corners", value: "Corners" },
        { id: "one-per-side", label: "One per side", value: "One Strap Per Side" }
      ]
    },
    {
      id: "cover_upgrades",
      title: "Cover upgrades",
      type: "addons",
      options: [
        { id: "fully-insulated-hinge", label: "Fully Insulated Hinge", badge: "Recommended", description: "Insulates the hinge with heat-sealed foam to prevent heat loss.", value: "Fully Insulated Hinge", listName: "Cover Upgrades", key: "upgrade:fully-insulated-hinge", priceCents: 3999 },
        { id: "vapor-barrier-2x", label: "Upgraded Vapor Barrier (2x Thickness)", badge: "Recommended", description: "Blocks water from penetrating into the foam cores by doubling the protective layer.", value: "Upgraded Vapor Barrier (2x Thickness)", listName: "Cover Upgrades", key: "upgrade:vapor-barrier-2x", priceCents: 3999 },
        { id: "foam-density-2lb", label: "2 Lbs Foam Density", description: "Higher weight resistance and stronger insulation.", value: "2 Lbs Foam Density", listName: "Cover Upgrades", key: "upgrade:2lb-foam-density", priceCents: 9999 },
        { id: "reinforced-hinge", label: "Reinforced Hinge", description: "Extra durability for covers using lifters.", value: "Reinforced Hinge", listName: "Cover Upgrades", key: "upgrade:reinforced-hinge", priceCents: 5999 }
      ]
    },
    {
      id: "accessories",
      title: "Bundle with accessories",
      type: "addons",
      options: [
        { id: "thermofloat-spa-blanket", label: "ThermoFloat Spa Blanket", description: "Helps insulate your spa and reduce condensation.", value: "ThermoFloat Spa Blanket", listName: "Bundle Accessories", key: "accessory:thermofloat-spa-blanket", priceCents: 7999 },
        { id: "basic-cover-protector", label: "Basic Cover Protector", description: "Reflective lightweight cover protection.", value: "Basic Cover Protector", listName: "Bundle Accessories", key: "accessory:basic-cover-protector", priceCents: 7999 },
        { id: "aquatex-cover-protector", label: "AquaTEX Cover Protector", description: "Heavy-duty all-season AquaTEX protection.", value: "AquaTEX Cover Protector", listName: "Bundle Accessories", key: "accessory:aquatex-cover-protector", priceCents: 11999 },
        { id: "hydraulic-cradle-lifter", label: "Hydraulic Cradle Lifter", description: "Floor-mounted cradle lifter that helps open, store, and close the cover with less effort.", value: "Hydraulic Cradle Lifter", listName: "Bundle Accessories", key: "accessory:hydraulic-cradle-lifter", priceCents: 24999, variantId: "49313435418921", addonProductHandle: "hot-tub-cover-cradle-hydraulic-lifter" },
        { id: "liftable-hydraulic-lifter", label: "LiftAble Hydraulic Lifter", description: "Assisted lifting for easier cover handling.", value: "LiftAble Hydraulic Lifter", listName: "Bundle Accessories", key: "accessory:liftable-hydraulic-lifter", priceCents: 32999 },
        { id: "liftable-undermount-lifter", label: "LiftAble Undermount Lifter", description: "Undermount support when side mounting is not ideal.", value: "LiftAble Undermount Lifter", listName: "Bundle Accessories", key: "accessory:liftable-undermount-lifter", priceCents: 32999 }
      ]
    }
  ];

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  function initAll() {
    setupMobileHeaderOrder();
    document.querySelectorAll("[data-cover-builder-extension]").forEach(init);
  }

  // On mobile, lift the product title + rating above the media block (so the
  // product name and social proof read first, like Covers & All). They go into a
  // tight `.smcbx-mobile-header` wrapper so they sit close together, while the
  // container's 20px flex gap still separates the pair from the media. Desktop
  // restores them to the right-hand column (comment placeholders mark home).
  function setupMobileHeaderOrder() {
    var main = document.querySelector(".s-main-product--builder-integrated");
    if (!main) return;
    var medias = main.querySelector(".s-main-product__medias");
    var content = main.querySelector(".s-main-product__content");
    if (!medias || !content || medias.parentNode !== main) return;
    // Title first, then the rating (the Covers & All order the owner referenced).
    var movers = [content.querySelector(".s-main-product__title"), content.querySelector(".customizer-details-reviews")]
      .filter(Boolean)
      .map(function (el) {
        var ph = document.createComment("smcbx-header-home");
        el.parentNode.insertBefore(ph, el);
        return { el: el, ph: ph };
      });
    if (!movers.length) return;
    var wrap = document.createElement("div");
    wrap.className = "smcbx-mobile-header";
    var mq = window.matchMedia("(max-width: 767px)");
    function apply() {
      if (mq.matches) {
        movers.forEach(function (m) { wrap.appendChild(m.el); });
        if (wrap.parentNode !== main) main.insertBefore(wrap, medias);
      } else {
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        movers.forEach(function (m) { if (m.ph.parentNode) m.ph.parentNode.insertBefore(m.el, m.ph); });
      }
    }
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else if (mq.addListener) mq.addListener(apply);
  }

  function init(root) {
    if (document.body) document.body.classList.add("smcbx-page");
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    var groups = normalizeGroupsPayload(readJson(root, "[data-builder-groups]", []));
    if (groups.length === 0 && root.dataset.groupsJsonUrl) {
      fetch(root.dataset.groupsJsonUrl, { credentials: "same-origin" })
        .then(function (response) {
          if (!response.ok) throw new Error("Unable to load builder options.");
          return response.json();
        })
        .then(function (payload) {
          renderFromGroups(root, normalizeGroupsPayload(payload));
        })
        .catch(function () {
          renderFromGroups(root, groups);
        });
      return;
    }

    renderFromGroups(root, groups);
  }

  function renderFromGroups(root, groups) {
    var group = applyBuilderMode(root, selectGroup(root, groups));
    if (!group) {
      root.hidden = true;
      return;
    }

    hydrateVariantPrices(root, group, groups)
      .then(function (hydratedGroup) {
        renderBuilder(root, hydratedGroup, Array.isArray(groups) ? groups : []);
      })
      .catch(function () {
        renderBuilder(root, group, Array.isArray(groups) ? groups : []);
      });
  }

  function hydrateVariantPrices(root, group, groups) {
    // Include automatic size fees in the same market-price lookup as options.
    attachOversizedFeePricing(root, group);
    var fields = builderFieldsForGroup(root, group, Array.isArray(group.fields) && group.fields.length > 0 ? group.fields : defaultFields, groups);
    var handles = collectAddonProductHandles(fields, group);
    if (handles.length === 0) return Promise.resolve(Object.assign({}, group, { _smcbxPreparedFields: fields }));

    return Promise.all(handles.map(function (handle) {
      return fetchAddonProduct(root, handle).catch(function () {
        return null;
      });
    })).then(function (products) {
      var priceByVariantId = {};
      var compareAtPriceByVariantId = {};
      products.forEach(function (product) {
        if (!product || !Array.isArray(product.variants)) return;
        product.variants.forEach(function (variant) {
          var id = String(variant.id);
          priceByVariantId[id] = parseInt(variant.price || 0, 10) || 0;
          compareAtPriceByVariantId[id] = parseInt(variant.compare_at_price || 0, 10) || 0;
        });
      });

      fields.forEach(function (field) {
        (field.options || []).forEach(function (option) {
          var variantId = option.variantId ? String(option.variantId) : "";
          if (!variantId || priceByVariantId[variantId] === undefined) return;
          option.priceCents = priceByVariantId[variantId];
          option.compareAtPriceCents = compareAtPriceByVariantId[variantId] || 0;
        });
      });
      sizePricingVariants(group).forEach(function (variant) {
        var variantId = variant.variantId ? String(variant.variantId) : "";
        if (!variantId || priceByVariantId[variantId] === undefined) return;
        variant.priceCents = priceByVariantId[variantId];
        variant.compareAtPriceCents = compareAtPriceByVariantId[variantId] || 0;
      });

      return Object.assign({}, group, { _smcbxPreparedFields: fields });
    });
  }

  function collectAddonProductHandles(fields, group) {
    var handles = {};
    fields.forEach(function (field) {
      (field.options || []).forEach(function (option) {
        var handle = option.addonProductHandle || option.productHandle || "";
        if (handle && option.variantId) handles[handle] = true;
      });
    });
    var sizePricing = group && group.sizePricing || {};
    sizePricingVariants(group).forEach(function (variant) {
      var handle = variant.addonProductHandle || variant.productHandle || sizePricing.addonProductHandle || sizePricing.productHandle || "";
      if (handle && variant.variantId) handles[handle] = true;
    });
    return Object.keys(handles);
  }

  function sizePricingVariants(group) {
    return group && group.sizePricing && Array.isArray(group.sizePricing.variants) ? group.sizePricing.variants : [];
  }

  function fetchAddonProduct(root, handle) {
    var url = localizedProductJsonUrl(root, handle);
    if (!productJsonCache[url]) {
      productJsonCache[url] = fetch(url, { credentials: "same-origin" }).then(function (response) {
        if (!response.ok) throw new Error("Unable to load add-on product.");
        return response.json();
      });
    }
    return productJsonCache[url];
  }

  function localizedProductJsonUrl(root, handle) {
    var locale = normalizeToken(root.dataset.locale || "");
    var path = window.location && window.location.pathname ? window.location.pathname : "/";
    var match = path.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\//i);
    var prefix = match ? "/" + match[1] : "";

    if (!prefix && locale && locale.indexOf("-") > 0) {
      prefix = "/" + locale;
    }

    return prefix + "/products/" + encodeURIComponent(handle) + ".js";
  }

  function normalizeGroupsPayload(payload) {
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.groups)) return payload.groups;
    return [];
  }

  function selectGroup(root, groups) {
    var normalized = Array.isArray(groups) ? groups : [];
    var targetMatched = root.dataset.targetMatched === "true";
    var allowUntargeted = root.dataset.showWhenUntargeted === "true";
    if (normalized.length === 0 && (root.dataset.designMode === "true" || targetMatched || allowUntargeted)) {
      normalized = [{
        id: "hot-tub-covers",
        name: "Hot Tub Covers",
        enabled: true,
        products: [],
        collections: [],
        markets: [],
        locales: [],
        fields: defaultFields
      }];
    }

    var productId = root.dataset.productId || "";
    var collectionIds = root.dataset.productCollectionIds || "";
    var marketValues = [
      root.dataset.marketHandle || "",
      root.dataset.marketId || "",
      root.dataset.country || ""
    ].map(normalizeToken);
    var locale = normalizeToken(root.dataset.locale || "");
    var localeBase = locale.split("-")[0];
    var productHandle = normalizeToken(root.dataset.productHandle || "");
    var modelGroupId = modelGroupIdForRoot(root);
    if (requiresModelGroupRouting(root) && !modelGroupId) return null;

    var matchedGroup = normalized.find(function (group) {
      if (!group || group.enabled === false) return false;
      if (modelGroupId && group.id !== modelGroupId) return false;

      var productMatch = (group.products || []).some(function (product) {
        var handle = normalizeToken(product.handle || "");
        return String(product.id) === productId ||
          String(product.numericId) === productId ||
          Boolean(handle && handle === productHandle);
      });
      var collectionMatch = (group.collections || []).some(function (collection) {
        return collectionIds.indexOf("|" + collection.numericId + "|") !== -1 ||
          collectionIds.indexOf("|" + collection.id + "|") !== -1;
      });
      var hasTargets = (group.products || []).length > 0 || (group.collections || []).length > 0;
      if (hasTargets && !productMatch && !collectionMatch) return false;

      var groupMarkets = (group.markets || []).map(normalizeToken).filter(Boolean);
      if (groupMarkets.length > 0 && !groupMarkets.some(function (market) {
        return marketValues.indexOf(market) !== -1;
      })) {
        return false;
      }

      var groupLocales = (group.locales || []).map(normalizeToken).filter(Boolean);
      if (groupLocales.length > 0 && groupLocales.indexOf(locale) === -1 && groupLocales.indexOf(localeBase) === -1) {
        return false;
      }

      return true;
    });

    if (matchedGroup) return matchedGroup;

    if (modelGroupId) {
      return normalized.find(function (group) {
        return group && group.enabled !== false && group.id === modelGroupId;
      }) || null;
    }

    if (targetMatched || allowUntargeted || root.dataset.designMode === "true") {
      return normalized.find(function (group) {
        return group && group.enabled !== false;
      }) || null;
    }

    return null;
  }

  function applyBuilderMode(root, group) {
    if (!group) return group;
    var mode = builderModeForRoot(root);
    if (mode !== "model" && mode !== "model_nopreview" && mode !== "specialized") return group;
    var selectedVariantId = String(root.dataset.variantId || "");
    // Only pre-select a size when the shopper has no real choice (a single variant)
    // or when they deep-linked to a specific variant (?variant=123). On a multi-size
    // model we leave every size unselected so the shopper must actively pick the one
    // that matches their spa — guessing the size risks shipping an undersized cover.
    var rawSpecs = modelVariantSpecs(root);
    var singleVariant = rawSpecs.length === 1;
    var variantExplicit = String(root.dataset.variantExplicitlySelected || "") === "true";
    var specs = rawSpecs.map(function (spec) {
      var isSelected = singleVariant
        || (variantExplicit && selectedVariantId && String(spec.variantId) === selectedVariantId);
      return Object.assign({}, spec, { selected: isSelected });
    });

    return Object.assign({}, group, {
      builderMode: mode,
      productTitle: root.dataset.productTitle || "",
      productHandle: root.dataset.productHandle || "",
      modelVariantSpecs: specs
    });
  }

  function builderModeForRoot(root) {
    return normalizeToken(root && root.dataset ? root.dataset.builderMode || "" : "").replace(/[\s-]+/g, "_");
  }

  function modelGroupIdForRoot(root) {
    if (!requiresModelGroupRouting(root)) return "";
    var spaType = normalizeToken(root && root.dataset ? root.dataset.spaType || "" : "").replace(/[_-]+/g, " ").replace(/\s+/g, " ");
    if (spaType === "swim spa") return "swim-spa-covers";
    if (spaType === "hot tub") return "hot-tub-covers";
    return "";
  }

  function requiresModelGroupRouting(root) {
    var mode = builderModeForRoot(root);
    return mode === "model" || mode === "model_nopreview" || mode === "specialized";
  }

  function isModelBuilderGroup(group) {
    return group && group.builderMode === "model";
  }

  function isModelNoPreviewBuilderGroup(group) {
    return group && group.builderMode === "model_nopreview";
  }

  function isModelLikeBuilderGroup(group) {
    return isModelBuilderGroup(group) || isModelNoPreviewBuilderGroup(group);
  }

  function isSpecializedBuilderGroup(group) {
    return group && group.builderMode === "specialized";
  }

  function isFixedSpecBuilderGroup(group) {
    return isModelLikeBuilderGroup(group) || isSpecializedBuilderGroup(group);
  }

  function showsHotTubModelEntry(group) {
    return group && group.id === "hot-tub-covers" && !isFixedSpecBuilderGroup(group);
  }

  function hasLiveBuilderPreview(group) {
    return !isSpecializedBuilderGroup(group) && !isModelNoPreviewBuilderGroup(group);
  }

  function modelVariantSpecs(root) {
    if (root._smcbxModelVariantSpecs) return root._smcbxModelVariantSpecs;
    var specs = normalizeModelVariantSpecs(readJson(root, "[data-model-variant-specs]", []));
    root._smcbxModelVariantSpecs = specs;
    return specs;
  }

  function normalizeModelVariantSpecs(payload) {
    var specs = (Array.isArray(payload) ? payload : []).map(function (item) {
      var spec = item && typeof item === "object" ? item : {};
      var title = modelSpecValue(spec.title);
      var parsed = parseModelSpecFromText(title);
      var length = modelSpecValue(spec.length || spec.lengthA || spec.measurementA || spec.measurement_a || spec.cover_measurement_a || spec.cover_length_a_in);
      var width = modelSpecValue(spec.width || spec.widthB || spec.measurementB || spec.measurement_b || spec.cover_measurement_b || spec.cover_width_b_in);
      var radius = modelSpecValue(spec.radius || spec.radiusC || spec.measurementC || spec.measurement_c || spec.cover_measurement_c || spec.cover_radius_c_in);
      var dimensionD = modelSpecValue(spec.dimensionD || spec.measurementD || spec.measurement_d || spec.cover_measurement_d);
      var shape = modelSpecValue(spec.shape || spec.cover_shape);
      var modelLabel = modelSpecValue(spec.modelLabel || spec.model_label || spec.cover_model_label);
      var yearRange = modelSpecValue(spec.yearRange || spec.year_range || spec.cover_year_range);
      var variantQualifier = modelSpecValue(spec.variantQualifier || spec.variant_qualifier || spec.cover_variant_qualifier);
      var speakerPocketCount = modelSpecValue(spec.speakerPocketCount || spec.speaker_pocket_count || spec.cover_speaker_pocket_count);
      if (speakerPocketCount === "0") speakerPocketCount = "";
      length = length || parsed.length;
      width = width || parsed.width;
      radius = radius || parsed.radius;
      shape = shape || parsed.shape;
      var structuredMeasurement = modelSpecMeasurementSummary(length, width, radius, "en", shape, dimensionD);
      var label = modelSpecSizeLabel(spec.title, length, width, radius, shape, dimensionD, yearRange, modelLabel, variantQualifier, "en");

      return {
        variantId: modelSpecValue(spec.id || spec.variantId || spec.variant_id),
        title: title,
        label: label,
        labelFromTitle: !structuredMeasurement && Boolean(title && title.toLowerCase() !== "default title"),
        available: spec.available !== false,
        priceCents: parseInt(spec.priceCents || spec.price_cents || 0, 10) || 0,
        compareAtPriceCents: parseInt(spec.compareAtPriceCents || spec.compare_at_price_cents || 0, 10) || 0,
        length: length,
        width: width,
        radius: radius,
        dimensionD: dimensionD,
        shape: shape,
        modelLabel: modelLabel,
        yearRange: yearRange,
        variantQualifier: variantQualifier,
        specSource: modelSpecValue(spec.specSource || spec.spec_source),
        speakerPocketCount: speakerPocketCount
      };
    }).filter(function (spec) {
      return spec.variantId;
    });

    var labelCounts = Object.create(null);
    specs.forEach(function (spec) {
      var token = normalizeToken(spec.label);
      labelCounts[token] = (labelCounts[token] || 0) + 1;
    });

    return specs.map(function (spec) {
      var token = normalizeToken(spec.label);
      var title = modelSpecValue(spec.title);
      if (labelCounts[token] > 1 && title && title.toLowerCase() !== "default title") {
        return Object.assign({}, spec, { label: title, labelFromTitle: true });
      }
      return spec;
    });
  }

  function parseModelSpecFromText(value) {
    var text = String(value || "");
    var dimensions = text.match(/(\d+(?:\.\d+)?)\s*(?:"|in(?:ch(?:es)?)?\.?)?\s*(?:x|×|by)\s*(\d+(?:\.\d+)?)/i);
    var diameter = text.match(/(\d+(?:\.\d+)?)\s*(?:"|in(?:ch(?:es)?)?\.?)?\s*(?:diameter|round|circle)/i);
    var radius = text.match(/(\d+(?:\.\d+)?)\s*(?:"|in(?:ch(?:es)?)?\.?)?\s*(?:radius|corner radius|radius corners)/i);
    var shape = "";
    if (/circle|round\b|diameter/i.test(text) && !/rounded/i.test(text)) {
      shape = "Round";
    } else if (/bowed|elliptic|elliptical/i.test(text)) {
      shape = "Bowed Sides / Elliptical";
    } else if (/square|rectangle|radius|rounded/i.test(text)) {
      shape = radius && parseFloat(radius[1]) > 0 ? "Rounded Square / Rectangle" : "";
    }

    return {
      length: dimensions ? dimensions[1] : diameter ? diameter[1] : "",
      width: dimensions ? dimensions[2] : "",
      radius: radius ? radius[1] : "",
      shape: shape
    };
  }

  function modelSpecValue(value) {
    if (value === undefined || value === null) return "";
    if (Array.isArray(value)) {
      for (var index = 0; index < value.length; index += 1) {
        var arrayValue = modelSpecValue(value[index]);
        if (arrayValue) return arrayValue;
      }
      return "";
    }
    if (value && typeof value === "object") {
      var preferredKeys = ["value", "amount", "number", "decimal", "integer", "name", "label", "text"];
      for (var preferredIndex = 0; preferredIndex < preferredKeys.length; preferredIndex += 1) {
        var preferredKey = preferredKeys[preferredIndex];
        if (value[preferredKey] !== undefined) {
          var preferredValue = modelSpecValue(value[preferredKey]);
          if (preferredValue) return preferredValue;
        }
      }

      var fallbackKeys = Object.keys(value).filter(function (key) {
        return ["unit", "units", "type", "namespace", "key"].indexOf(key) === -1;
      });
      for (var fallbackIndex = 0; fallbackIndex < fallbackKeys.length; fallbackIndex += 1) {
        var fallbackValue = value[fallbackKeys[fallbackIndex]];
        if (fallbackValue === undefined || fallbackValue === null || typeof fallbackValue === "object") continue;
        var normalizedFallback = modelSpecValue(fallbackValue);
        if (normalizedFallback) return normalizedFallback;
      }

      return "";
    }
    var text = String(value).trim();
    if (!text || text === "[object Object]" || /json not allowed for this object/i.test(text)) return "";
    var dimensionText = text.match(/^(-?\d+(?:\.\d+)?)\s*(?:"|in(?:ch(?:es)?)?\.?|po\.?)$/i);
    if (dimensionText) return dimensionText[1];
    return text;
  }

  function modelSpecSizeLabel(title, length, width, radius, shape, dimensionD, yearRange, modelLabel, variantQualifier, locale) {
    var size = modelSpecMeasurementSummary(length, width, radius, locale || "en", shape, dimensionD);
    var qualifier = modelSpecQualifierSummary(yearRange, modelLabel, variantQualifier, locale || "en");
    if (size) return size + (qualifier ? " / " + qualifier : "");

    var text = modelSpecValue(title);
    if (text && text.toLowerCase() !== "default title") return text;
    return qualifier || "One size";
  }

  function modelSpecQualifierSummary(yearRange, modelLabel, variantQualifier, locale) {
    var values = [modelSpecValue(variantQualifier), modelSpecValue(modelLabel), modelSpecValue(yearRange)].filter(Boolean).map(function (value) {
      return localize(value, locale);
    });
    return values.filter(function (value, index) {
      var token = normalizeToken(value);
      return values.findIndex(function (candidate) { return normalizeToken(candidate) === token; }) === index;
    }).join(" / ");
  }

  function modelSpecMeasurementSummary(length, width, radius, locale, shape, dimensionD) {
    var a = modelSpecValue(length);
    var b = modelSpecValue(width);
    var c = modelSpecValue(radius);
    var d = modelSpecValue(dimensionD);
    var template = shape ? measurementTemplateFor(modelShapePropertyValue(shape)) : "";
    if (template === "diameter") {
      return a ? a + " in. diameter" : "";
    }
    if (!a || !b) return "";
    var base = a + " x " + b + " " + inchUnit(locale);
    if (template === "a_b_c_radius") return base + (c ? " / " + radiusInchesLabel(c, locale) : "");
    if (template === "a_b_c_d_cut") {
      return base +
        (d ? " / C " + localize("cut", locale) + ": " + inchesLabel(d, locale) : "") +
        (c ? " / D " + localize("radius", locale) + ": " + inchesLabel(c, locale) : "");
    }
    if (template === "a_b_c_cut") return base + (c ? " / C " + localize("cut", locale) + ": " + inchesLabel(c, locale) : "");
    if (template === "a_b_c") return base + (c ? " / C " + inchesLabel(c, locale) : "");
    return base;
  }

  function modelShapePropertyValue(value) {
    var raw = modelSpecValue(value);
    var text = normalizeToken(raw);
    if (!text) return "Rounded Square / Rectangle";
    if (text === "round") return "Round";
    if (text.indexOf("round") !== -1 && text.indexOf("rounded") === -1) return "Round";
    if (text.indexOf("circle") !== -1 || text.indexOf("diameter") !== -1) return "Round";
    if (text.indexOf("bowed") !== -1 || text.indexOf("ellipt") !== -1) return "Bowed Sides / Elliptical";
    if (text.indexOf("octagon") !== -1) return "Octagon";
    if ((text.indexOf("four") !== -1 || /\b4\b/.test(text)) && text.indexOf("cut") !== -1) return "Four Cut Corners";
    if ((text.indexOf("two") !== -1 || /\b2\b/.test(text)) && text.indexOf("cut") !== -1) return "Two Cut Corners / Rounded Corners";
    if ((text.indexOf("one") !== -1 || /\b1\b/.test(text)) && text.indexOf("cut") !== -1) return "One Cut Corner / Rounded Corners";
    if (text.indexOf("square") !== -1 && text.indexOf("rounded") === -1) return "Square / Rectangle";
    if (text.indexOf("rectangle") !== -1 && text.indexOf("rounded") === -1 && text.indexOf("radius") === -1) return "Square / Rectangle";
    if (text.indexOf("rounded") !== -1 || text.indexOf("radius") !== -1 || text.indexOf("rectangle") !== -1) return "Rounded Square / Rectangle";
    return raw;
  }

  // Keep Size → Fold → Strap consecutive (matching the measure flow): if Strap
  // sits after Fold but with other steps (material, skirt) wedged between, lift it
  // to immediately after Fold. No-op when either field is absent (e.g. rollaway).
  function moveStrapAfterFold(fields) {
    if (!Array.isArray(fields)) return fields;
    var foldField = null, strapField = null;
    fields.forEach(function (f) {
      if (!foldField && isFoldOrientationField(f)) foldField = f;
      if (!strapField && isStrapPlacementField(f)) strapField = f;
    });
    if (!foldField || !strapField) return fields;
    var out = fields.filter(function (f) { return f !== strapField; });
    out.splice(out.indexOf(foldField) + 1, 0, strapField);
    return out;
  }

  function builderFieldsForGroup(root, group, fields, groups) {
    var groupId = group && group.id;
    var scopedFields = isHotTubSizeCappedGroupId(groupId) ? withHotTubSizeCap(fields, groupId) : fields;
    if (isModelLikeBuilderGroup(group)) scopedFields = withModelBuilderFields(root, group, scopedFields);
    if (isSpecializedBuilderGroup(group)) scopedFields = withSpecializedBuilderFields(group, scopedFields, groups);
    if (showsHotTubModelEntry(group)) scopedFields = withCustomFoldDimensionFields(scopedFields);
    if (isModelLikeBuilderGroup(group) && (isHotTubSizeCappedGroupId(groupId) || isRegularSwimSpaGroupId(groupId))) {
      scopedFields = withRollawayCoverType(root, group, scopedFields, groups);
    }
    // Bowed covers are not launched. Keep their prepared measurement work off
    // the storefront, including options restored from older builder data.
    // LiftAble is supplied by HST in Canada only.
    // An option can name a different variant/image per shopper country in
    // `countryOverrides` (the Basic Cover Protector is grey from HST in Canada,
    // black from VEVOR in the US). Applying it here, before prices are hydrated,
    // keeps the shown price, the cart line and _Builder Addon Variant IDs on the
    // same variant.
    var country = String(root.dataset.country || "").toUpperCase();
    scopedFields = scopedFields.map(function (field) {
      if (!Array.isArray(field.options)) return field;
      return Object.assign({}, field, { options: field.options.filter(function (option) {
        var value = [option.id, option.label, option.value, option.key].join(" ");
        if (isShapeField(field) && (/bowed|elliptic/i.test(value) || option.measurementTemplate === "a_b_c")) return false;
        return country !== "US" || !/liftable/i.test(value);
      }).map(function (option) {
        return withCountryOverride(option, country);
      }) });
    });
    if (!isSwimSpaGroupId(groupId)) return moveStrapAfterFold(scopedFields);
    return (scopedFields || []).map(function (field) {
      if (isShapeField(field)) return null;
      if (isStrapPlacementField(field)) return null;
      if (isRegularSwimSpaGroupId(groupId) && isFoldOrientationField(field)) return null;
      return field;
    }).filter(Boolean);
  }

  function withCountryOverride(option, country) {
    var overrides = option && option.countryOverrides;
    var override = country && overrides && typeof overrides === "object" ? overrides[country] : null;
    if (!override || typeof override !== "object") return option;
    return Object.assign({}, option, override);
  }

  function withModelBuilderFields(root, group, fields) {
    var output = [];
    var insertedSizeSelector = false;
    var insertedLifterSystem = false;
    var includeLifterSystem = shouldShowModelLifterSystemField(root, group, fields);

    (fields || []).forEach(function (field) {
      if (isShapeField(field)) return;
      if (isSizeField(field) && !insertedSizeSelector) {
        output.push(modelSizeFieldForGroup(group));
        insertedSizeSelector = true;
        return;
      }
      if (isFoldOrientationField(field)) {
        output.push(withModelFoldOrientationField(field));
        return;
      }
      if (includeLifterSystem && !insertedLifterSystem && isCoverUpgradesField(field)) {
        output.push(modelLifterSystemField(root));
        insertedLifterSystem = true;
      }
      if (isRegularSwimSpaGroupId(group && group.id) && field && field.id === "skirt_length") {
        output.push(Object.assign({}, field, { hint: "Choose the skirt length that matches your existing cover." }));
        return;
      }
      output.push(field);
    });

    if (!insertedSizeSelector) output.push(modelSizeFieldForGroup(group));
    if (includeLifterSystem && !insertedLifterSystem) output.push(modelLifterSystemField(root));
    return output;
  }

  /**
   * A model page picks Rollaway as a cover type, so it never renders the
   * standalone rollaway builder's `rollaway_cover_shape` field — and a
   * visibleWhen pointing at a field that does not exist matches nothing and
   * silently hides the question. Retarget it at `cover_shape`, the same move
   * withModelFoldOrientationField makes, and keep the list to the shapes a
   * rolling cover is actually made in.
   */
  function withModelRollOrientationField(field) {
    if (!field) return null;
    var next = Object.assign({}, field);
    var condition = field.visibleWhen && typeof field.visibleWhen === "object" ? field.visibleWhen : {};
    var values = Array.isArray(condition.in) ? condition.in.slice() : [];
    [
      "Rounded Square / Rectangle",
      "Square / Rectangle",
      "Rounded square / rectangle",
      "Square"
    ].forEach(function (value) {
      if (values.indexOf(value) === -1) values.push(value);
    });
    next.visibleWhen = Object.assign({}, condition, {
      field: "cover_shape",
      in: values
    });
    return next;
  }

  function withModelFoldOrientationField(field) {
    var next = Object.assign({}, withFoldDimensionDescriptions(field), {
      hint: "For rectangular, elliptical, or cut-corner covers, choose which direction the center hinge runs.",
    });
    var condition = field && field.visibleWhen && typeof field.visibleWhen === "object" ? field.visibleWhen : {};
    var values = Array.isArray(condition.in) ? condition.in.slice() : [];
    [
      "Rounded Square / Rectangle",
      "Square / Rectangle",
      "Rounded square / rectangle",
      "Square",
      "Bowed Sides / Elliptical",
      "Bowed sides / elliptical",
      "Elliptical",
      "Octagon",
      "Four Cut Corners",
      "Two Cut Corners / Rounded Corners",
      "One Cut Corner / Rounded Corners"
    ].forEach(function (value) {
      if (values.indexOf(value) === -1) values.push(value);
    });
    next.visibleWhen = Object.assign({}, condition, {
      field: condition.field || "cover_shape",
      in: values
    });
    return next;
  }

  function withCustomFoldDimensionFields(fields) {
    return (fields || []).map(function (field) {
      return isFoldOrientationField(field) ? withFoldDimensionDescriptions(field) : field;
    });
  }

  function withFoldDimensionDescriptions(field) {
    return Object.assign({}, field, {
      showFoldDimensionDescriptions: true
    });
  }

  function shouldShowModelLifterSystemField(root, group, fields) {
    if ((fields || []).some(isLifterSystemField)) return false;
    var text = [
      root && root.dataset ? root.dataset.productTitle : "",
      root && root.dataset ? root.dataset.productHandle : "",
      group && group.productTitle,
      group && group.productHandle
    ].join(" ").toLowerCase();
    return text.indexOf("caldera") !== -1 ||
      text.indexOf("hot spring") !== -1 ||
      text.indexOf("hot-spring") !== -1 ||
      text.indexOf("hotspring") !== -1 ||
      text.indexOf("hot spot") !== -1 ||
      text.indexOf("hot-spot") !== -1;
  }

  function modelLifterSystemField(root) {
    return {
      id: "current_lifter_system",
      title: "Select lifter plates",
      type: "image_choices",
      property: "Lifter Plates",
      required: true,
      hint: "Hot Spring and Caldera brand hot tubs often use proprietary lifters that need specific metal plates. Plates will be installed based on your selection.",
      options: [
        {
          id: "no-lifter",
          label: "No Lifter Plates Needed",
          description: "No metal plates are needed. The lifter is not attached directly to the cover.",
          value: "No Lifter Plates Needed",
          key: "lifter-system:none",
          imageUrl: "https://spamigo.com/cdn/shop/files/image-swatches-7_1_1744838093843-1745862819.jpg",
          selected: true
        },
        {
          id: "hot-spring-caldera-standard-lifter",
          label: "Hot Spring / Caldera Standard Lifter Plates",
          description: "Requires metal plates installed in the sides and rear of the cover.",
          value: "Hot Spring / Caldera Standard Lifter Plates",
          key: "upgrade:metal-lifter-plates-standard",
          imageUrl: "https://cdn.shopify.com/s/files/1/0865/5916/2665/files/cover-upgrades-407075.webp?v=1745926068",
          priceCents: 8999,
          variantId: "49199610233129",
          addonProductHandle: "option-set-590744-checkbox-1"
        },
        {
          id: "hot-spring-caldera-uprite-lifter",
          label: "Hot Spring / Caldera Uprite Lifter Plates",
          description: "Requires metal plates installed in the sides of the cover.",
          value: "Hot Spring / Caldera Uprite Lifter Plates",
          key: "upgrade:metal-lifter-plates-uprite",
          imageUrl: "https://cdn.shopify.com/s/files/1/0865/5916/2665/files/cover-upgrades-713502.webp?v=1745926068",
          priceCents: 8999,
          variantId: "50266473857321",
          addonProductHandle: "option-set-590744-checkbox-1"
        }
      ]
    };
  }

  function withSpecializedBuilderFields(group, fields, groups) {
    var currentFields = Array.isArray(fields) ? fields : [];
    var standardFields = standardHotTubBuilderFields(groups);

    return [
      modelSizeFieldForGroup(group),
      specializedField(currentFields, standardFields, "material_color"),
      specializedMergedAddonField(currentFields, standardFields, "cover_upgrades"),
      specializedMergedAddonField(currentFields, standardFields, "accessories")
    ].filter(Boolean);
  }

  function standardHotTubBuilderFields(groups) {
    var standardGroup = (Array.isArray(groups) ? groups : []).find(function (group) {
      return group && group.id === "hot-tub-covers";
    });
    return Array.isArray(standardGroup && standardGroup.fields) && standardGroup.fields.length > 0
      ? standardGroup.fields
      : defaultFields;
  }

  function specializedField(currentFields, standardFields, id) {
    return cloneBuilderField(findBuilderField(currentFields, id) || findBuilderField(standardFields, id));
  }

  function specializedMergedAddonField(currentFields, standardFields, id) {
    var current = findBuilderField(currentFields, id);
    var standard = findBuilderField(standardFields, id);
    var base = cloneBuilderField(current || standard);
    if (!base) return null;
    base.options = mergeBuilderOptions(standard && standard.options, current && current.options);
    return base;
  }

  function findBuilderField(fields, id) {
    return (fields || []).find(function (field) {
      return String(field && field.id || "") === id;
    }) || null;
  }

  function cloneBuilderField(field) {
    if (!field) return null;
    return Object.assign({}, field, {
      options: Array.isArray(field.options) ? field.options.map(function (option) {
        return Object.assign({}, option);
      }) : []
    });
  }

  function mergeBuilderOptions(standardOptions, currentOptions) {
    var output = [];
    var indexByKey = Object.create(null);

    function append(option) {
      if (!option) return;
      var clone = Object.assign({}, option);
      var key = builderOptionKey(clone);
      if (!key) {
        output.push(clone);
        return;
      }
      if (indexByKey[key] !== undefined) {
        output[indexByKey[key]] = Object.assign({}, output[indexByKey[key]], clone);
        return;
      }
      indexByKey[key] = output.length;
      output.push(clone);
    }

    (standardOptions || []).forEach(append);
    (currentOptions || []).forEach(append);
    return output;
  }

  function builderOptionKey(option) {
    return String(option && (option.key || option.id || option.value || option.label) || "");
  }

  function modelSizeFieldForGroup(group) {
    var swimSpa = isRegularSwimSpaGroupId(group && group.id);
    return {
      id: "model_variant_size",
      title: "Size",
      type: "model_sizes",
      property: "Selected Size",
      required: true,
      customBuilderUrl: swimSpa ? SWIM_SPA_PRODUCT_URL : "/products/hot-tub-cover",
      customBuilderTitle: swimSpa ? "Custom Swim Spa Covers" : "Custom Hot Tub Covers",
      options: Array.isArray(group.modelVariantSpecs) ? group.modelVariantSpecs : []
    };
  }

  function withHotTubSizeCap(fields, groupId) {
    return (fields || []).map(function (field) {
      if (!isSizeField(field)) return field;
      var isRollawayHotTub = isRollawayHotTubGroupId(groupId);

      return Object.assign({}, field, {
        // Static copy stays minimal — no size range, no always-on swim-spa
        // redirect. Oversize/swim-spa guidance is contextual now (see
        // updateSizeContext): it only appears once the entered size calls for it.
        hint: HOT_TUB_SIZE_HINT,
        hintLinks: [],
        sizeContext: {
          isRollaway: isRollawayHotTub,
          swimSpaUrl: isRollawayHotTub ? ROLLAWAY_SWIM_SPA_PRODUCT_URL : SWIM_SPA_PRODUCT_URL,
          swimSpaLabel: isRollawayHotTub ? "Open the rollaway swim spa builder" : "Open the swim spa builder"
        },
        inputs: (field.inputs || []).map(function (input) {
          if (!isPrimarySizeInput(input)) return input;
          return Object.assign({}, input, { max: HOT_TUB_COVER_MAX_SIZE_INCHES });
        })
      });
    });
  }

  function isSizeField(field) {
    var id = String(field && field.id || "");
    return id === "cover_size" || id === "rollaway_size";
  }

  function isPrimarySizeInput(input) {
    var id = String(input && input.id || "");
    var property = String(input && input.property || "");
    return id === "length_a" ||
      id === "width_b" ||
      property === "Cover Length A" ||
      property === "Cover Width B";
  }

  function isShapeField(field) {
    var id = String(field && field.id || "").toLowerCase();
    var property = String(field && field.property || "").toLowerCase();
    return id === "cover_shape" || id === "rollaway_cover_shape" || property === "cover shape";
  }

  function isFoldOrientationField(field) {
    var id = String(field && field.id || "").toLowerCase();
    var property = String(field && field.property || "").toLowerCase();
    return id === "fold_orientation" || id === "rollaway_fold_orientation" || property === "fold orientation";
  }

  // A rollaway cover has no fold; what it has instead is a roll direction. The
  // two questions are the same shape (which dimension the cover is worked
  // along) and answer to the same rectangle rule, so they are deliberately
  // kept as siblings rather than folded into one field.
  function isRollOrientationField(field) {
    var id = String(field && field.id || "").toLowerCase();
    var property = String(field && field.property || "").toLowerCase();
    return id === "roll_orientation" || id === "rollaway_roll_orientation" || property === "roll orientation";
  }

  function isCornerRadiusField(field) {
    var id = String(field && field.id || "").toLowerCase();
    var property = String(field && field.property || "").toLowerCase();
    return id === "corner_radius_mode" || id === "corner_radius" || property === "corner radius measurement" || property === "corner radius";
  }

  function isThicknessField(field) {
    var id = String(field && field.id || "").toLowerCase();
    var property = String(field && field.property || "").toLowerCase();
    return id === "cover_thickness" || id === "rollaway_cover_thickness" || property === "cover thickness";
  }

  function isSkirtField(field) {
    var id = String(field && field.id || "").toLowerCase();
    var property = String(field && field.property || "").toLowerCase();
    return id === "skirt_length" || id === "rollaway_skirt_length" || property === "skirt length";
  }

  function isStrapPlacementField(field) {
    var id = String(field && field.id || "").toLowerCase();
    var property = String(field && field.property || "").toLowerCase();
    return id === "strap_placement" || id === "rollaway_strap_placement" || property === "strap placement";
  }

  function isCoverUpgradesField(field) {
    var id = String(field && field.id || "").toLowerCase();
    var property = String(field && field.property || "").toLowerCase();
    return id === "cover_upgrades" || property === "cover upgrades";
  }

  function isLifterSystemField(field) {
    var id = String(field && field.id || "").toLowerCase();
    var property = String(field && field.property || "").toLowerCase();
    return id === "current_lifter_system" || property === "lifter plates";
  }

  function renderBuilder(root, group, groups) {
    var mount = root.querySelector("[data-builder-root]");
    var locale = root.dataset.locale || "en";
    var currency = root.dataset.currency || "CAD";
    var basePriceCents = parseInt(root.dataset.basePriceCents || "0", 10) || 0;
    var baseCompareAtPriceCents = parseInt(root.dataset.baseCompareAtPriceCents || "0", 10) || 0;
    attachOversizedFeePricing(root, group);
    var fields = Array.isArray(group._smcbxPreparedFields)
      ? group._smcbxPreparedFields
      : builderFieldsForGroup(root, group, Array.isArray(group.fields) && group.fields.length > 0 ? group.fields : defaultFields, groups);
    var listNames = getListNames(fields, group);

    mount.innerHTML = "";

    var form = el("form", {
      className: "smcbx__form smcbx__layout",
      action: root.dataset.cartAddUrl || "/cart/add",
      method: "post",
      autocomplete: "off",
      noValidate: true,
      dataset: { builderGroupId: group.id || "" }
    });
    form._smcbxGroup = group;

    form.appendChild(hiddenInput("id", root.dataset.variantId || ""));
    form.appendChild(hiddenInput("quantity", "1"));
    form.appendChild(hiddenInput("properties[Cover Details]", "", "cover-details"));
    form.appendChild(hiddenInput("properties[Estimated Builder Total]", "", "total"));
    form.appendChild(hiddenInput("properties[_Estimated Builder Compare Total]", "", "compare-total"));
    form.appendChild(hiddenInput("properties[_Estimated Builder Savings]", "", "savings"));
    form.appendChild(hiddenInput("properties[_Builder Addon Keys]", "", "addon-keys"));
    form.appendChild(hiddenInput("properties[_Builder Addon Variant IDs]", "", "addon-variant-ids"));
    form.appendChild(hiddenInput("properties[_Builder Base Summary]", "", "base-summary"));
    form.appendChild(hiddenInput("properties[_Builder Cart Details]", "", "cart-details"));
    form.appendChild(hiddenInput("properties[_Builder Group]", group.name || group.id || "Builder"));
    form.appendChild(hiddenInput("properties[_Builder Bundle ID]", "", "bundle-id"));
    form.appendChild(hiddenInput("properties[Builder Bundle ID]", "", "public-bundle-id"));
    var modelProperty = isFixedSpecBuilderGroup(group) && isRegularSwimSpaGroupId(group.id)
      ? "properties[Swim Spa Make & Model]"
      : "properties[Hot Tub Make & Model]";
    form.appendChild(hiddenInput(modelProperty, "", "hot-tub-model"));
    if (isFixedSpecBuilderGroup(group)) {
      var modelShapeInput = hiddenInput("properties[Cover Shape]", "", "model-shape");
      modelShapeInput.dataset.fieldId = "cover_shape";
      form.appendChild(modelShapeInput);
      form.appendChild(hiddenInput("properties[Cover Length A]", "", "model-length-a"));
      form.appendChild(hiddenInput("properties[Cover Width B]", "", "model-width-b"));
      form.appendChild(hiddenInput("properties[Corner Radius]", "", "model-radius-c"));
      form.appendChild(hiddenInput("properties[Cover Dimension C]", "", "model-dimension-c"));
      form.appendChild(hiddenInput("properties[Cover Dimension D]", "", "model-dimension-d"));
      form.appendChild(hiddenInput("properties[Speaker Pocket Count]", "", "model-speaker-pocket-count"));
    }
    listNames.forEach(function (name) {
      form.appendChild(hiddenInput("properties[" + name + "]", "", "list:" + name));
    });

    var visualColumn = renderVisualColumn(root, group, locale);
    if (visualColumn) {
      form.appendChild(visualColumn);
    } else {
      form.classList.add("smcbx__layout--no-preview");
    }

    var steps = el("section", { className: "smcbx__steps", ariaLabel: "Custom cover options" });
    steps.appendChild(renderProductHeader(root, group, locale));
    steps.appendChild(renderIncludedPanel(group, locale));
    steps.appendChild(renderSupportPanel(locale));
    if (!isFixedSpecBuilderGroup(group)) {
      if (isSwimSpaGroupId(group && group.id) && root.dataset.swimSpaModelsUrl) {
        steps.appendChild(renderSwimSpaModelPicker(root, group, locale));
      } else {
        steps.appendChild(renderModelSearch(group, locale));
      }
      steps.appendChild(createDivider(locale));
    }
    var coverTypeStep = renderCoverTypeStep(groups, group, locale, root);
    if (coverTypeStep) steps.appendChild(coverTypeStep);
    fields.forEach(function (field) {
      var rendered = renderField(field, locale, currency, group, root, groups);
      if (rendered) steps.appendChild(rendered);
    });
    form.appendChild(steps);

    // Appended after the fields, not with the other hidden inputs at the top:
    // buildCoverDetails walks the form in DOM order, and from up there this
    // would have led the summary rather than sitting with the specs it belongs
    // to. Disabled until the size actually decides the answer.
    if (isRollawayGroup(group) || fields.some(isRollOrientationField)) {
      var rollDefaultInput = hiddenInput("properties[Roll Orientation]", "", "roll-orientation-default");
      rollDefaultInput.dataset.coverDetail = "true";
      rollDefaultInput.disabled = true;
      form.appendChild(rollDefaultInput);
    }
    setupStepSections(steps, group, locale);

    form.appendChild(renderPurchaseRail(root, group, basePriceCents, baseCompareAtPriceCents, currency, locale));
    mount.appendChild(form);
    moveIntegratedPreview(root, form);
    setupStickyCart(root, form, locale);
    setupMobilePreview(root, form, locale);

    var addonMap = readJson(root, "[data-addon-map]", {});
    form._smcbxAddonMap = addonMap;
    function syncModelPriceState() {
      var synced = syncSelectedModelVariant(root, form);
      if (!synced) return;
      basePriceCents = synced.basePriceCents;
      baseCompareAtPriceCents = synced.baseCompareAtPriceCents;
      updateMainProductPriceBlock(root, basePriceCents, baseCompareAtPriceCents, currency, locale);
    }
    form.addEventListener("change", function (event) {
      var galleryHandled = syncCoverTypeGallery(root, event.target) || showMaterialColorPhoto(root, form, event.target);
      if (hasLiveBuilderPreview(group) && !galleryHandled) activateBuildPreview(root);
      if (isModelSizeControl(event.target)) {
        applyLockedVariantSpec(root, form, true);
        syncModelPriceState();
        retierRollawayUpgrade(root, form, currency, locale);
      }
      updateVisibility(root, form);
      syncSelectedClasses(root);
      updateProperties(root, form, addonMap, currency, locale, basePriceCents, baseCompareAtPriceCents);
      validateLive(root, form, event.target);
    });
    form.addEventListener("input", function (event) {
      var galleryHandled = syncCoverTypeGallery(root, event.target) || showMaterialColorPhoto(root, form, event.target);
      if (hasLiveBuilderPreview(group) && !galleryHandled) activateBuildPreview(root);
      updateVisibility(root, form);
      updateProperties(root, form, addonMap, currency, locale, basePriceCents, baseCompareAtPriceCents);
      validateLive(root, form, event.target);
    });
    form.addEventListener("keydown", function (event) {
      if (!shouldSuppressInputSubmit(event)) return;
      event.preventDefault();
      if (event.target && typeof event.target.blur === "function") {
        event.target.blur();
      }
    });
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      syncPendingModelSearch(form, locale);
      updateVisibility(root, form);
      updateProperties(root, form, addonMap, currency, locale, basePriceCents, baseCompareAtPriceCents);
      if (!validate(root, form)) return;
      submitBuilder(root, form, addonMap, currency, locale, basePriceCents, baseCompareAtPriceCents);
    });
    form.addEventListener("click", function (event) {
      handleGalleryClick(root, form, event);
    });

    if (isFixedSpecBuilderGroup(group)) {
      applyLockedVariantSpec(root, form, true);
    }
    if (isFixedSpecBuilderGroup(group)) {
      syncModelPriceState();
    }
    applyEditStateFromUrl(form);
    if (!isFixedSpecBuilderGroup(group)) applyManualModelFromUrl(form, locale);
    if (!isFixedSpecBuilderGroup(group)) syncManualModelStatus(form, locale);
    if (isFixedSpecBuilderGroup(group)) {
      applyLockedVariantSpec(root, form, true);
    }
    if (isFixedSpecBuilderGroup(group)) {
      syncModelPriceState();
    }
    retierRollawayUpgrade(root, form, currency, locale);
    updateVisibility(root, form);
    syncSelectedClasses(root);
    updateProperties(root, form, addonMap, currency, locale, basePriceCents, baseCompareAtPriceCents);
    translateBuilderNode(root, locale);
  }

  function renderProductHeader(root, group, locale) {
    // In the integrated layout the theme section already renders the canonical
    // <h1 class="s-main-product__title"> and this header is hidden via CSS, so
    // emitting another <h1> here would leave a duplicate <h1> in the DOM that SEO
    // and a11y crawlers flag. Use a non-heading element in that case; keep the
    // real <h1> only for standalone mounts where this header is the page heading.
    var integrated = root.dataset.builderLayout === "integrated";
    var titleText = root.dataset.productTitle || localize(group.name || "Custom Hot Tub Cover", locale);
    return el("header", { className: "smcbx__product-header" },
      el("div", { className: "smcbx__rating" }, "★★★★★", el("span", {}, localize("4.7 (2,000+ reviews)", locale))),
      el(integrated ? "p" : "h1", {}, titleText),
      el("div", { className: "smcbx__made-badge" }, localize("Made in Canada", locale))
    );
  }

  function renderVisualColumn(root, group, locale) {
    if (!hasLiveBuilderPreview(group)) return null;
    var galleryImages = coverGalleryImages(root, group);
    var referenceImage = galleryImages[0] || null;
    var initialMode = referenceImage ? "image" : "build";
    var initialSrc = referenceImage ? referenceImage.src : "";

    var hasPhotos = galleryImages.length > 0;

    return el("aside", { className: "smcbx__visual-column smcbx__gallery", ariaLabel: "Cover preview" },
      el("div", { className: "smcbx__thumbs", ariaLabel: "Product media" },
        galleryImages.map(function (image, index) {
          return el("button", {
            type: "button",
            className: index === 0 && initialMode === "image" ? "is-active" : "",
            dataset: {
              galleryButton: "",
              galleryMode: "image",
              gallerySrc: image.src,
              galleryFull: image.full || image.src
            }
          }, el("img", { src: image.thumb || image.src, alt: image.alt || "", loading: "lazy" }));
        }),
        el("button", {
          type: "button",
          className: initialMode === "build" ? "is-active smcbx__build-thumb" : "smcbx__build-thumb",
          dataset: { galleryButton: "", galleryMode: "build" }
        }, buildIcon(), el("span", { className: "smcbx__build-thumb-label" }, "Build"))
      ),
      el("div", { className: "smcbx__media", dataset: { galleryMode: initialMode, gallerySrc: initialSrc, galleryFull: referenceImage ? referenceImage.full || referenceImage.src : "" } },
        el("span", { className: "smcbx__sale" }, "SALE"),
        el("button", { type: "button", className: "smcbx__expand", ariaLabel: "Expand current image" }, zoomIcon()),
        el("button", { type: "button", className: "smcbx__media-nav smcbx__media-nav--prev", dataset: { galleryNav: "prev" }, ariaLabel: "Previous image", hidden: !hasPhotos }, chevronIcon()),
        el("button", { type: "button", className: "smcbx__media-nav smcbx__media-nav--next", dataset: { galleryNav: "next" }, ariaLabel: "Next image", hidden: !hasPhotos }, chevronIcon()),
        withHidden(renderLivePreview(root, root.dataset.productTitle || group.name || "Custom cover", group.id), initialMode !== "build"),
        el("img", {
          className: "smcbx__reference-photo",
          src: initialSrc,
          alt: root.dataset.productTitle || group.name || "Custom cover",
          hidden: initialMode !== "image"
        }),
        el("div", { className: "smcbx__live-cover-meta", hidden: initialMode !== "build" },
          el("span", { dataset: { sizeLabel: "" } }, ""),
          el("span", { dataset: { materialLabel: "" } }, "Black Vinyl"),
          el("span", { dataset: { shapeLabel: "" } }, "Rounded square / rectangle"),
          el("span", { dataset: { foldLabel: "" } }, "Fold A")
        )
      ),
      el("div", { className: "smcbx__selection-review" },
        el("b", {}, localize({ en: "Selected specs", fr: "Specifications selectionnees" }, locale)),
        el("dl", { dataset: { specList: "" } })
      )
    );
  }

  function moveIntegratedPreview(root, form) {
    if (root.dataset.builderLayout !== "integrated") return;
    var section = root.closest(".s-main-product--builder-integrated");
    var dock = section ? section.querySelector("[data-builder-preview-dock]") : null;
    var visual = form.querySelector(".smcbx__visual-column");
    if (!dock || !visual) return;

    root._smcbxVisualColumn = visual;
    dock.innerHTML = "";
    dock.appendChild(visual);
    form.classList.add("smcbx__layout--no-preview");
    section.classList.add("s-main-product--has-builder-preview");
    visual.addEventListener("click", function (event) {
      handleGalleryClick(root, form, event);
    });
  }

  function renderIncludedPanel(group, locale) {
    var includes = group.id && group.id.indexOf("rollaway") !== -1
      ? ["Rollaway one-person opening", "Chemical Resistant Liner", "Integrated rollaway strap system", "Custom sizing", "10-Year Warranty", "Made for Year-Round Use"]
      : ["Sealed Vapor Barrier", "1.5 Lbs Foam Density", "Chemical Resistant Liner", "4 Locking Straps", "Steam Stoppers", "2 Reinforced Handles"];

    return el("section", { className: "smcbx__included" },
      el("b", {}, localize({ en: "All our covers include:", fr: "Toutes nos housses comprennent:" }, locale), el("span", {}, " (FREE - valued at $49.99)")),
      el("ul", {}, includes.map(function (item) {
        return el("li", {}, localize(item, locale));
      }))
    );
  }

  function renderSupportPanel(locale) {
    return el("p", { className: "smcbx__support" },
      localize("Do you have additional questions?", locale),
      " ",
      el("a", { href: "tel:+18665156446" }, localize("Call +1 (866) 515-6446", locale))
    );
  }

  function renderModelSearch(group, locale) {
    var title = isSwimSpaGroupId(group && group.id) ? "Find Your Swim Spa Model" : "Find Your Hot Tub Model";
    var input = el("input", {
      type: "search",
      className: "smcbx__model-search-input",
      placeholder: localize("Search brand, model or product code...", locale),
      ariaLabel: localize("Search by brand, model, or product code", locale),
      autoComplete: "off"
    });
    var results = el("ul", {
      className: "smcbx__model-search-results",
      ariaLive: "polite",
      hidden: true
    });
    var selected = el("p", {
      className: "smcbx__model-search-selected",
      hidden: true,
      dataset: { modelSearchSelected: "" }
    });
    var timeout;

    input.addEventListener("input", function (event) {
      var query = String(event.target.value || "").trim();
      window.clearTimeout(timeout);
      var form = input.closest("form");
      var modelInput = modelSearchInput(form);
      if (modelInput && modelInput.value && modelInput.value !== query) {
        setManualModel(form, "", locale);
      }

      if (!query) {
        results.hidden = true;
        results.innerHTML = "";
        return;
      }

      timeout = window.setTimeout(function () {
        searchModels(query, results, locale);
      }, 220);
    });

    results.addEventListener("click", function (event) {
      var button = event.target.closest("[data-model-search-add]");
      if (!button) return;
      event.preventDefault();
      var form = button.closest("form");
      var model = button.dataset.modelSearchAdd || results.dataset.query || input.value;
      setManualModel(form, model, locale);
      results.hidden = true;
    });

    return el("section", { className: "smcbx__model-search" },
      el("header", { className: "smcbx__model-search-heading" },
        el("b", {}, localize(title, locale)),
        el("span", {}, localize("Optional", locale))
      ),
      el("p", {}, localize("Search by brand, model, or product code.", locale)),
      el("label", { className: "smcbx__model-search-field" },
        el("span", { className: "smcbx__sr-only" }, localize("Search by brand, model, or product code", locale)),
        input
      ),
      results,
      selected
    );
  }

  function renderSwimSpaModelPicker(root, group, locale) {
    var brandSelect = el("select", {
      className: "smcbx__model-picker-select",
      disabled: true,
      ariaLabel: localize({ en: "Swim spa brand", fr: "Marque du spa de nage" }, locale)
    }, el("option", { value: "" }, localize({ en: "Loading brands…", fr: "Chargement des marques…" }, locale)));

    var modelSelect = el("select", {
      className: "smcbx__model-picker-select",
      disabled: true,
      ariaLabel: localize({ en: "Swim spa model", fr: "Modèle du spa de nage" }, locale)
    }, el("option", { value: "" }, localize({ en: "Select a brand first", fr: "Choisissez d'abord une marque" }, locale)));

    var status = el("p", { className: "smcbx__model-search-selected", hidden: true });

    var manualInput = el("input", {
      type: "text",
      className: "smcbx__model-picker-manual-input",
      placeholder: localize({ en: "e.g. Hydropool AquaTrainer 19fX", fr: "ex. Hydropool AquaTrainer 19fX" }, locale),
      autoComplete: "off",
      dataset: { modelEntryInput: "" }
    });

    var section = el("section", { className: "smcbx__model-search smcbx__model-picker" },
      el("header", { className: "smcbx__model-search-heading" },
        el("b", {}, localize("Find Your Swim Spa Model", locale)),
        el("span", {}, localize("Optional", locale))
      ),
      el("p", {}, localize({ en: "Pick your brand and model to auto-fill the cover size.", fr: "Choisissez votre marque et modèle pour remplir automatiquement les dimensions." }, locale)),
      el("div", { className: "smcbx__model-picker-fields" },
        el("label", { className: "smcbx__model-picker-field" },
          el("span", { className: "smcbx__sr-only" }, localize({ en: "Swim spa brand", fr: "Marque du spa de nage" }, locale)),
          brandSelect
        ),
        el("label", { className: "smcbx__model-picker-field" },
          el("span", { className: "smcbx__sr-only" }, localize({ en: "Swim spa model", fr: "Modèle du spa de nage" }, locale)),
          modelSelect
        )
      ),
      status,
      el("div", { className: "smcbx__model-picker-manual" },
        el("label", { className: "smcbx__model-picker-manual-label" },
          el("span", {}, localize({ en: "Don't see your spa? Enter your make & model", fr: "Vous ne voyez pas votre spa? Entrez la marque et le modèle" }, locale)),
          manualInput
        ),
        el("p", { className: "smcbx__model-picker-note" }, localize({ en: "We'll note it on your order — then enter your measurements below.", fr: "Nous l'indiquerons sur votre commande — puis entrez vos mesures ci-dessous." }, locale))
      )
    );

    var brands = [];

    brandSelect.addEventListener("change", function () {
      populateSwimSpaModelOptions(modelSelect, findSwimSpaBrand(brands, brandSelect.value), locale);
      status.hidden = true;
    });

    modelSelect.addEventListener("change", function () {
      var brand = findSwimSpaBrand(brands, brandSelect.value);
      var model = brand ? findSwimSpaModel(brand, modelSelect.value) : null;
      if (!model) {
        status.hidden = true;
        return;
      }
      applySwimSpaModel(section.closest("form"), brand.brand, model);
      manualInput.value = (brand.brand ? brand.brand + " " : "") + model.name;
      status.hidden = false;
      status.textContent = localize({ en: "Prefilled: ", fr: "Prérempli : " }, locale) + formatSwimSpaSize(model, locale);
    });

    manualInput.addEventListener("input", function () {
      var value = String(manualInput.value || "").trim();
      setSwimSpaMakeModel(section.closest("form"), value);
      if (value) {
        status.hidden = false;
        status.textContent = localize("Using model name:", locale) + " " + value;
      } else {
        status.hidden = true;
      }
    });

    loadSwimSpaModels(root).then(function (data) {
      brands = data && Array.isArray(data.brands) ? data.brands : [];
      brandSelect.innerHTML = "";
      if (!brands.length) {
        brandSelect.appendChild(el("option", { value: "" }, localize({ en: "Model list unavailable", fr: "Liste de modèles indisponible" }, locale)));
        return;
      }
      brandSelect.appendChild(el("option", { value: "" }, localize({ en: "Select brand", fr: "Choisir une marque" }, locale)));
      brands.forEach(function (brand) {
        if (brand && brand.brand) brandSelect.appendChild(el("option", { value: brand.brand }, brand.brand));
      });
      brandSelect.disabled = false;
    });

    return section;
  }

  function populateSwimSpaModelOptions(modelSelect, brand, locale) {
    modelSelect.innerHTML = "";
    if (!brand || !Array.isArray(brand.models) || !brand.models.length) {
      modelSelect.appendChild(el("option", { value: "" }, localize({ en: "Select a brand first", fr: "Choisissez d'abord une marque" }, locale)));
      modelSelect.disabled = true;
      return;
    }
    modelSelect.appendChild(el("option", { value: "" }, localize({ en: "Select model", fr: "Choisir un modèle" }, locale)));
    brand.models.forEach(function (model) {
      if (model && model.name) modelSelect.appendChild(el("option", { value: model.name }, model.name));
    });
    modelSelect.disabled = false;
  }

  function findSwimSpaBrand(brands, name) {
    return (brands || []).find(function (brand) {
      return brand && brand.brand === name;
    }) || null;
  }

  function findSwimSpaModel(brand, name) {
    if (!brand || !Array.isArray(brand.models)) return null;
    return brand.models.find(function (model) {
      return model && model.name === name;
    }) || null;
  }

  function applySwimSpaModel(form, brandName, model) {
    if (!form || !model) return;
    setSwimSpaMeasurement(form, "Cover Length A", model.a);
    setSwimSpaMeasurement(form, "Cover Width B", model.b);
    if (model.c !== undefined && model.c !== null && model.c !== "") {
      ensureCornerRadiusMeasured(form);
      setSwimSpaMeasurement(form, "Corner Radius", model.c);
    }
    setSwimSpaMakeModel(form, (brandName ? brandName + " " : "") + model.name);
    form.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function setSwimSpaMakeModel(form, value) {
    if (!form) return;
    var input = form.elements ? form.elements["properties[Hot Tub Make & Model]"] : null;
    if (!input) return;
    input.value = value == null ? "" : String(value).trim();
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function setSwimSpaMeasurement(form, property, value) {
    if (!form) return;
    var input = form.querySelector('[name="properties[' + cssEscape(property) + ']"]');
    if (!input) return;
    input.value = value === 0 || value ? String(value) : "";
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function ensureCornerRadiusMeasured(form) {
    var radios = form.querySelectorAll('input[name="properties[Corner Radius Measurement]"]');
    Array.prototype.forEach.call(radios, function (radio) {
      if (radio.value === CORNER_RADIUS_MEASURED_VALUE && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  function formatSwimSpaSize(model, locale) {
    var unit = inchUnit(locale);
    var text = model.a + " × " + model.b + " " + unit;
    if (model.c !== undefined && model.c !== null && model.c !== "") {
      text += " · " + localize({ en: "corner radius ", fr: "rayon d'angle " }, locale) + model.c + " " + unit;
    }
    return text;
  }

  function loadSwimSpaModels(root) {
    if (root._smcbxSwimSpaModels) return root._smcbxSwimSpaModels;
    var url = root && root.dataset ? root.dataset.swimSpaModelsUrl : "";
    if (!url) {
      root._smcbxSwimSpaModels = Promise.resolve({ brands: [] });
      return root._smcbxSwimSpaModels;
    }
    root._smcbxSwimSpaModels = fetch(url, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to load swim spa models.");
        return response.json();
      })
      .then(function (data) {
        return data && Array.isArray(data.brands) ? data : { brands: [] };
      })
      .catch(function () {
        return { brands: [] };
      });
    return root._smcbxSwimSpaModels;
  }

  function searchModels(query, results, locale) {
    results.dataset.query = query;
    results.hidden = false;
    setSearchStatus(results, "Searching...", locale);

    fetch("/search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=50", {
      headers: { "Accept": "application/json" }
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to search products.");
        return response.json();
      })
      .then(function (data) {
        if (results.dataset.query !== query) return;
        var products = data && data.resources && data.resources.results && Array.isArray(data.resources.results.products)
          ? data.resources.results.products
          : [];
        renderSearchResults(results, products, locale);
      })
      .catch(function () {
        if (results.dataset.query !== query) return;
        setSearchStatus(results, "Something went wrong. Please try again.", locale);
      });
  }

  function renderSearchResults(results, products, locale) {
    results.innerHTML = "";
    results.hidden = false;

    if (!products.length) {
      var contact = el("a", { href: localizedUrl("/pages/contact-us"), className: "smcbx__model-search-link" }, localize({ en: "contact us", fr: "contactez-nous" }, locale));
      results.appendChild(el("li", { className: "smcbx__model-search-status smcbx__model-search-status--missing" },
        el("span", {},
          localize({
            en: "We don't have that model on file — no problem. Every cover is custom-made to your measurements, so you'll still get a perfect fit. Want a hand? ",
            fr: "Nous n'avons pas ce modèle dans nos fichiers — aucun souci. Chaque housse est fabriquée sur mesure selon vos dimensions, l'ajustement sera donc parfait. Besoin d'aide? "
          }, locale),
          contact,
          "."
        )
      ));
      appendManualModelAction(results, locale);
      return;
    }

    products.slice(0, 8).forEach(function (product) {
      var image = product && product.featured_image ? product.featured_image.url : "";
      var title = product && product.title ? product.title : "Hot tub cover";
      var item = el("li", { className: "smcbx__model-search-result" },
        el("a", { href: localizedUrl(product && product.url ? product.url : "#") },
          image ? el("img", { src: image, alt: title, loading: "lazy" }) : el("span", { className: "smcbx__model-search-thumb" }),
          el("span", {}, title)
        )
      );
      results.appendChild(item);
    });
    appendManualModelAction(results, locale);
  }

  function appendManualModelAction(results, locale) {
    var query = String(results.dataset.query || "").trim();
    if (!query) return;
    // Reuse the model-search result-row component (full-width, big click target)
    // instead of a small "+" pill, so it matches the predefined results.
    results.appendChild(el("li", { className: "smcbx__model-search-result smcbx__model-search-result--manual" },
      el("button", { type: "button", dataset: { modelSearchAdd: query } },
        el("span", { className: "smcbx__model-search-thumb smcbx__model-search-thumb--add", ariaHidden: "true" }, "+"),
        el("span", { className: "smcbx__model-search-manual-text" },
          el("strong", {}, localize({ en: "Use", fr: "Utiliser" }, locale) + ' "' + query + '"'),
          el("small", {}, localize({ en: "We'll custom-make it to your measurements", fr: "Fabriquée sur mesure selon vos dimensions" }, locale))
        )
      )
    ));
  }

  function setSearchStatus(results, message, locale) {
    results.innerHTML = "";
    results.hidden = false;
    results.appendChild(el("li", { className: "smcbx__model-search-status" }, localize(message, locale)));
  }

  function modelSearchInput(form) {
    return form ? form.elements["properties[Hot Tub Make & Model]"] : null;
  }

  function modelEntryInput(form) {
    return form ? form.querySelector("[data-model-entry-input]") : null;
  }

  function setManualModel(form, model, locale) {
    var input = modelSearchInput(form);
    if (!input) return;
    input.value = String(model || "").trim();
    syncManualModelStatus(form, locale);
    form.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function syncManualModelStatus(form, locale) {
    if (!form) return;
    var input = modelSearchInput(form);
    var selected = form.querySelector("[data-model-search-selected]");
    var modelEntry = modelEntryInput(form);
    var searchInput = form.querySelector(".smcbx__model-search-input");
    if (!selected || !input) return;
    var model = String(input.value || "").trim();
    if (modelEntry && document.activeElement !== modelEntry && modelEntry.value !== model) modelEntry.value = model;
    if (searchInput && document.activeElement !== searchInput && searchInput.value !== model) searchInput.value = model;
    selected.hidden = !model;
    selected.textContent = model ? localize("Using model name:", locale) + " " + model : "";
  }

  function syncPendingModelSearch(form, locale) {
    if (!showsHotTubModelEntry(form && form._smcbxGroup)) return;
    var hiddenModelInput = modelSearchInput(form);
    if (!hiddenModelInput) return;

    var modelEntry = modelEntryInput(form);
    var searchInput = form.querySelector(".smcbx__model-search-input");
    var entryValue = modelEntry ? String(modelEntry.value || "").trim() : "";
    var hiddenValue = String(hiddenModelInput.value || "").trim();
    var searchValue = searchInput ? String(searchInput.value || "").trim() : "";
    var model = entryValue || hiddenValue || searchValue;

    if (model) hiddenModelInput.value = model;
    if (modelEntry && !entryValue) modelEntry.value = model;
    syncManualModelStatus(form, locale);
  }

  function localizedUrl(url) {
    var value = String(url || "#");
    if (/^https?:\/\//i.test(value) || value === "#") return value;
    var localeMatch = window.location.pathname.match(/^\/(en-us|fr)\//);
    var localePrefix = localeMatch ? "/" + localeMatch[1] : "";
    if (localePrefix && value.indexOf(localePrefix + "/") !== 0) return localePrefix + value;
    return value;
  }

  function renderCoverTypeStep(groups, currentGroup, locale, root) {
    // Specialized models (e.g. the curved Coast Spas Apex Curve) have no Rollaway
    // counterpart — their shape can't be built as a roll-off cover — so they offer
    // neither the inline upgrade nor this navigate-away cover-type switcher.
    if (isSpecializedBuilderGroup(currentGroup)) return null;
    // Model pages show cover type as an inline priced option (rollawayCoverTypeField);
    // the navigate-away switcher below is only for the custom master products.
    if (isModelLikeBuilderGroup(currentGroup) && hasModelRollawayUpgrade(root, currentGroup && currentGroup.id)) return null;
    var relatedCoverTypes = coverTypeFamily(currentGroup);
    if (relatedCoverTypes.length < 2) return null;
    var available = (groups || []).filter(function (group) {
      return group && group.enabled !== false && relatedCoverTypes.indexOf(group.id) !== -1;
    });
    if (available.length < 2) return null;

    var comparePanel = el("div", { className: "smcbx__cover-type-compare", style: "display:none" },
      el("div", { className: "smcbx__cover-type-grid" }, available.map(function (group) {
        return buildCoverTypeCard(group, currentGroup, locale, root);
      }))
    );

    var compareLabel = el("span", {}, localize({ en: "Compare both types", fr: "Comparer les deux types" }, locale));
    var compareToggle = el("button", {
      type: "button",
      className: "smcbx__cover-type-compare-toggle",
      onclick: function () {
        var open = comparePanel.style.display !== "none";
        comparePanel.style.display = open ? "none" : "block";
        compareLabel.textContent = localize(open
          ? { en: "Compare both types", fr: "Comparer les deux types" }
          : { en: "Hide comparison", fr: "Masquer la comparaison" }, locale);
      }
    }, compareLabel);

    return el("fieldset", { className: "smcbx__fieldset smcbx__cover-type" },
      el("legend", {},
        el("span", {}, localize({ en: "Select cover type", fr: "Selectionnez le type de couverture" }, locale), el("strong", {}, "*")),
        el("em", {}, coverTypeShortLabel(currentGroup, locale))
      ),
      el("div", { className: "smcbx__cover-type-pills" }, available.map(function (group) {
        var selected = group.id === currentGroup.id;
        var product = (group.products || [])[0] || {};
        var handle = product.handle || "";
        var href = handle ? localizedUrl("/products/" + handle) : "#";
        var tag = selected ? "span" : "a";

        var photo = coverTypeThumb(group, root, locale);
        applyMainProductPhoto(root, handle, photo);

        var priceEl = el("span", { className: "smcbx__cover-type-pill-price is-loading" }, "—");
        fillCoverTypePillPrice(root, handle, priceEl, locale);

        return el(tag, {
          className: "smcbx__cover-type-pill" + (selected ? " is-selected" : ""),
          href: selected ? undefined : href
        },
          el("span", { className: "smcbx__cover-type-pill-thumb" }, photo),
          el("span", { className: "smcbx__cover-type-pill-text" },
            el("b", {}, coverTypeShortLabel(group, locale)),
            priceEl
          )
        );
      })),
      el("div", { className: "smcbx__cover-type-compare-row" }, compareToggle),
      comparePanel
    );
  }

  function buildCoverTypeCard(group, currentGroup, locale, root) {
    var selected = group.id === currentGroup.id;
    var product = (group.products || [])[0] || {};
    var handle = product.handle || "";
    var href = handle ? localizedUrl("/products/" + handle) : "#";
    var tag = selected ? "span" : "a";

    var priceValue = el("span", { className: "smcbx__cover-type-spec-value is-loading", dataset: { coverPrice: "" } }, "—");
    var priceRow = el("span", { className: "smcbx__cover-type-spec smcbx__cover-type-spec--price" },
      el("span", { className: "smcbx__cover-type-spec-label" }, localize({ en: "Price", fr: "Prix" }, locale)),
      priceValue
    );
    fillCoverTypePrice(root, handle, priceValue, priceRow, locale);

    var photo = coverTypeThumb(group, root, locale);
    applyMainProductPhoto(root, handle, photo);

    return el(tag, {
      className: "smcbx__cover-type-card" + (selected ? " is-selected" : ""),
      href: selected ? undefined : href
    },
      el("span", { className: "smcbx__cover-type-image" }, photo),
      el("span", { className: "smcbx__cover-type-copy" },
        el("b", {}, coverTypeLabel(group, locale)),
        el("small", {}, localize(isRollawayGroup(group) ? "The premium upgrade." : "The everyday classic.", locale)),
        el("span", { className: "smcbx__cover-type-specs" },
          coverTypeSpecs(group, locale).map(function (spec) {
            return el("span", { className: "smcbx__cover-type-spec" },
              el("span", { className: "smcbx__cover-type-spec-label" }, spec.label),
              el("span", { className: "smcbx__cover-type-spec-value" }, spec.value)
            );
          }),
          priceRow
        )
      )
    );
  }

  function coverTypeSpecs(group, locale) {
    var rollaway = isRollawayGroup(group);
    var hotTub = coverTypeFamily(group).indexOf("hot-tub-covers") !== -1;
    return [
      {
        label: localize({ en: "Foam", fr: "Mousse" }, locale),
        value: rollaway
          ? localize({ en: "iXPE, never waterlogs", fr: "iXPE imperméable" }, locale)
          : localize({ en: "Closed-cell EPS, rigid", fr: "EPS à cellules fermées" }, locale)
      },
      {
        label: localize({ en: "Opens by", fr: "Ouverture" }, locale),
        value: rollaway
          ? localize({ en: "Rolling to the end", fr: "En la roulant jusqu'au bout" }, locale)
          : localize({ en: "Lifting & folding", fr: "En la soulevant et la pliant" }, locale)
      },
      {
        label: localize({ en: "Tough winters & snow loads", fr: "Hivers rigoureux et charges de neige" }, locale),
        value: localize({ en: "Yes", fr: "Oui" }, locale)
      },
      {
        label: localize({ en: "Best for", fr: "Idéale pour" }, locale),
        value: rollaway
          ? (hotTub
            ? localize({ en: "Durability & longevity", fr: "Durabilité et longévité" }, locale)
            : localize({ en: "Easy handling & longevity", fr: "Manipulation facile et longévité" }, locale))
          : localize({ en: "Energy savings", fr: "Économies d'énergie" }, locale)
      }
    ];
  }

  // Model pages: cover type is an in-place priced radio (not a navigate-away
  // group switch), so this mirrors the custom builder's photo-pill + comparison
  // look while driving the inline cover_type option. Pills are <label> + hidden
  // radio (the global .smcbx input rule hides it); selection state comes from
  // syncSelectedClasses toggling .is-selected, and price/cart from the dataset.
  function renderModelCoverTypeBody(field, locale, currency, root, groups, currentGroup) {
    var family = coverTypeFamily(currentGroup);
    var tradGroupId = family[0] || "hot-tub-covers";
    var rollGroupId = family[1] || "rollaway-hot-tub-covers";
    var tradGroup = (groups || []).find(function (g) { return g && g.id === tradGroupId; });
    var rollGroup = (groups || []).find(function (g) { return g && g.id === rollGroupId; });
    var tradHandle = coverTypeProductHandle(tradGroup);
    var rollHandle = coverTypeProductHandle(rollGroup);
    var traditionalImg = coverTypeImage(root, tradGroup || { id: tradGroupId });
    var rollawayImg = coverTypeImage(root, rollGroup || { id: rollGroupId });

    var pills = el("div", { className: "smcbx__cover-type-pills" },
      (field.options || []).map(function (option) {
        var roll = isRollawayChoiceOption(option);
        var priceCents = priceFor(option, currency);
        var label = localize(option.label || option.value, locale);
        var input = el("input", {
          type: "radio",
          name: field.property ? "properties[" + field.property + "]" : "builder[" + (field.id || "") + "]",
          value: option.value,
          checked: option.selected === true,
          dataset: {
            fieldId: field.id || "",
            optionKey: option.key || "",
            optionLabel: label,
            listName: "",
            priceCents: String(priceCents),
            compareAtPriceCents: "0",
            variantId: option.variantId || "",
            defaultOption: option.selected === true ? "true" : ""
          }
        });
        // Match the custom builder: render the fallback asset, then swap in the
        // real product featured image (hot-tub-cover / custom-rollaway-hot-tub-cover).
        var photo = el("img", { className: "smcbx__cover-type-photo", src: roll ? rollawayImg : traditionalImg, alt: label, loading: "lazy" });
        applyMainProductPhoto(root, roll ? rollHandle : tradHandle, photo);
        return el("label", { className: "smcbx__cover-type-pill" },
          input,
          el("span", { className: "smcbx__cover-type-pill-thumb" }, photo),
          el("span", { className: "smcbx__cover-type-pill-text" },
            el("b", {}, label),
            priceCents > 0 ? el("span", { className: "smcbx__cover-type-pill-price" }, "+" + formatMoney(priceCents, currency, locale)) : null
          )
        );
      })
    );

    var rollawayOption = (field.options || []).filter(isRollawayChoiceOption)[0];
    var upgradeCents = rollawayOption ? priceFor(rollawayOption, currency) : 0;

    var comparePanel = el("div", { className: "smcbx__cover-type-compare", style: "display:none" },
      el("div", { className: "smcbx__cover-type-grid" },
        modelCoverTypeCard(root, tradGroupId, tradHandle, traditionalImg, 0, currency, locale),
        modelCoverTypeCard(root, rollGroupId, rollHandle, rollawayImg, upgradeCents, currency, locale)
      )
    );
    var compareLabel = el("span", {}, localize({ en: "Compare both types", fr: "Comparer les deux types" }, locale));
    var compareToggle = el("button", {
      type: "button",
      className: "smcbx__cover-type-compare-toggle",
      onclick: function () {
        var open = comparePanel.style.display !== "none";
        comparePanel.style.display = open ? "none" : "block";
        compareLabel.textContent = localize(open
          ? { en: "Compare both types", fr: "Comparer les deux types" }
          : { en: "Hide comparison", fr: "Masquer la comparaison" }, locale);
      }
    }, compareLabel);

    return el("div", { className: "smcbx__cover-type-choice" },
      pills,
      el("div", { className: "smcbx__cover-type-compare-row" }, compareToggle),
      comparePanel
    );
  }

  function isRollawayChoiceOption(option) {
    return Boolean(option && (option.value === "Rollaway" || option.id === "rollaway"));
  }

  function modelCoverTypeCard(root, typeId, handle, img, upgradeCents, currency, locale) {
    var roll = isRollawayGroupId(typeId);
    var title = coverTypeLabel({ id: typeId }, locale);
    var specs = coverTypeSpecs({ id: typeId }, locale).map(function (spec) {
      return el("span", { className: "smcbx__cover-type-spec" },
        el("span", { className: "smcbx__cover-type-spec-label" }, spec.label),
        el("span", { className: "smcbx__cover-type-spec-value" }, spec.value)
      );
    });
    if (roll && upgradeCents > 0) {
      specs.push(el("span", { className: "smcbx__cover-type-spec smcbx__cover-type-spec--price" },
        el("span", { className: "smcbx__cover-type-spec-label" }, localize({ en: "Price", fr: "Prix" }, locale)),
        el("span", { className: "smcbx__cover-type-spec-value" }, "+" + formatMoney(upgradeCents, currency, locale))
      ));
    }
    var photo = el("img", { className: "smcbx__cover-type-photo", src: img, alt: title, loading: "lazy" });
    applyMainProductPhoto(root, handle, photo);
    return el("div", { className: "smcbx__cover-type-card smcbx__cover-type-card--static" },
      el("span", { className: "smcbx__cover-type-image" }, photo),
      el("span", { className: "smcbx__cover-type-copy" },
        el("b", {}, title),
        el("small", {}, localize(roll ? "The premium upgrade." : "The everyday classic.", locale)),
        el("span", { className: "smcbx__cover-type-specs" }, specs)
      )
    );
  }

  function coverTypeProductHandle(group) {
    return (group && Array.isArray(group.products) && group.products[0] && group.products[0].handle) || "";
  }

  function fillCoverTypePrice(root, handle, valueNode, rowNode, locale) {
    if (!handle || !valueNode) {
      if (rowNode) rowNode.style.display = "none";
      return;
    }
    var currency = root.dataset.currency || "CAD";
    fetchAddonProduct(root, handle).then(function (product) {
      var cents = product && (product.price_min || product.price);
      if (!cents) {
        if (rowNode) rowNode.style.display = "none";
        return;
      }
      valueNode.textContent = localize({ en: "From ", fr: "À partir de " }, locale) + formatMoney(cents, currency, locale);
      valueNode.classList.remove("is-loading");
    }).catch(function () {
      if (rowNode) rowNode.style.display = "none";
    });
  }

  function fillCoverTypePillPrice(root, handle, valueNode, locale) {
    if (!handle || !valueNode) return;
    var currency = root.dataset.currency || "CAD";
    fetchAddonProduct(root, handle).then(function (product) {
      var cents = product && (product.price_min || product.price);
      if (!cents) { valueNode.textContent = ""; return; }
      valueNode.textContent = localize({ en: "From ", fr: "À partir de " }, locale) + formatMoney(cents, currency, locale);
      valueNode.classList.remove("is-loading");
    }).catch(function () { valueNode.textContent = ""; });
  }

  function coverTypeShortLabel(group, locale) {
    return localize(isRollawayGroup(group)
      ? { en: "Rollaway", fr: "Enroulable" }
      : { en: "Traditional", fr: "Traditionnelle" }, locale);
  }

  function applyMainProductPhoto(root, handle, imgNode) {
    if (!handle || !imgNode) return;
    fetchAddonProduct(root, handle).then(function (product) {
      var src = product && product.featured_image;
      if (!src) return;
      if (src.indexOf("//") === 0) src = "https:" + src;
      imgNode.src = src;
    }).catch(function () {});
  }

  function renderPurchaseRail(root, group, basePriceCents, baseCompareAtPriceCents, currency, locale) {
    var compare = baseCompareAtPriceCents > basePriceCents ? baseCompareAtPriceCents : 0;
    var savings = compare > basePriceCents ? compare - basePriceCents : 0;
    return el("aside", { className: "smcbx__purchase-rail", ariaLabel: localize("Order summary", locale) },
      el("div", { className: "smcbx__price-card" },
        el("span", { className: "smcbx__rail-eyebrow" }, localize("Your price", locale)),
        el("div", { className: "smcbx__price-row" },
          el("s", { dataset: { compareTotal: "", comparePrice: "" }, hidden: !savings }, formatMoney(compare, currency, locale)),
          el("div", {},
            el("strong", { dataset: { totalPrice: "" } }, formatMoney(basePriceCents, currency, locale)),
            el("span", { className: "smcbx__currency" }, String(currency || "CAD").toUpperCase()),
            el("span", { dataset: { savings: "", savingsBadge: "" }, hidden: !savings }, savingsLabel(formatMoney(savings, currency, locale), locale))
          )
        ),
        el("button", {
          type: "submit",
          className: "smcbx__submit",
          dataset: {
            defaultText: localize({ en: "ADD TO CART", fr: "AJOUTER AU PANIER" }, locale),
            loadingText: localize({ en: "ADDING...", fr: "AJOUT..." }, locale),
            addedText: localize({ en: "ADDED TO CART", fr: "AJOUTE AU PANIER" }, locale)
          }
        }, el("span", { className: "smcbx__submit-text" }, localize({ en: "ADD TO CART", fr: "AJOUTER AU PANIER" }, locale))),
        el("p", { className: "smcbx__free-shipping" }, localize(isSwimSpaGroupId(group && group.id) ? "Trusted by 10,000+ spa owners in North America" : "Trusted by 10,000+ hot tub owners in North America", locale))
      ),
      el("div", { className: "smcbx__price-detail-card" },
        el("b", {}, localize("Price details", locale)),
        el("dl", {},
          el("div", {}, el("dt", {}, root.dataset.productTitle || group.name || "Custom cover"), el("dd", { dataset: { basePrice: "" } }, formatMoney(basePriceCents, currency, locale))),
          el("div", {}, el("dt", {}, localize("10-Year Warranty", locale)), el("dd", {}, localize("Included", locale))),
          el("div", {}, el("dt", {}, localize("Custom sizing", locale)), el("dd", {}, localize("Included", locale))),
          el("div", {}, el("dt", {}, localize("Production/spec review", locale)), el("dd", {}, localize("Included", locale))),
          el("div", {}, el("dt", {}, localize("Shipping", locale)), el("dd", {}, localize("Free", locale))),
          el("div", { className: "smcbx__upgrade-line", dataset: { upgradeLine: "" } }, el("dt", {}, localize("Selected upgrades", locale)), el("dd", { dataset: { addonPrice: "" } }, formatMoney(0, currency, locale)))
        ),
        el("div", { className: "smcbx__estimated-total" },
          el("span", {}, localize("Estimated total", locale)),
          el("div", { className: "smcbx__estimated-price-stack" },
            el("s", { dataset: { detailCompareTotal: "", comparePrice: "" }, hidden: !savings }, formatMoney(compare, currency, locale)),
            el("strong", { dataset: { detailTotal: "" } }, formatMoney(basePriceCents, currency, locale) + " " + currency),
            el("em", { dataset: { detailSavings: "", savingsBadge: "" }, hidden: !savings }, savingsLabel(formatMoney(savings, currency, locale), locale))
          )
        )
      ),
      el("div", { className: "smcbx__secure-card" },
        el("b", {}, localize("Secure checkout", locale)),
        el("p", {}, localize("Your order is safe and secure.", locale)),
        el("div", { className: "smcbx__payment-badges" }, ["VISA", "MC", "AMEX", "Apple Pay", "G Pay"].map(function (item) {
          return el("span", {}, item);
        })),
        el("small", {}, localize("256-bit SSL encrypted", locale))
      ),
      el("div", { className: "smcbx__message", role: "status", ariaLive: "polite", dataset: { formMessage: "" } })
    );
  }

  function renderLivePreview(root, title, groupId) {
    var family = previewFamilyForGroupId(groupId);
    var preview = el("div", { className: "smcbx__live-cover", dataset: { livePreview: "", groupId: groupId || "", previewFamily: family, shapeKind: "rounded", strapPlacement: "handle" } });
    preview.innerHTML = [
      '<svg viewBox="0 0 560 500" role="img" aria-label="' + escapeHtml(title) + ' measurement preview">',
      texturePatternMarkup(root),
      '<g class="smcbx__shape-diagram smcbx__shape-rounded">',
      '<rect class="smcbx__cover-shadow" x="146" y="88" width="302" height="302" rx="44"></rect>',
      '<rect class="smcbx__cover-top" x="130" y="70" width="302" height="302" rx="38"></rect>',
      '<path class="smcbx__hinge-line" d="M132 222H430"></path>',
      strapMarkup("rounded"),
      '<path class="smcbx__handle" d="M252 68v-14h56v14"></path><path class="smcbx__handle" d="M252 376v14h56v-14"></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M80 79v126"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M80 287v78"></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M130 430h118"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M314 430h118"></path>',
      '<path class="smcbx__corner-guide" d="M438 70h30v38"></path><path class="smcbx__measure-arrow smcbx__arrow-both" d="M486 70v38"></path>',
      '<text class="smcbx__measure-letter" x="80" y="239">A</text>' + valuePillMarkup(51, 244, "data-dim-a-label", ""),
      '<text class="smcbx__measure-letter" x="281" y="428">B</text>' + valuePillMarkup(252, 434, "data-dim-b-label", ""),
      '<text class="smcbx__measure-letter" x="517" y="91">C</text>' + valuePillMarkup(494, 95, "data-radius-label", "", true),
      '</g>',
      '<g class="smcbx__shape-diagram smcbx__shape-square">',
      '<rect class="smcbx__cover-shadow" x="148" y="88" width="300" height="300" rx="0"></rect>',
      '<rect class="smcbx__cover-top" x="130" y="70" width="300" height="300" rx="0"></rect>',
      '<path class="smcbx__hinge-line" d="M132 222H430"></path>',
      strapMarkup("square"),
      '<path class="smcbx__handle" d="M252 68v-14h56v14"></path><path class="smcbx__handle" d="M252 374v14h56v-14"></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M80 76v126"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M80 287v77"></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M130 428h118"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M312 428h118"></path>',
      '<text class="smcbx__measure-letter" x="80" y="239">A</text>' + valuePillMarkup(51, 244, "data-dim-a-label", ""),
      '<text class="smcbx__measure-letter" x="280" y="426">B</text>' + valuePillMarkup(251, 432, "data-dim-b-label", ""),
      '</g>',
      '<g class="smcbx__shape-diagram smcbx__shape-round">',
      '<circle class="smcbx__cover-shadow" cx="294" cy="240" r="154"></circle>',
      '<circle class="smcbx__cover-top" cx="280" cy="220" r="154"></circle>',
      '<g class="smcbx__rollaway-ribs smcbx__rollaway-ribs--round"></g>',
      '<g class="smcbx__rollaway-straps smcbx__rollaway-straps--round"><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect></g>',
      '<path class="smcbx__hinge-line" d="M128 220H432"></path>',
      strapMarkup("round"),
      '<path class="smcbx__handle" d="M252 68v-14h56v14"></path><path class="smcbx__handle" d="M252 374v14h56v-14"></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M78 70v126"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M78 286v84"></path>',
      '<text class="smcbx__measure-letter" x="78" y="234">A</text>' + valuePillMarkup(49, 239, "data-dim-a-label", ""),
      '</g>',
      '<g class="smcbx__shape-diagram smcbx__shape-octagon">',
      '<path class="smcbx__cover-shadow" d="M220 88h150l80 80v150l-80 80H220l-80-80V168Z"></path>',
      '<path class="smcbx__cover-top" d="M205 70h150l80 80v150l-80 80H205l-80-80V150Z"></path>',
      '<g class="smcbx__rollaway-ribs smcbx__rollaway-ribs--octagon"></g>',
      '<g class="smcbx__rollaway-straps smcbx__rollaway-straps--octagon"><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect></g>',
      '<path class="smcbx__hinge-line" d="M127 224H433"></path>',
      strapMarkup("octagon"),
      '<path class="smcbx__handle" d="M252 68v-14h56v14"></path><path class="smcbx__handle" d="M252 384v14h56v-14"></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M82 80v126"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M82 289v83"></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M127 432h116"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M317 432h116"></path>',
      '<text class="smcbx__measure-letter" x="82" y="240">A</text>' + valuePillMarkup(53, 245, "data-dim-a-label", ""),
      '<text class="smcbx__measure-letter" x="280" y="430">B</text>' + valuePillMarkup(251, 436, "data-dim-b-label", ""),
      '</g>',
      cutShapeGroupMarkup("smcbx__shape-fourcut"),
      cutShapeGroupMarkup("smcbx__shape-onecut"),
      cutShapeGroupMarkup("smcbx__shape-twocut"),
      cutShapeGroupMarkup("smcbx__shape-bowed"),
      cutShapeGroupMarkup("smcbx__shape-custom"),
      '<g class="smcbx__shape-diagram smcbx__shape-swim-spa">',
      '<rect class="smcbx__cover-shadow" x="150" y="96" width="298" height="300" rx="22"></rect>',
      '<rect class="smcbx__cover-top" x="130" y="78" width="298" height="300" rx="18"></rect>',
      '<g class="smcbx__swim-panel-lines"></g>',
      '<g class="smcbx__swim-velcro-lines"></g>',
      '<g class="smcbx__swim-straps"></g>',
      '<path class="smcbx__handle" d=""></path><path class="smcbx__handle" d=""></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M80 78v128"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M80 290v88"></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M130 438h118"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M312 438h116"></path>',
      '<path class="smcbx__corner-guide" d="M428 78h30v38"></path><path class="smcbx__measure-arrow smcbx__arrow-both" d="M476 78v38"></path>',
      '<text class="smcbx__measure-letter" x="80" y="246">A</text>' + valuePillMarkup(51, 251, "data-dim-a-label", ""),
      '<text class="smcbx__measure-letter" x="279" y="436">B</text>' + valuePillMarkup(250, 442, "data-dim-b-label", ""),
      '<text class="smcbx__measure-letter" x="507" y="101">C</text>' + valuePillMarkup(484, 105, "data-radius-label", "", true),
      '<text class="smcbx__preview-note" x="280" y="68" text-anchor="middle" data-preview-note></text>',
      '</g>',
      '<g class="smcbx__shape-diagram smcbx__shape-rollaway">',
      '<rect class="smcbx__cover-shadow" x="150" y="96" width="298" height="300" rx="18"></rect>',
      '<rect class="smcbx__cover-top" x="130" y="78" width="298" height="300" rx="16"></rect>',
      '<g class="smcbx__rollaway-ribs"></g>',
      '<g class="smcbx__rollaway-straps"><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect></g>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M80 78v128"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M80 290v88"></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d="M130 438h118"></path><path class="smcbx__measure-arrow smcbx__arrow-end" d="M312 438h116"></path>',
      '<path class="smcbx__corner-guide" d="M428 78h30v38"></path><path class="smcbx__measure-arrow smcbx__arrow-both" d="M476 78v38"></path>',
      '<text class="smcbx__measure-letter" x="80" y="246">A</text>' + valuePillMarkup(51, 251, "data-dim-a-label", ""),
      '<text class="smcbx__measure-letter" x="279" y="436">B</text>' + valuePillMarkup(250, 442, "data-dim-b-label", ""),
      '<text class="smcbx__measure-letter" x="507" y="101">C</text>' + valuePillMarkup(484, 105, "data-radius-label", "", true),
      '</g>',
      '</svg>'
    ].join("");
    return preview;
  }

  function texturePatternMarkup(root) {
    var textures = [
      ["smcbxBlackVinylPattern", root.dataset.textureBlackVinyl],
      ["smcbxCharcoalVinylPattern", root.dataset.textureCharcoalVinyl],
      ["smcbxChestnutVinylPattern", root.dataset.textureChestnutVinyl],
      ["smcbxBlackAquatexPattern", root.dataset.textureBlackAquatex],
      ["smcbxCharcoalAquatexPattern", root.dataset.textureCharcoalAquatex],
      ["smcbxChestnutAquatexPattern", root.dataset.textureChestnutAquatex]
    ];

    return '<defs><marker id="smcbxMeasureArrow" viewBox="0 0 8 8" refX="4" refY="4" markerWidth="4.6" markerHeight="4.6" orient="auto-start-reverse"><path d="M1 1L7 4L1 7Z"></path></marker>' + textures.map(function (texture) {
      return '<pattern id="' + texture[0] + '" x="0" y="0" width="560" height="500" patternUnits="userSpaceOnUse">' +
        '<image href="' + escapeHtml(texture[1] || "") + '" width="560" height="500" preserveAspectRatio="xMidYMid slice"></image>' +
        '</pattern>';
    }).join("") + '</defs>';
  }

  function strapMarkup() {
    return [
      '<g class="smcbx__strap-set smcbx__straps-handle"><rect x="214" y="44" width="16" height="30" rx="5"></rect><rect x="330" y="44" width="16" height="30" rx="5"></rect><rect x="214" y="370" width="16" height="30" rx="5"></rect><rect x="330" y="370" width="16" height="30" rx="5"></rect></g>',
      '<g class="smcbx__strap-set smcbx__straps-hinge"><rect x="96" y="166" width="42" height="12" rx="5"></rect><rect x="96" y="270" width="42" height="12" rx="5"></rect><rect x="422" y="166" width="42" height="12" rx="5"></rect><rect x="422" y="270" width="42" height="12" rx="5"></rect></g>',
      '<g class="smcbx__strap-set smcbx__straps-corners"><rect x="132" y="86" width="42" height="12" rx="5" transform="rotate(40 153 92)"></rect><rect x="396" y="86" width="42" height="12" rx="5" transform="rotate(-40 417 92)"></rect><rect x="132" y="340" width="42" height="12" rx="5" transform="rotate(-40 153 346)"></rect><rect x="396" y="340" width="42" height="12" rx="5" transform="rotate(40 417 346)"></rect></g>',
      '<g class="smcbx__strap-set smcbx__straps-one-per-side"><rect x="272" y="44" width="16" height="30" rx="5"></rect><rect x="272" y="370" width="16" height="30" rx="5"></rect><rect x="96" y="218" width="42" height="12" rx="5"></rect><rect x="422" y="218" width="42" height="12" rx="5"></rect></g>'
    ].join("");
  }

  function valuePillMarkup(x, y, attr, text, small) {
    return '<g class="smcbx__value-pill' + (small ? " smcbx__value-pill--small" : "") + '" transform="translate(' + x + " " + y + ')"><rect width="' + (small ? 48 : 58) + '" height="26" rx="13"></rect><text x="' + (small ? 24 : 29) + '" y="18" text-anchor="middle" ' + attr + ">" + text + "</text></g>";
  }

  // Shared markup for the cut-corner shape diagrams (four/one/two cut). C rides its own
  // data-cut-label pill (the cut, along the diagonal); D reuses data-radius-label (it IS
  // the corner radius of the remaining corners).
  function cutShapeGroupMarkup(kindClass) {
    return [
      '<g class="smcbx__shape-diagram ' + kindClass + '">',
      '<path class="smcbx__cover-shadow" d=""></path>',
      '<path class="smcbx__cover-top" d=""></path>',
      '<g class="smcbx__rollaway-ribs" style="display:none"></g>',
      '<g class="smcbx__rollaway-straps" style="display:none"><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect><rect></rect></g>',
      '<path class="smcbx__hinge-line" d=""></path>',
      strapMarkup(kindClass),
      '<path class="smcbx__handle" d="M252 68v-14h56v14"></path><path class="smcbx__handle" d="M252 384v14h56v-14"></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d=""></path><path class="smcbx__measure-arrow smcbx__arrow-end" d=""></path>',
      '<path class="smcbx__measure-arrow smcbx__arrow-start" d=""></path><path class="smcbx__measure-arrow smcbx__arrow-end" d=""></path>',
      '<text class="smcbx__measure-letter" x="0" y="0">A</text>' + valuePillMarkup(0, 0, "data-dim-a-label", ""),
      '<text class="smcbx__measure-letter" x="0" y="0">B</text>' + valuePillMarkup(0, 0, "data-dim-b-label", ""),
      '<path class="smcbx__corner-guide" data-cut-guide d="" style="display:none"></path><path class="smcbx__measure-arrow smcbx__arrow-both" data-cut-arrow d="" style="display:none"></path>',
      '<text class="smcbx__measure-letter" data-cut-letter x="0" y="0" style="display:none">C</text>' + valuePillMarkup(0, 0, "data-cut-label", "", true),
      '<path class="smcbx__corner-guide" data-cutshape-radius-guide d="" style="display:none"></path>',
      '<text class="smcbx__measure-letter" data-cutshape-radius-letter x="0" y="0" style="display:none">D</text>' + valuePillMarkup(0, 0, "data-radius-label", "", true),
      '</g>'
    ].join("");
  }

  function renderField(field, locale, currency, group, root, groups) {
    if (field.id === "corner_radius_mode" || field.id === "corner_radius") return null;
    if (field.type === "model_sizes") return renderModelSizeField(field, locale);

    var wrapper = el("fieldset", { className: "smcbx__fieldset", dataset: { fieldId: field.id || "" } });
    if (field.visibleWhen) wrapper.dataset.visibleWhen = JSON.stringify(field.visibleWhen);
    if (field.hideForRollaway) wrapper.dataset.hideForRollaway = "true";
    if (field.showForRollaway) wrapper.dataset.showForRollaway = "true";
    if (field.showFoldDimensionDescriptions) wrapper.dataset.foldDimensionDescriptions = "true";

    wrapper.appendChild(el("legend", {}, el("span", {}, localize(field.title || field.property || "", locale), field.required ? el("strong", {}, "*") : ""), el("em", { dataset: { sectionStatus: "" } })));
    if (field.hint) wrapper.appendChild(renderFieldHint(field, locale));

    if (field.type === "cover_type_choice") {
      wrapper.classList.add("smcbx__cover-type");
      wrapper.appendChild(renderModelCoverTypeBody(field, locale, currency, root, groups, group));
      wrapper.appendChild(errorNode(field.id || field.property || ""));
      return wrapper;
    }

    if (field.type === "number_pair") {
      var isSizeField = field.id === "cover_size" || field.id === "rollaway_size";
      // Advisory sits under the hint (pre-measurement guidance); the live size
      // notice sits under the dimensions it describes — keeps the corner-radius
      // step and its validation clean below.
      if (isSizeField && field.sizeContext) wrapper.appendChild(renderSizeAdvisory(locale));
      var grid = el("div", { className: "smcbx__measure-grid" });
      (field.inputs || []).forEach(function (input, index) {
        grid.appendChild(renderNumberInput(input, field, locale, index === 0 ? "a" : "b"));
      });
      wrapper.appendChild(grid);
      if (isSizeField) {
        wrapper.appendChild(errorNode(fieldScopedErrorKey(field.id || "cover_size", "primary")));
        if (field.sizeContext) wrapper.appendChild(renderSizeContext());
        wrapper.appendChild(renderCornerRadiusMode(locale, field.id || "cover_size"));
        var extraGrid = el("div", { className: "smcbx__measure-grid smcbx__measure-grid--secondary" });
        extraGrid.appendChild(renderNumberInput({
          label: "Dimension C / corner radius (in.)",
          property: "Corner Radius",
          min: 0,
          max: 24,
          step: 0.5,
          placeholder: "Example: 8"
        }, { id: field.id, required: false }, locale, "c"));
        extraGrid.appendChild(renderNumberInput({
          label: "Dimension D (in.)",
          property: "Cover Dimension D",
          min: 0,
          max: 120,
          step: 0.5
        }, { id: field.id, required: false }, locale, "d", true));
        wrapper.appendChild(extraGrid);
        wrapper.appendChild(errorNode(fieldScopedErrorKey(field.id || "cover_size", "corner_radius")));
      }
      wrapper.appendChild(errorNode(field.id || "dimensions"));
      return wrapper;
    }

    if (field.type === "number" || field.type === "text" || field.type === "textarea") {
      wrapper.appendChild(renderSingleInput(field, locale));
      wrapper.appendChild(errorNode(field.id || field.property || ""));
      return wrapper;
    }

    var options = Array.isArray(field.options) ? field.options : [];
    var type = field.type === "addons" ? "checkbox" : "radio";
    var groupClass = groupClassFor(field.type);
    if (field.id && field.id.indexOf("cover_thickness") !== -1) {
      groupClass += " smcbx__configurator-options smcbx__thickness-options";
      if (options.length === 1) groupClass += " smcbx__thickness-options--single";
    } else if (field.type === "shapes") {
      groupClass += " smcbx__configurator-options smcbx__shape-options";
    }
    var groupDataset = {};
    if (field.required) groupDataset.requiredField = field.id || "";
    var group = el("div", { className: groupClass, dataset: groupDataset });
    options.forEach(function (option, index) {
      group.appendChild(renderOption(field, option, index, type, locale, currency));
    });

    if (field.type === "swatches" && options.some(function (option) {
      return materialFamilyFor(option) === "premium";
    })) {
      wrapper.appendChild(renderAquaTexNote(options, locale, currency));
    }

    wrapper.appendChild(group);
    if (isThicknessField(field) && options.some(isClassicThicknessOption)) {
      wrapper.appendChild(renderClassicThicknessWarning(locale));
    }
    wrapper.appendChild(errorNode(field.id || field.property || ""));
    return wrapper;
  }

  function renderClassicThicknessWarning(locale) {
    return el("p", {
      className: "smcbx__thickness-warning",
      hidden: true,
      dataset: { thicknessWarning: "" }
    }, localize(CLASSIC_THICKNESS_WARNING_MESSAGE, locale));
  }

  // Compact AquaTEX value-prop note above the colour swatches. Owner wanted the
  // special callout back, but lighter and without repeating what's already on the
  // swatches (the +$ price) or in the hint (the "included" status) — so just the
  // brand shield + a short benefits line.
  function renderAquaTexNote(options, locale, currency) {
    // Heading adapts to context: a real upgrade CTA where AquaTEX costs extra
    // (traditional/swim-spa swatches), a plain descriptor where it's included
    // (rollaway — its "included" status is already stated by the field hint).
    var paid = (options || []).some(function (option) {
      return materialFamilyFor(option) === "premium" && priceFor(option, currency) > 0;
    });
    var benefits = el("span", { className: "smcbx__aquatex-note-benefits" });
    ["Waterproof", "UV and mold resistant", "3× stronger, 25% lighter", "Easy to clean"].forEach(function (item, index) {
      if (index > 0) benefits.appendChild(el("span", { className: "smcbx__aquatex-note-dot", ariaHidden: "true" }, "·"));
      benefits.appendChild(el("span", {}, localize(item, locale)));
    });
    return el("div", { className: "smcbx__aquatex-note", dataset: { aquatexNote: "", paid: paid ? "true" : "false" } },
      el("span", { className: "smcbx__aquatex-note-icon", ariaHidden: "true" }),
      el("span", { className: "smcbx__aquatex-note-body" },
        el("b", { dataset: { aquatexNoteHeading: "" } }, localize(paid ? "Upgrade to AquaTEX™" : "AquaTEX™ premium fabric", locale)),
        benefits
      )
    );
  }

  function renderFieldHint(field, locale) {
    var hint = el("p", { className: "smcbx__hint" }, localize(field.hint, locale));
    var links = Array.isArray(field.hintLinks) ? field.hintLinks : [];
    if (links.length === 0 && field.hintLinkUrl && field.hintLinkLabel) {
      links = [{ url: field.hintLinkUrl, label: field.hintLinkLabel }];
    }
    if (!links.length) return hint;

    var actions = el("span", { className: "smcbx__hint-actions" });
    var renderedLinks = 0;
    links.forEach(function (link) {
      if (!link || !link.url || !link.label) return;
      if (renderedLinks > 0) actions.appendChild(document.createTextNode("/"));
      actions.appendChild(el("a", { href: localizedUrl(link.url) }, localize(link.label, locale)));
      renderedLinks += 1;
    });
    if (renderedLinks > 0) hint.appendChild(actions);
    return hint;
  }

  // Always-on note under the size inputs: many hot tubs have raised waterfalls,
  // speakers, or fountains the cover has to clear, so point those shoppers to us.
  function renderSizeAdvisory(locale) {
    return el("p", { className: "smcbx__size-advisory" },
      localize("Raised waterfalls, speakers, or fountains?", locale) + " ",
      el("a", { href: localizedUrl("/pages/contact") }, localize("Contact us", locale)),
      " " + localize("and we'll build around them.", locale)
    );
  }

  // Empty placeholder; updateSizeContext fills/clears it as the entered size changes.
  function renderSizeContext() {
    return el("div", { className: "smcbx__size-context", hidden: true, dataset: { sizeContext: "" } });
  }

  function renderModelSizeField(field, locale) {
    var wrapper = el("fieldset", { className: "smcbx__fieldset", dataset: { fieldId: field.id || "" } });
    wrapper.appendChild(el("legend", {},
      el("span", {}, localize(field.title || "Select size", locale), field.required ? el("strong", {}, "*") : ""),
      el("em", { dataset: { sectionStatus: "" } })
    ));
    var options = Array.isArray(field.options) ? field.options : [];
    // Measuring guidance sits under the heading like every other field hint,
    // and only when there is a real choice to make.
    if (options.length > 1) wrapper.appendChild(renderModelSizeGuide(locale));

    var groupDataset = {};
    if (field.required) groupDataset.requiredField = field.id || "";
    var group = el("div", { className: "smcbx__cards smcbx__cards--three smcbx__model-size-options", dataset: groupDataset });
    var hasExplicitSelection = hasSelected(options);
    var singleOption = options.length === 1;
    var fallbackIndex = options.findIndex(function (option) {
      return option.available !== false;
    });
    if (fallbackIndex < 0) fallbackIndex = 0;

    options.forEach(function (option, index) {
      var labelText = option.labelFromTitle
        ? localize(option.label || option.title || "One size", locale)
        : modelSpecSizeLabel(option.title, option.length, option.width, option.radius, option.shape, option.dimensionD, option.yearRange, option.modelLabel, option.variantQualifier, locale);
      var label = el("label", { className: "smcbx__card smcbx__model-size" });
      label.appendChild(el("input", {
        type: "radio",
        name: "properties[" + (field.property || "Selected Size") + "]",
        value: labelText,
        // Pre-check only a lone size (no real choice) or one the shopper explicitly
        // selected via deep link. Multi-size models start with nothing checked so the
        // shopper has to choose the size that matches their spa.
        checked: option.selected === true || (singleOption && index === fallbackIndex && !hasExplicitSelection),
        required: field.required === true,
        disabled: option.available === false,
        dataset: {
          fieldId: field.id || "",
          optionLabel: labelText,
          modelVariantId: option.variantId || "",
          modelPriceCents: String(option.priceCents || 0),
          modelCompareAtPriceCents: String(option.compareAtPriceCents || 0),
          modelLength: option.length || "",
          modelWidth: option.width || "",
          modelRadius: option.radius || "",
          modelDimensionD: option.dimensionD || "",
          modelShape: option.shape || "",
          modelLabel: option.modelLabel || "",
          modelYearRange: option.yearRange || "",
          modelVariantQualifier: option.variantQualifier || "",
          modelSpecSource: option.specSource || "",
          modelSpeakerPocketCount: option.speakerPocketCount || ""
        }
      }));
      // Measurement and qualifier text comes from structured variant metafields.
      // Keep the Shopify variant title only as an upstream fallback for legacy
      // records that have no usable measurements or qualifiers.
      var displayParts = labelText.split(/\s+\/\s+/);
      if (displayParts.length === 1 && labelText.indexOf("|") >= 0) displayParts = labelText.split(/\s*\|\s*/);
      var dimText = prettyDim(displayParts.shift() || labelText);
      var detailText = displayParts.map(prettyDim).filter(Boolean).join(" · ");
      var sizeBody = el("span", {}, el("strong", { className: "smcbx__model-size-dim" }, dimText));
      if (detailText) sizeBody.appendChild(el("small", { className: "smcbx__model-size-radius" }, detailText));
      label.appendChild(sizeBody);
      group.appendChild(label);
    });

    wrapper.appendChild(group);
    if (field.customBuilderUrl) wrapper.appendChild(renderModelCustomBuilderLink(field.customBuilderUrl, field.customBuilderTitle, locale));
    wrapper.appendChild(errorNode(field.id || "model_variant_size"));
    return wrapper;
  }

  function renderModelCustomBuilderLink(url, title, locale) {
    return el("p", { className: "smcbx__model-custom-link" },
      localize("Need a different size ?", locale),
      " ",
      el("a", {
        href: localizedUrl(url),
        target: "_blank",
        rel: "noopener",
        title: localize(title || "Custom Hot Tub Covers", locale)
      }, localize("Configure your custom cover", locale))
    );
  }

  // Measuring guidance in the standard field-hint style: one plain sentence.
  function renderModelSizeGuide(locale) {
    return el("p", { className: "smcbx__hint" }, localize({
      en: "Measure your spa shell: size rounds up ↑, radius rounds down ↓.",
      fr: "Mesurez la coque de votre spa : taille vers le haut ↑, rayon vers le bas ↓."
    }, locale));
  }

  // Display-only typographic polish for size labels: 8" -> 8″ and 89 x 89 -> 89 × 89.
  function prettyDim(text) {
    return String(text)
      .replace(/"/g, "″")
      .replace(/(\d|″)\s*x\s*(\d)/gi, "$1 × $2")
      .trim();
  }

  function renderOption(field, option, index, inputType, locale, currency) {
    var labelClass = optionClassFor(field.type);
    if (field.type === "swatches" && materialFamilyFor(option) === "premium") {
      labelClass += " is-aquatex";
    }
    if ((field.type === "addons" || field.type === "image_choices") && option.badge) {
      labelClass += (labelClass ? " " : "") + "smcbx__addon-featured";
    }
    var label = el("label", { className: labelClass });
    if (option.visibleWhen) label.dataset.visibleWhen = JSON.stringify(option.visibleWhen);
    var propertyName = field.property ? "properties[" + field.property + "]" : "builder[" + field.id + "]";
    var optionValue = option.value || localize(option.label || option.id || "", locale);
    var input = el("input", {
      type: inputType,
      name: propertyName,
      value: optionValue,
      ariaLabel: localize(option.label || optionValue, locale),
      checked: shouldSelectOptionByDefault(field, option, index, inputType),
      dataset: {
        fieldId: field.id || "",
        optionKey: option.key || "",
        optionLabel: localize(option.label || optionValue, locale),
        listName: option.listName || "",
        priceCents: String(priceFor(option, currency)),
        compareAtPriceCents: String(compareAtPriceFor(option, currency)),
        variantId: option.variantId || "",
        addonProductHandle: option.addonProductHandle || option.productHandle || "",
        measurementTemplate: option.measurementTemplate || "",
        galleryImage: option.galleryImageUrl || option.imageUrl || "",
        swatch: option.swatch || "",
        materialFamily: option.materialFamily || materialFamilyFor(option),
        defaultOption: (option.isDefault || option.selected === true) ? "true" : ""
      }
    });
    label.appendChild(input);

    var body = el("span", {});
    if (field.id && field.id.indexOf("cover_thickness") !== -1) {
      body.appendChild(thicknessArt(option));
    } else if (field.type === "addons" || field.type === "image_choices") {
      if (option.imageUrl) {
        label.appendChild(el("img", {
          className: "smcbx__addon-image",
          src: option.imageUrl,
          alt: localize(option.label || optionValue, locale),
          loading: "lazy"
        }));
      }
    } else if (field.type === "swatches" && option.imageUrl) {
      body.appendChild(el("span", { className: "smcbx__material-photo-frame" },
        el("img", {
          className: "smcbx__option-image",
          src: option.imageUrl,
          alt: localize(option.label || optionValue, locale),
          loading: "lazy"
        })
      ));
    } else if (option.imageUrl) {
      body.appendChild(el("img", {
        className: "smcbx__option-image",
        src: option.imageUrl,
        alt: localize(option.label || optionValue, locale),
        loading: "lazy"
      }));
    } else if (field.type === "shapes") {
      body.appendChild(shapeSvg(option.id || optionValue));
    } else if (field.type === "swatches") {
      body.appendChild(el("i", { style: "--swatch:" + (option.swatch || "#1b315a") }));
    }

    var title = el("strong", {}, localize(option.label || optionValue, locale));
    if (option.badge) {
      body.appendChild(el("span", { className: "smcbx__option-heading" },
        el("span", { className: "smcbx__option-badge" }, localize(option.badge, locale)),
        title
      ));
    } else {
      body.appendChild(title);
    }
    var foldAxis = foldSplitAxisForOption(field, option);
    var rollAxis = foldAxis ? "" : rollAxisForOption(field, option);
    var description = foldAxis
      ? foldDimensionDescription(foldAxis, "", locale)
      : rollAxis
        ? rollDimensionDescription(rollAxis, "", locale)
        : option && option.description || "";
    if (description) {
      var descriptionAttrs = foldAxis
        ? { dataset: { foldDimensionAxis: foldAxis } }
        : rollAxis
          ? { dataset: { rollDimensionAxis: rollAxis } }
          : {};
      body.appendChild(el("small", descriptionAttrs, foldAxis || rollAxis ? description : localize(description, locale)));
    }
    if (priceFor(option, currency) > 0) {
      body.appendChild(el("em", { className: "smcbx__option-price" }, "+" + formatMoney(priceFor(option, currency), currency, locale)));
    } else if (field.id && field.id.indexOf("cover_thickness") !== -1) {
      body.appendChild(el("em", { className: "smcbx__option-price smcbx__option-price--placeholder", "aria-hidden": "true" }, "+$0.00"));
    }

    label.appendChild(body);

    return label;
  }

  function shouldSelectOptionByDefault(field, option, index, inputType) {
    if (isFoldOrientationField(field)) return false;
    if (isRollOrientationField(field)) return option.selected === true;
    // Skirt length carries no default: shoppers were adding the preselected
    // 3 in. skirt without noticing, so they must make an explicit choice.
    // Skip the first-option radio fallback below.
    if (isSkirtField(field)) return option.selected === true;
    if (isThicknessField(field) && inputType === "radio" && hasClassicThicknessOption(field.options)) {
      if (isClassicThicknessOption(option)) return false;
      if (!hasSelected(field.options)) return false;
    }
    if (option.selected === true) return true;
    return index === 0 && inputType === "radio" && !hasSelected(field.options);
  }

  function foldSplitAxisForOption(field, option) {
    if (field && field.showFoldDimensionDescriptions && isFoldOrientationField(field)) {
      var id = normalizeToken(option && option.id || "");
      var text = normalizeToken((option && option.value || "") + " " + (option && option.label || ""));
      if (id.indexOf("width-b") !== -1 || /\bfold\s*a\b|\ba\b/.test(text)) return "a";
      if (id.indexOf("length-a") !== -1 || /\bfold\s*b\b|\bb\b/.test(text)) return "b";
    }
    return "";
  }

  // Unlike fold, this description is not opt-in per group: "Roll A" on its own
  // says nothing to a shopper, and the measurement is what makes the choice
  // legible.
  function rollAxisForOption(field, option) {
    if (!isRollOrientationField(field)) return "";
    var id = normalizeToken(option && option.id || "");
    var text = normalizeToken((option && option.value || "") + " " + (option && option.label || ""));
    if (id.indexOf("length-a") !== -1 || /\broll\s*a\b|\ba\b/.test(text)) return "a";
    if (id.indexOf("width-b") !== -1 || /\broll\s*b\b|\bb\b/.test(text)) return "b";
    return "";
  }

  function updateRollDimensionDescriptions(form, locale) {
    var scopes = [form];
    var overlay = document.querySelector(".smcbx__measure");
    if (overlay && scopes.indexOf(overlay) === -1) scopes.push(overlay);
    scopes.forEach(function (scope) {
      scope.querySelectorAll("[data-roll-dimension-axis]").forEach(function (node) {
        var axis = node.dataset.rollDimensionAxis || "";
        var value = axis === "a" ? propertyValue(form, "Cover Length A") : propertyValue(form, "Cover Width B");
        node.textContent = rollDimensionDescription(axis, value, locale);
      });
    });
  }

  /**
   * One sentence, one measurement — the shape fold uses ("Cut the 84 in. side
   * in half."). Naming the side the roll travels ALONG keeps the letter and
   * the number on the same dimension, so Roll A always reads against A. The
   * clearance guidance lives in the field hint instead, stated once rather
   * than restated in both pills.
   */
  function rollDimensionDescription(axis, value, locale) {
    var measurement = String(value || "").trim();
    var baseLocale = normalizeToken(locale || "en").split("-")[0];
    if (measurement) {
      return baseLocale === "fr"
        ? "S’enroule dans le sens du côté de " + inchesLabel(measurement, locale) + "."
        : "Rolls along the " + inchesLabel(measurement, locale) + " side.";
    }
    return localize(axis === "a" ? "Rolls along A." : "Rolls along B.", locale);
  }

  function updateFoldDimensionDescriptions(form, locale) {
    // Update in-form pills AND the body-level measure pop-up clone (which lives
    // outside the form) so the pop-up's fold pills show the real "Cut the 80.5 in.
    // side in half." text instead of the generic "Cut B in half." placeholder.
    var scopes = [form];
    var overlay = document.querySelector(".smcbx__measure");
    if (overlay && scopes.indexOf(overlay) === -1) scopes.push(overlay);
    scopes.forEach(function (scope) {
      scope.querySelectorAll("[data-fold-dimension-axis]").forEach(function (node) {
        var axis = node.dataset.foldDimensionAxis || "";
        var value = axis === "a" ? propertyValue(form, "Cover Length A") : propertyValue(form, "Cover Width B");
        node.textContent = foldDimensionDescription(axis, value, locale);
      });
    });
  }

  function foldDimensionDescription(axis, value, locale) {
    var measurement = String(value || "").trim();
    var baseLocale = normalizeToken(locale || "en").split("-")[0];
    if (measurement) {
      return baseLocale === "fr"
        ? "Couper le côté de " + inchesLabel(measurement, locale) + " en deux."
        : "Cut the " + inchesLabel(measurement, locale) + " side in half.";
    }
    return localize(axis === "a" ? "Cut A in half." : "Cut B in half.", locale);
  }

  function renderCornerRadiusMode(locale, fieldId) {
    return el("div", { className: "smcbx__corner-radius-mode", dataset: { cornerRadiusMode: "" } },
      el("div", { className: "smcbx__corner-radius-mode-title" }, localize("Corner radius", locale)),
      el("div", { className: "smcbx__choice-stack smcbx__choice-stack--compact" },
        renderCornerRadiusChoice("measured", CORNER_RADIUS_MEASURED_VALUE, false, locale),
        renderCornerRadiusChoice("need-help", CORNER_RADIUS_HELP_VALUE, false, locale)
      ),
      errorNode(fieldScopedErrorKey(fieldId || "cover_size", "corner_mode")),
      el("p", { className: "smcbx__corner-radius-help", dataset: { cornerRadiusHelp: "" }, hidden: true }, localize(CORNER_RADIUS_HELP_MESSAGE, locale))
    );
  }

  function renderCornerRadiusChoice(id, value, selected, locale) {
    var label = el("label", { className: "smcbx__choice smcbx__choice--radius-mode" });
    label.appendChild(el("input", {
      type: "radio",
      name: "properties[Corner Radius Measurement]",
      value: value,
      checked: selected === true,
      dataset: {
        fieldId: "corner_radius_mode",
        optionLabel: localize(value, locale)
      }
    }));
    label.appendChild(el("span", {}, localize(value, locale)));
    return label;
  }

  function renderNumberInput(input, field, locale, dimension, hidden) {
    var label = el("label", { dataset: dimension ? { dimension: dimension } : {}, hidden: hidden === true });
    label.appendChild(el("span", {}, localize(input.label || input.property || "", locale)));
    label.appendChild(numberInput({
      type: "number",
      name: "properties[" + input.property + "]",
      min: input.min ?? field.min ?? "",
      max: input.max ?? field.max ?? "",
      step: input.step ?? field.step ?? "1",
      inputMode: "decimal",
      required: field.required === true,
      value: "",
      autocomplete: "off",
      dataset: { fieldId: field.id || "" },
      placeholder: localize(input.placeholder || "", locale)
    }));
    return label;
  }

  function renderSingleInput(field, locale) {
    var label = el("label", { className: "smcbx__single-input" });
    if (field.label) label.appendChild(el("span", {}, localize(field.label, locale)));
    var inputProps = {
      type: field.type === "number" ? "number" : "text",
      name: "properties[" + field.property + "]",
      min: field.min ?? "",
      max: field.max ?? "",
      step: field.step ?? "1",
      inputMode: field.type === "number" ? "decimal" : "",
      required: field.required === true,
      value: "",
      autocomplete: "off",
      placeholder: localize(field.placeholder || "", locale),
      dataset: { fieldId: field.id || "" }
    };
    if (field.type === "textarea") {
      delete inputProps.type;
      delete inputProps.min;
      delete inputProps.max;
      delete inputProps.step;
      delete inputProps.inputMode;
      inputProps.rows = field.rows || 4;
      label.appendChild(el("textarea", inputProps));
    } else {
      label.appendChild(field.type === "number" ? numberInput(inputProps) : el("input", inputProps));
    }
    return label;
  }

  function numberInput(props) {
    return disableNumberWheelChange(el("input", props));
  }

  function disableNumberWheelChange(input) {
    input.addEventListener("wheel", function () {
      if (document.activeElement === input) input.blur();
    });
    return input;
  }

  function shouldSuppressInputSubmit(event) {
    if (!event || event.key !== "Enter" || event.defaultPrevented || event.isComposing) return false;
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return false;

    var target = event.target;
    if (!target || target.tagName !== "INPUT") return false;

    var type = String(target.type || "text").toLowerCase();
    return ["number", "text", "search", "email", "tel", "url"].indexOf(type) !== -1;
  }

  function isModelSizeControl(control) {
    return control && control.matches && control.matches("input[data-model-variant-id]");
  }

  function selectedModelSizeInput(form) {
    return form.querySelector("input[data-model-variant-id]:checked");
  }

  function applyLockedVariantSpec(root, form, overwrite) {
    var spec = selectedLockedVariantSpec(root, form);
    if (!spec) return;

    var shape = modelShapePropertyValue(spec.shape);
    var template = measurementTemplateFor(shape);
    var measurementC = spec.radius || "";
    var usesRadius = template === "a_b_c_radius";
    // Property contract (production packet): Corner Radius = a radius, Cover Dimension C = a
    // cut measured along the diagonal, Cover Dimension D = secondary cut/depth. Metafields
    // store c=radius d=cut for one/two-cut models, so route by template, not by letter.
    var routedRadius = "";
    var routedCut = "";
    var routedD = "";
    if (template === "a_b_c_radius") routedRadius = measurementC;
    else if (template === "a_b_c_cut") routedCut = measurementC;
    else if (template === "a_b_c_d_cut") { routedRadius = measurementC; routedCut = spec.dimensionD || ""; }
    else if (modelTemplateUsesMeasurementC(template)) routedCut = measurementC;

    setPropertyInputValue(form, "Cover Shape", shape, true);
    var shapeInput = form.querySelector('[data-hidden-key="model-shape"]');
    if (shapeInput) shapeInput.dataset.optionLabel = shape;

    setPropertyInputValue(form, "Cover Length A", spec.length || "", overwrite);
    if (modelTemplateUsesWidth(template)) {
      setPropertyInputValue(form, "Cover Width B", spec.width || "", overwrite);
    } else {
      setPropertyInputValue(form, "Cover Width B", "", true);
    }

    setPropertyInputValue(form, "Corner Radius", routedRadius, true);
    setPropertyInputValue(form, "Cover Dimension C", routedCut, true);
    setPropertyInputValue(form, "Cover Dimension D", routedD, true);
    setPropertyInputValue(form, "Speaker Pocket Count", spec.speakerPocketCount || "", true);

    var modelLabel = spec.modelLabel || root.dataset.productTitle || "";
    setHidden(form, "hot-tub-model", modelLabel);
  }

  function selectedLockedVariantSpec(root, form) {
    var input = selectedModelSizeInput(form);
    if (input) {
      return {
        variantId: input.dataset.modelVariantId || "",
        length: input.dataset.modelLength || "",
        width: input.dataset.modelWidth || "",
        radius: input.dataset.modelRadius || "",
        dimensionD: input.dataset.modelDimensionD || "",
        shape: input.dataset.modelShape || "",
        modelLabel: input.dataset.modelLabel || "",
        yearRange: input.dataset.modelYearRange || "",
        variantQualifier: input.dataset.modelVariantQualifier || "",
        specSource: input.dataset.modelSpecSource || "",
        speakerPocketCount: input.dataset.modelSpeakerPocketCount || ""
      };
    }

    // No size radio is checked. A single-variant model has nothing to choose, so use
    // its only spec. A multi-size model intentionally stays blank until the shopper
    // picks, so the preview and spec list never imply a pre-selected size. An explicit
    // deep-link (?variant=) marks its spec selected, so honor that too.
    var specs = modelVariantSpecs(root);
    if (specs.length === 1) return specs[0];
    return specs.find(function (spec) {
      return spec.selected === true;
    }) || null;
  }

  function modelTemplateUsesMeasurementC(template) {
    return template === "a_b_c_radius" || template === "a_b_c" || template === "a_b_c_cut" || template === "a_b_c_d_cut";
  }

  function modelTemplateUsesDimensionD(template) {
    return template === "a_b_c_d_cut";
  }

  function modelTemplateUsesWidth(template) {
    return template !== "diameter";
  }

  function syncSelectedModelVariant(root, form) {
    var input = selectedModelSizeInput(form);
    if (!input) return null;

    var variantId = input.dataset.modelVariantId || "";
    if (variantId) {
      root.dataset.variantId = variantId;
      if (form.elements.id) form.elements.id.value = variantId;
    }

    var basePriceCents = parseInt(input.dataset.modelPriceCents || root.dataset.basePriceCents || "0", 10) || 0;
    var baseCompareAtPriceCents = parseInt(input.dataset.modelCompareAtPriceCents || "0", 10) || 0;
    root.dataset.basePriceCents = String(basePriceCents);
    root.dataset.baseCompareAtPriceCents = String(baseCompareAtPriceCents);
    return {
      basePriceCents: basePriceCents,
      baseCompareAtPriceCents: baseCompareAtPriceCents
    };
  }

  function updateMainProductPriceBlock(root, priceCents, compareAtPriceCents, currency, locale) {
    var section = root.closest && root.closest(".s-main-product");
    if (!section) return;

    var priceBlock = section.querySelector(".js-main-product__price-container");
    if (!priceBlock) return;

    // Same markup as snippets/main-product-price.liquid: current price + market
    // currency code, and the CA/US market note (server-rendered) is kept below it.
    var marketNote = priceBlock.querySelector(".s-main-product__market-note");
    var codeHtml = ' <span class="s-main-product__currency">' + escapeHtml(String(currency || "CAD").toUpperCase()) + "</span>";
    var priceHtml = escapeHtml(formatMoney(priceCents, currency, locale)) + codeHtml;
    if (compareAtPriceCents > priceCents) {
      var discountPercentage = Math.floor(((compareAtPriceCents - priceCents) * 100) / compareAtPriceCents);
      priceBlock.innerHTML = [
        '<span class="s-main-product__price s-main-product__price--discount">',
        '<span class="visually-hidden">', escapeHtml(localize({ en: "Regular price", fr: "Prix régulier" }, locale)), '</span> ',
        escapeHtml(formatMoney(compareAtPriceCents, currency, locale)),
        '</span>',
        '<span class="s-main-product__compare-at-price">',
        '<span class="visually-hidden">', escapeHtml(localize({ en: "Sale price", fr: "Prix réduit" }, locale)), '</span> ',
        priceHtml,
        '</span>',
        '<div class="s-main-product__tags"><span class="s-main-product__tag">-',
        discountPercentage,
        '%</span></div>'
      ].join("");
    } else {
      priceBlock.innerHTML = '<span class="s-main-product__price">' + priceHtml + '</span>';
    }
    if (marketNote) priceBlock.appendChild(marketNote);
  }

  function setPropertyInputValue(form, property, value, overwrite) {
    var controls = Array.prototype.slice.call(form.querySelectorAll('[name="properties[' + cssEscape(property) + ']"]'));
    var target = controls.find(function (control) {
      return control.type !== "radio" && control.type !== "checkbox";
    });
    if (!target) return;
    if (!overwrite && String(target.value || "").trim()) return;
    target.value = value || "";
  }

  function submitBuilder(root, form, addonMap, currency, locale, basePriceCents, baseCompareAtPriceCents) {
    var totals = calculateTotals(form, addonMap, basePriceCents, baseCompareAtPriceCents);
    var missing = totals.paidSelections.filter(function (selection) {
      return !selection.addonVariantId;
    });

    if (missing.length > 0) {
      showMessage(root, localize({
        en: "We could not add the paid options for: " + missing.map(function (selection) {
          return selection.label;
        }).join(", ") + ". Please contact us or try again.",
        fr: "Nous n'avons pas pu ajouter les options payantes suivantes : " + missing.map(function (selection) {
          return selection.label;
        }).join(", ") + ". Veuillez nous contacter ou réessayer."
      }, locale), false);
      return;
    }

    var variantId = parseInt(root.dataset.variantId || form.elements.id.value, 10);
    if (!Number.isFinite(variantId)) {
      showMessage(root, "Missing product variant ID.", false);
      return;
    }

    setSubmitState(root, "loading");

    var bundleId = "smcb-" + Date.now() + "-" + Math.random().toString(16).slice(2);
    setHidden(form, "bundle-id", bundleId);
    setHidden(form, "public-bundle-id", bundleId);
    updateProperties(root, form, addonMap, currency, locale, basePriceCents, baseCompareAtPriceCents);

    var parentProperties = collectProperties(form);
    var editState = encodeEditState(form);
    parentProperties["_Builder Bundle ID"] = bundleId;
    parentProperties["Builder Bundle ID"] = bundleId;
    parentProperties["_Builder State"] = editState;
    parentProperties["_Builder Edit URL"] = buildBuilderEditUrl(editState);

    var items = [{
      id: variantId,
      quantity: 1,
      properties: parentProperties
    }];

    totals.paidSelections.forEach(function (selection) {
      var addonId = parseInt(selection.addonVariantId, 10);
      if (Number.isFinite(addonId)) {
        items.push({
          id: addonId,
          quantity: 1,
          properties: {
            "_Builder Bundle ID": bundleId,
            "Builder Bundle ID": bundleId,
            "_Builder Parent Variant": String(variantId),
            "Builder Parent Variant": String(variantId),
            "_Builder product": root.dataset.productTitle || "Custom cover",
            "_Builder option": selection.label,
            "_Builder key": selection.key
          }
        });
      }
    });

    fetch(cartAddFormUrl(root.dataset.cartAddUrl), {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/javascript"
      },
      credentials: "same-origin",
      body: buildCartAddFormData(items)
    })
      .then(function (response) {
        return response.text().then(function (text) {
          if (!response.ok && response.status === 401) {
            submitCartAddForm(root.dataset.cartAddUrl, items);
            return { submittedByForm: true };
          }
          if (!response.ok) throw new Error(cartErrorMessage(text, response.status));
          return parseJson(text || "{}", {});
        });
      })
      .then(function (result) {
        if (result && result.submittedByForm) return result;
        var editLineKey = editLineKeyFromUrl();
        if (editLineKey) return removeCartBundleForLine(editLineKey);
      })
      .then(function (result) {
        if (result && result.submittedByForm) return result;
        return updateBuilderOrderNote(root, form, bundleId, totals, currency, locale);
      })
      .then(function (result) {
        if (result && result.submittedByForm) return;
        if (result && result.noteUpdateFailed) {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.dispatchEvent(new CustomEvent("cart:updated"));
          setSubmitState(root, "added");
          showMessage(root, result.message, false);
          return;
        }
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:updated"));
        setSubmitState(root, "added");
        showMessage(root, localize({ en: "Added to cart.", fr: "Ajoute au panier." }, locale), true);
        window.setTimeout(function () {
          window.location.href = cartUrlFromAddUrl(root.dataset.cartAddUrl);
        }, 300);
      })
      .catch(function (error) {
        setSubmitState(root, "idle");
        showMessage(root, error.message, false);
      });
  }

  function cartErrorMessage(text, status) {
    var fallback = "Unable to add this custom cover to cart.";
    var payload = parseJson(text || "", null);
    if (payload && typeof payload === "object") {
      return payload.description ||
        payload.message ||
        payload.error ||
        payload.status ||
        fallback;
    }
    var raw = String(text || "").replace(/\s+/g, " ").trim();
    if (raw) {
      return fallback + " Shopify returned " + (status ? "HTTP " + status + ": " : "") + raw.slice(0, 220);
    }
    return status ? fallback + " Shopify returned HTTP " + status + "." : fallback;
  }

  function editLineKeyFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get("smcb_line") || "";
    } catch {
      return "";
    }
  }

  function removeCartBundleForLine(lineKey) {
    return fetch("/cart.js", {
      headers: {
        "Accept": "application/json"
      },
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (text) {
            throw new Error(cartErrorMessage(text, response.status));
          });
        }
        return response.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var editedItem = items.find(function (item) {
          return item.key === lineKey;
        });

        if (!editedItem) return null;

        var bundleId = cartItemBundleId(editedItem);
        if (!bundleId) return removeCartLine(lineKey);

        var updates = {};
        items.forEach(function (item) {
          if (cartItemBundleId(item) === bundleId) {
            updates[item.key] = 0;
          }
        });

        if (!Object.keys(updates).length) updates[lineKey] = 0;
        return updateCartLines(updates);
      });
  }

  function updateCartLines(updates) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error(cartErrorMessage(text, response.status));
        });
      }
      return response.json();
    });
  }

  function cartItemBundleId(item) {
    if (!item || !item.properties) return "";
    if (Array.isArray(item.properties)) {
      for (var i = 0; i < item.properties.length; i += 1) {
        var property = item.properties[i];
        var key = property && (property[0] || property.name || property.key);
        if (key === "Builder Bundle ID" || key === "_Builder Bundle ID") {
          return String(property[1] || property.value || "");
        }
      }
      return "";
    }

    return String(item.properties["Builder Bundle ID"] || item.properties["_Builder Bundle ID"] || "");
  }

  function removeCartLine(lineKey) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error(cartErrorMessage(text, response.status));
        });
      }
      return response.json();
    });
  }

  function updateBuilderOrderNote(root, form, bundleId, totals, currency, locale) {
    var block = buildBuilderOrderNoteBlock(root, form, bundleId, totals, currency, locale);

    return fetch("/cart.js", {
      headers: {
        "Accept": "application/json"
      },
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (text) {
            throw new Error(cartErrorMessage(text, response.status));
          });
        }
        return response.json();
      })
      .then(function (cart) {
        var bundleIds = cartBuilderBundleIds(cart);
        bundleIds[bundleId] = true;

        var currentNote = String(cart.note || "");
        var nextNote = upsertBuilderOrderNoteBlock(currentNote, bundleId, bundleIds, block);
        if (nextNote === currentNote) return cart;

        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({ note: nextNote })
        }).then(function (response) {
          if (!response.ok) {
            return response.text().then(function (text) {
              throw new Error(cartErrorMessage(text, response.status));
            });
          }
          return response.json();
        });
      })
      .catch(function (error) {
        if (window.console && window.console.warn) {
          window.console.warn("Unable to update builder order note:", error);
        }
        return {
          noteUpdateFailed: true,
          message: localize({
            en: "Added to cart, but the order note could not be updated. Please review the cart note before checkout.",
            fr: "Ajouté au panier, mais la note de commande n'a pas pu être mise à jour. Veuillez vérifier la note du panier avant de passer à la caisse."
          }, locale)
        };
      });
  }

  function cartBuilderBundleIds(cart) {
    var ids = Object.create(null);
    (cart.items || []).forEach(function (item) {
      var id = cartItemBundleId(item);
      if (id) ids[id] = true;
    });
    return ids;
  }

  function buildBuilderOrderNoteBlock(root, form, bundleId, totals, currency, locale) {
    var lines = [
      builderNoteStartLine(bundleId),
      "Product: " + (root.dataset.productTitle || "Custom cover"),
      "Builder Bundle ID: " + bundleId,
      "Estimated Builder Total: " + formatMoney(totals.totalCents, currency, locale) + " " + String(currency || "CAD").toUpperCase()
    ];
    var rows = builderOrderNoteRows(form, locale);
    var used = Object.create(null);

    appendBuilderNoteSection(lines, "Measurements", builderNoteSectionRows(rows, [
      "Hot Tub Model",
      "Swim Spa Model",
      "Factory Fit Model",
      "Selected Size",
      "Cover Shape",
      "Cover Length A",
      "Cover Width B",
      "Cover Dimension C",
      "Corner Radius Measurement",
      "Corner Radius",
      "Cover Dimension D",
      "Speaker Pocket Count",
      "Fold Orientation",
      "Strap Placement"
    ], used));

    appendBuilderNoteSection(lines, "Cover Options", builderNoteSectionRows(rows, [
      "Cover Thickness",
      "Material & Color",
      "Skirt Length"
    ], used));

    appendBuilderNoteSection(lines, "Upgrades & Accessories", builderNoteSectionRows(rows, [
      "Lifter Plates",
      "Cover Upgrades",
      "Bundle Accessories"
    ], used));

    appendBuilderNoteSection(lines, "Production Notes", builderNoteSectionRows(rows, [
      "Special Instructions"
    ], used));

    appendBuilderNoteSection(lines, "Other Details", rows.filter(function (row) {
      return !used[row.key];
    }));

    lines.push(builderNoteEndLine(bundleId));
    return lines.join("\n");
  }

  function builderOrderNoteRows(form, locale) {
    var rows = [];
    var grouped = Object.create(null);

    function addRow(key, value) {
      var label = String(key || "").trim();
      var text = builderNoteValue(label, value, locale);
      if (!label || !text) return;
      if (!grouped[label]) {
        grouped[label] = [];
        rows.push({ key: label, value: "" });
      }
      if (grouped[label].indexOf(text) === -1) grouped[label].push(text);
    }

    selectedPropertyRows(form).forEach(function (row) {
      addRow(row.key, row.value);
    });

    getHiddenListNames(form).forEach(function (name) {
      addRow(name, propertyValue(form, name));
    });

    rows.forEach(function (row) {
      row.value = grouped[row.key].join(", ");
    });

    return rows.filter(function (row) {
      return row.value;
    });
  }

  function builderNoteValue(key, value, locale) {
    var text = String(value || "").replace(/\s+/g, " ").trim();
    if (!text) return "";
    if (key === "Corner Radius Measurement" && normalizeToken(text) === normalizeToken(localize(CORNER_RADIUS_HELP_VALUE, locale))) {
      return localize(CORNER_RADIUS_HELP_SUMMARY, locale);
    }
    if (builderNoteDimensionKey(key) && plainNumber(text)) return inchesLabel(text, locale);
    return text;
  }

  function builderNoteDimensionKey(key) {
    return [
      "Cover Length A",
      "Cover Width B",
      "Cover Dimension C",
      "Corner Radius",
      "Cover Dimension D"
    ].indexOf(key) !== -1;
  }

  function plainNumber(value) {
    return /^-?\d+(?:[.,]\d+)?$/.test(String(value || "").trim());
  }

  function builderNoteSectionRows(rows, keys, used) {
    return keys.map(function (key) {
      return rows.find(function (row) {
        return row.key === key;
      });
    }).filter(function (row) {
      if (!row) return false;
      used[row.key] = true;
      return true;
    });
  }

  function appendBuilderNoteSection(lines, title, rows) {
    if (!rows || !rows.length) return;
    lines.push("");
    lines.push(title);
    rows.forEach(function (row) {
      lines.push("- " + row.key + ": " + row.value);
    });
  }

  function upsertBuilderOrderNoteBlock(note, bundleId, activeBundleIds, block) {
    var lines = String(note || "").split(/\r?\n/);
    var kept = [];

    for (var i = 0; i < lines.length; i += 1) {
      var existingBundleId = builderNoteBundleId(lines[i]);
      if (!existingBundleId) {
        kept.push(lines[i]);
        continue;
      }

      var blockLines = [lines[i]];
      var hasEnd = false;
      i += 1;
      while (i < lines.length) {
        blockLines.push(lines[i]);
        if (isBuilderNoteEndLine(lines[i])) {
          hasEnd = true;
          break;
        }
        i += 1;
      }

      if (!hasEnd) {
        kept = kept.concat(blockLines);
        continue;
      }
      if (existingBundleId === bundleId || !activeBundleIds[existingBundleId]) continue;
      kept = kept.concat(blockLines);
    }

    while (kept.length && !String(kept[kept.length - 1]).trim()) kept.pop();
    if (kept.length) kept.push("");
    return kept.concat(block.split("\n")).join("\n");
  }

  function builderNoteStartLine(bundleId) {
    return BUILDER_NOTE_START + bundleId + " -----";
  }

  function builderNoteEndLine(bundleId) {
    return BUILDER_NOTE_END + bundleId + " -----";
  }

  function builderNoteBundleId(line) {
    var text = String(line || "");
    if (text.indexOf(BUILDER_NOTE_START) !== 0) return "";
    return text.slice(BUILDER_NOTE_START.length).replace(/\s*-+\s*$/, "").trim();
  }

  function isBuilderNoteEndLine(line) {
    return String(line || "").indexOf(BUILDER_NOTE_END) === 0;
  }

  function buildBuilderEditUrl(editState) {
    var baseUrl = window.location.origin + window.location.pathname;
    return baseUrl + "?smcb_edit=" + encodeURIComponent(editState);
  }

  function applyEditStateFromUrl(form) {
    var state = editStateFromUrl() || legacyEditStateFromUrl() || thicknessSelectionFromUrl();
    if (!state) return;

    var controls = Array.prototype.slice.call(form.querySelectorAll("input[type='radio'], input[type='checkbox']"));
    (state.checked || []).forEach(function (item) {
      var match = controls.find(function (input) {
        if (item.key && input.dataset.optionKey === item.key) return true;
        if (item.name && input.name === item.name && input.value === item.value) return true;
        return item.label && normalizeEditLabel(input.dataset.optionLabel || input.value) === normalizeEditLabel(item.label);
      });
      if (match) match.checked = true;
    });

    (state.values || []).forEach(function (item) {
      var input = Array.prototype.slice.call(form.querySelectorAll("input, select, textarea")).find(function (control) {
        return control.name === item.name;
      });
      if (input) input.value = item.value;
    });
  }

  function editStateFromUrl() {
    try {
      var value = new URLSearchParams(window.location.search).get("smcb_edit");
      if (!value) return null;
      return JSON.parse(base64UrlDecode(value));
    } catch {
      return null;
    }
  }

  function legacyEditStateFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("smcb_legacy") !== "1") return null;

      var checked = [];
      var values = [];
      var addChecked = function (param, name) {
        var value = params.get(param);
        if (value) checked.push({ name: name, value: value, label: value });
      };
      var addValue = function (param, name) {
        var value = params.get(param);
        if (value) values.push({ name: name, value: value });
      };
      var addList = function (param) {
        parseLegacyList(params.get(param)).forEach(function (label) {
          checked.push({ label: label });
        });
      };

      addChecked("smcb_cover_thickness", "properties[Cover Thickness]");
      addChecked("smcb_shape", "properties[Cover Shape]");
      addChecked("smcb_material", "properties[Material & Color]");
      addChecked("smcb_skirt", "properties[Skirt Length]");
      addChecked("smcb_strap", "properties[Strap Placement]");
      addChecked("smcb_fold", "properties[Fold Orientation]");
      addValue("smcb_length", "properties[Cover Length A]");
      addValue("smcb_width", "properties[Cover Width B]");
      addValue("smcb_radius", "properties[Corner Radius]");
      addList("smcb_cover_upgrades");
      addList("smcb_accessories");

      if (!checked.length && !values.length) return null;
      return { checked: checked, values: values };
    } catch {
      return null;
    }
  }

  // Lets a collection-page thickness choice (e.g. the Classic/Premium/Extreme
  // compare cards) deep-link into the builder with that tier preselected via
  // ?smcb_thickness=classic|premium|extreme. Matches on the option key so it
  // stays correct even if the displayed value text changes.
  function thicknessSelectionFromUrl() {
    try {
      var value = new URLSearchParams(window.location.search).get("smcb_thickness");
      if (!value) return null;
      var id = String(value).trim().toLowerCase();
      if (["classic", "premium", "extreme"].indexOf(id) === -1) return null;
      return { checked: [{ key: "thickness:" + id }] };
    } catch {
      return null;
    }
  }

  function applyManualModelFromUrl(form, locale) {
    try {
      var input = modelSearchInput(form);
      var value = new URLSearchParams(window.location.search).get("smcb_model");
      if (!input || input.value || !value) return;
      input.value = value.trim();
      var search = form.querySelector(".smcbx__model-search-input");
      if (search) search.value = input.value;
      syncManualModelStatus(form, locale);
    } catch {
      return;
    }
  }

  function parseLegacyList(value) {
    if (!value) return [];
    return String(value).split(/\s*,\s*/).map(stripLegacyPrice).filter(Boolean);
  }

  function stripLegacyPrice(value) {
    return String(value || "").replace(/\s*\(\+[^)]*\)\s*$/, "").trim();
  }

  function normalizeEditLabel(value) {
    return stripLegacyPrice(value).toLowerCase().replace(/\s+/g, " ");
  }

  function encodeEditState(form) {
    var state = {
      checked: [],
      values: []
    };

    Array.prototype.slice.call(form.querySelectorAll("input[type='radio'], input[type='checkbox']")).forEach(function (input) {
      if (!input.checked || !input.name) return;
      state.checked.push({
        name: input.name,
        value: input.value,
        key: input.dataset.optionKey || ""
      });
    });

    Array.prototype.slice.call(form.querySelectorAll("input[type='number'], input[type='text'], input[type='hidden'], select, textarea")).forEach(function (input) {
      var propertyName = propertyNameFromInput(input);
      if (!input.name || (input.type === "hidden" && propertyName !== "Hot Tub Make & Model")) return;
      state.values.push({
        name: input.name,
        value: String(input.value || "")
      });
    });

    return base64UrlEncode(JSON.stringify(state));
  }

  function base64UrlEncode(value) {
    var binary = "";
    new TextEncoder().encode(value).forEach(function (byte) {
      binary += String.fromCharCode(byte);
    });
    return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }

  function base64UrlDecode(value) {
    var base64 = String(value || "").replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) base64 += "=";
    var binary = atob(base64);
    var bytes = new Uint8Array(binary.length);
    for (var index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }
    return new TextDecoder().decode(bytes);
  }

  function updateVisibility(root, form) {
    var state = getFieldState(form);
    var coverType = Array.isArray(state.cover_type) ? state.cover_type[0] : state.cover_type;
    var isRollaway = coverType === "Rollaway";
    root.querySelectorAll("[data-visible-when], [data-hide-for-rollaway], [data-show-for-rollaway]").forEach(function (node) {
      var visible = true;
      if (node.dataset.visibleWhen) {
        visible = matchesCondition(parseJson(node.dataset.visibleWhen, null), state);
        if (visible && isFoldOrientationVisibilityNode(node)) {
          visible = foldOrientationFieldApplies(form);
        }
        if (visible && isRollOrientationVisibilityNode(node)) {
          visible = rollOrientationFieldApplies(form);
        }
      }
      if (visible && node.dataset.hideForRollaway === "true" && isRollaway) visible = false;
      if (visible && node.dataset.showForRollaway === "true" && !isRollaway) visible = false;
      node.hidden = !visible;
      node.querySelectorAll("input, select, textarea, button").forEach(function (control) {
        control.disabled = !visible;
      });
    });
    ensureVisibleSelection(form);
    applyRollOrientationDefault(form);
    root.querySelectorAll("[data-aquatex-note]").forEach(function (note) {
      var heading = note.querySelector("[data-aquatex-note-heading]");
      if (!heading) return;
      var paid = note.dataset.paid === "true" && !isRollaway;
      heading.textContent = localize(paid ? "Upgrade to AquaTEX™" : "AquaTEX™ premium fabric", root.dataset.locale || "en");
    });
    updatePhaseVisibility(form);
  }

  // A phase whose every field just got hidden (e.g. "Upgrades" when Rollaway is
  // selected — rollaway covers have no upgrade list) would otherwise show an empty
  // numbered heading. Hide those phases and renumber the visible ones so the step
  // counter stays gapless (1, 2, 3 — not 1, 2, 4). Phases with no field at all are
  // left untouched.
  function updatePhaseVisibility(form) {
    var visibleCount = 0;
    Array.prototype.slice.call(form.querySelectorAll(".smcbx__phase")).forEach(function (phase) {
      var fieldsets = Array.prototype.slice.call(phase.querySelectorAll("fieldset[data-field-id]"));
      if (fieldsets.length) {
        phase.hidden = !fieldsets.some(function (fs) { return !fs.hidden; });
      }
      if (phase.hidden) return;
      visibleCount += 1;
      var num = phase.querySelector(".smcbx__phase-num");
      if (num) num.textContent = String(visibleCount);
    });
  }

  // After visibility changes, a radio field whose checked option just became
  // hidden (e.g. the traditional material when switching to Rollaway) would have
  // no active selection. Move the selection to the first still-visible option so
  // required radio fields always carry a valid value. Fields with nothing checked
  // (like fold orientation, which starts unselected on purpose) are left alone.
  function ensureVisibleSelection(form) {
    Array.prototype.slice.call(form.querySelectorAll("fieldset[data-field-id]")).forEach(function (fieldset) {
      var radios = Array.prototype.slice.call(fieldset.querySelectorAll("input[type='radio']"));
      if (radios.length === 0) return;
      var checked = radios.filter(function (radio) { return radio.checked; })[0];
      if (!checked) return;
      if (isActiveControl(checked)) return;
      var active = radios.filter(isActiveControl);
      if (!active.length) return;
      var preferred = active.filter(function (radio) { return radio.dataset.defaultOption === "true"; })[0];
      (preferred || active[0]).checked = true;
    });
  }

  function updateProperties(root, form, addonMap, currency, locale, basePriceCents, baseCompareAtPriceCents) {
    syncManualModelStatus(form, locale);
    updateClassicThicknessWarnings(form, locale);
    updateSizeContext(root, form, currency, locale);

    var listNames = getHiddenListNames(form);
    var grouped = {};
    listNames.forEach(function (name) {
      grouped[name] = [];
    });

    getSelectedOptions(form, addonMap).forEach(function (selection) {
      if (!selection.listName || !grouped[selection.listName]) return;
      grouped[selection.listName].push(selection.label + (selection.priceCents > 0 ? " (+" + formatMoney(selection.priceCents, currency, locale) + ")" : ""));
    });

    Object.keys(grouped).forEach(function (name) {
      setHidden(form, "list:" + name, grouped[name].join(", "));
    });

    updateLivePreview(root, form, locale);
    updateFoldDimensionDescriptions(form, locale);
    updateRollDimensionDescriptions(form, locale);
    setHidden(form, "cover-details", buildCoverDetails(form, grouped));
    setHidden(form, "base-summary", buildBaseSummary(form, locale));
    setHidden(form, "cart-details", buildCartDetails(form, addonMap, currency, locale));

    var totals = calculateTotals(form, addonMap, basePriceCents, baseCompareAtPriceCents);
    var totalText = formatMoney(totals.totalCents, currency, locale);
    var compareTotalText = totals.savingsCents > 0 ? formatMoney(totals.compareAtTotalCents, currency, locale) : "";
    var savingsText = totals.savingsCents > 0 ? savingsLabel(formatMoney(totals.savingsCents, currency, locale), locale) : "";
    setText(root, "[data-base-price]", formatMoney(basePriceCents, currency, locale));
    setText(root, "[data-addon-price]", formatMoney(totals.addonCents, currency, locale));
    setText(root, "[data-total-price]", totalText);
    setTextAll(root, "[data-detail-total]", totalText);
    setTextAll(root, "[data-compare-total]", compareTotalText);
    setTextAll(root, "[data-detail-compare-total]", compareTotalText);
    setTextAll(root, "[data-savings]", savingsText);
    setTextAll(root, "[data-detail-savings]", savingsText);
    root.querySelectorAll("[data-compare-price], [data-savings-badge]").forEach(function (node) {
      node.hidden = totals.savingsCents <= 0;
    });
    setHidden(form, "total", totalText);
    setHidden(form, "compare-total", compareTotalText);
    setHidden(form, "savings", savingsText);
    setHidden(form, "addon-keys", totals.paidSelections.map(function (selection) {
      return selection.key;
    }).join(", "));
    setHidden(form, "addon-variant-ids", totals.paidSelections.map(function (selection) {
      return selection.addonVariantId;
    }).filter(Boolean).join(", "));
    root.querySelectorAll("[data-upgrade-line]").forEach(function (node) {
      node.classList.toggle("is-visible", totals.addonCents > 0);
    });
    updateSpecList(root, form, locale);
    updateSectionStatuses(form, currency, locale);
  }

  function updateLivePreview(root, form, locale) {
    var preview = builderQuery(root, "[data-live-preview]");
    if (!preview) return;

    // Model pages carry Rollaway as an inline cover-type option (a priced upgrade),
    // not a separate product. Switch either model family to the rollaway diagram
    // (ribs + roll straps, no fold line) whenever Rollaway is picked. Recompute from
    // the group id each call so toggling back restores the Traditional preview.
    var baseFamily = previewFamilyForGroupId(preview.dataset.groupId || "");
    var coverTypeInput = checkedField(form, "cover_type");
    var isRollawayCoverType = Boolean(coverTypeInput && coverTypeInput.value === "Rollaway");
    var previewFamily = isRollawayCoverType ? "rollaway" : baseFamily;
    preview.dataset.previewFamily = previewFamily;
    var defaultDimensions = defaultPreviewDimensions(previewFamily, preview.dataset.groupId || "");
    var shapeInput = checkedField(form, "cover_shape") || checkedField(form, "rollaway_cover_shape");
    var hiddenShapeLabel = propertyValue(form, "Cover Shape");
    var materialInput = checkedField(form, "material_color") || checkedField(form, "rollaway_material_color");
    var strapInput = checkedField(form, "strap_placement") || checkedField(form, "rollaway_strap_placement");
    var foldInput = checkedField(form, "fold_orientation") || checkedField(form, "rollaway_fold_orientation");
    var rollInput = checkedField(form, "roll_orientation") || checkedField(form, "rollaway_roll_orientation");
    var hasShapeInput = Boolean(shapeInput || hiddenShapeLabel);
    var shapeLabel = shapeInput ? shapeInput.dataset.optionLabel || shapeInput.value : hiddenShapeLabel || "Rounded square / rectangle";
    var template = shapeInput ? shapeInput.dataset.measurementTemplate || measurementTemplateFor(shapeLabel) : measurementTemplateFor(shapeLabel);
    updateMeasurementUi(form, template, locale);
    var lengthValue = propertyValue(form, "Cover Length A");
    var widthValue = propertyValue(form, "Cover Width B");
    var radiusValue = propertyValue(form, "Corner Radius");
    var length = lengthValue || String(defaultDimensions.length);
    var width = widthValue || String(defaultDimensions.width);
    var radius = radiusValue || "8";
    var materialLabel = materialInput ? materialInput.dataset.optionLabel || materialInput.value : "Black Vinyl";
    var materialFamily = materialInput ? materialInput.dataset.materialFamily || materialFamilyFor({ label: materialLabel, value: materialLabel }) : "vinyl";
    var swatch = materialInput ? materialInput.dataset.swatch || "#171717" : "#171717";
    var kind = shapeKind(shapeLabel);
    var foldLabel = foldInput ? foldInput.dataset.optionLabel || foldInput.value : "Fold A";
    var foldOrientation = foldKind(foldLabel);
    var foldApplies = previewFamily === "hot-tub" && kind !== "round" && foldOrientationFieldApplies(form);
    var rollLabel = rollInput ? rollInput.dataset.optionLabel || rollInput.value : "";
    var rollAxis = rollOrientationFieldApplies(form) ? rollKind(rollLabel) : "";
    var cutValue = propertyValue(form, "Cover Dimension C");

    preview.dataset.shapeKind = kind;
    preview.dataset.foldOrientation = foldOrientation;
    preview.dataset.materialFamily = materialFamily;
    preview.dataset.materialTone = materialTone(materialLabel, materialFamily);
    preview.dataset.strapPlacement = strapKind(strapInput ? strapInput.dataset.optionLabel || strapInput.value : "");
    preview.style.setProperty("--smcbx-cover-color", swatch);

    setMeasurementLabel(preview, "[data-dim-a-label]", lengthValue, locale);
    setMeasurementLabel(preview, "[data-dim-b-label]", widthValue, locale);
    setMeasurementLabel(preview, "[data-radius-label]", radiusValue, locale);
    setMeasurementLabel(preview, "[data-cut-label]", cutValue, locale);
    setText(root, "[data-size-label]", previewSizeLabel(template, lengthValue, widthValue, radiusValue, cutValue, locale));
    setText(root, "[data-material-label]", materialLabel);
    setText(root, "[data-shape-label]", hasShapeInput ? shapeLabel : "");
    setFoldLabel(root, foldLabel, foldApplies);
    updatePreviewGeometry(preview, template, length, width, radius, cutValue, foldOrientation, rollAxis);
  }

  function updatePreviewGeometry(preview, template, lengthValue, widthValue, radiusValue, cutValue, foldOrientation, rollAxis) {
    var kind = preview.dataset.shapeKind || "rounded";
    var fold = foldOrientation || "horizontal";

    var length = positiveNumber(lengthValue, 84);
    var width = positiveNumber(widthValue, length);
    var family = preview.dataset.previewFamily || "hot-tub";
    var radius = Math.max(0, positiveNumber(radiusValue, kind === "rounded" ? 8 : 0, true));
    var cut = Math.max(0, positiveNumber(cutValue, 0, true));
    var bounds = previewBounds(length, width);
    var x = bounds.x;
    var y = bounds.y;
    var w = bounds.w;
    var h = bounds.h;
    var rawRx = template === "a_b_c_radius" && kind === "rounded"
      ? radius / Math.max(1, Math.min(length, width)) * Math.min(w, h)
      : 2;
    var rx = kind === "rounded" ? clamp(rawRx, 0, Math.min(w, h) / 2) : 2;

    if (family === "swim-spa") {
      updateSwimSpaPreviewGroup(preview.querySelector(".smcbx__shape-swim-spa"), x, y, w, h, length, width, rx, kind);
      return;
    }

    if (family === "rollaway") {
      if (kind === "round") {
        updateRollawayRoundPreviewGroup(preview.querySelector(".smcbx__shape-round"), length);
        return;
      }
      if (kind === "octagon") {
        updateRollawayOctagonPreviewGroup(preview.querySelector(".smcbx__shape-octagon"), x, y, w, h, length, width, rollAxis);
        return;
      }
      if (kind === "fourcut") {
        updateCutShapePreviewGroup(preview.querySelector(".smcbx__shape-fourcut"), x, y, w, h, cut, 0, length, "fourcut", fold, true, width);
        return;
      }
      if (kind === "onecut") {
        updateCutShapePreviewGroup(preview.querySelector(".smcbx__shape-onecut"), x, y, w, h, cut, radius, length, "onecut", fold, true, width);
        return;
      }
      if (kind === "twocut") {
        updateCutShapePreviewGroup(preview.querySelector(".smcbx__shape-twocut"), x, y, w, h, cut, radius, length, "twocut", fold, true, width);
        return;
      }
      if (kind === "bowed") {
        updateBowedPreviewGroup(preview.querySelector(".smcbx__shape-bowed"), x, y, w, h, radius, length, fold, true, width);
        return;
      }
      if (kind === "custom") {
        updateCustomShapePreviewGroup(preview.querySelector(".smcbx__shape-custom"), x, y, w, h, length, width, true);
        return;
      }
      updateRollawayPreviewGroup(preview.querySelector(".smcbx__shape-rollaway"), x, y, w, h, length, width, rx, rollAxis);
      return;
    }

    updateRectPreviewGroup(preview.querySelector(".smcbx__shape-rounded"), x, y, w, h, rx, true, fold);
    updateRectPreviewGroup(preview.querySelector(".smcbx__shape-square"), x, y, w, h, kind === "square" ? 0 : rx, false, fold);
    updateRoundPreviewGroup(preview.querySelector(".smcbx__shape-round"), length);
    updateOctagonPreviewGroup(preview.querySelector(".smcbx__shape-octagon"), x, y, w, h);
    updateCutShapePreviewGroup(preview.querySelector(".smcbx__shape-fourcut"), x, y, w, h, cut, 0, length, "fourcut", fold, false, width);
    updateCutShapePreviewGroup(preview.querySelector(".smcbx__shape-onecut"), x, y, w, h, cut, radius, length, "onecut", fold, false, width);
    updateCutShapePreviewGroup(preview.querySelector(".smcbx__shape-twocut"), x, y, w, h, cut, radius, length, "twocut", fold, false, width);
    updateBowedPreviewGroup(preview.querySelector(".smcbx__shape-bowed"), x, y, w, h, radius, length, fold, false, width);
    updateCustomShapePreviewGroup(preview.querySelector(".smcbx__shape-custom"), x, y, w, h, length, width, false);
  }

  function updateSwimSpaPreviewGroup(group, x, y, w, h, lengthValue, widthValue, rx, shapeKind) {
    if (!group) return;
    var shadow = group.querySelector(".smcbx__cover-shadow");
    var top = group.querySelector(".smcbx__cover-top");
    var panelLines = group.querySelector(".smcbx__swim-panel-lines");
    var velcroLines = group.querySelector(".smcbx__swim-velcro-lines");
    var straps = group.querySelector(".smcbx__swim-straps");
    var handles = group.querySelectorAll(".smcbx__handle");
    var arrows = group.querySelectorAll(".smcbx__measure-arrow");
    var corner = group.querySelector(".smcbx__corner-guide");
    var letters = group.querySelectorAll(".smcbx__measure-letter");
    var connectors = ensureMeasureConnectors(group, 5);
    var longSideIsVertical = lengthValue >= widthValue;
    var longValue = longSideIsVertical ? lengthValue : widthValue;
    var plan = swimSpaPanelPlan(longValue);
    var coverRadius = shapeKind === "square" ? 0 : clamp(Number.isFinite(rx) ? rx : 18, 0, Math.min(w, h) / 2);

    setRectAttrs(shadow, x + 16, y + 18, w, h, coverRadius + 4);
    setRectAttrs(top, x, y, w, h, coverRadius);
    replaceSvgPaths(panelLines, plan.hingeFractions.map(function (fraction) {
      if (!longSideIsVertical) {
        var xx = x + w * fraction;
        return linePath(xx, y + 8, xx, y + h - 8);
      }
      var yy = y + h * fraction;
      return linePath(x + 8, yy, x + w - 8, yy);
    }), "smcbx__swim-panel-line");
    replaceSvgPaths(velcroLines, plan.velcroFractions.map(function (fraction) {
      if (!longSideIsVertical) {
        var xx = x + w * fraction;
        return linePath(xx, y + 12, xx, y + h - 12);
      }
      var yy = y + h * fraction;
      return linePath(x + 12, yy, x + w - 12, yy);
    }), "smcbx__swim-velcro-line");

    var note = group.querySelector("[data-preview-note]");
    if (note) note.textContent = "";

    updateSimpleRectMeasurements(group, arrows, letters, connectors, x, y, w, h);
    updateCornerRadiusMeasurement(group, arrows[4], corner, letters[2], connectors, x, y, w, h, coverRadius, shapeKind === "rounded");
    updateSwimSpaStraps(straps, x, y, w, h, longSideIsVertical);
    updateSwimSpaHandles(handles, x, y, w, h, longSideIsVertical);
  }

  /**
   * The ribs run across the roll, not along it, so a cover that rolls along
   * Length A gets horizontal ribs (A is the vertical axis in the preview) and
   * one that rolls along Width B gets vertical ribs. With no answer yet, keep
   * the long-side assumption the preview has always drawn — that is still the
   * common build, and it is what the swim-spa and octagon rollaways use.
   */
  function ribsRunVertical(rollAxis, longSideIsVertical) {
    if (rollAxis === "a") return false;
    if (rollAxis === "b") return true;
    return !longSideIsVertical;
  }

  function updateRollawayPreviewGroup(group, x, y, w, h, lengthValue, widthValue, rx, rollAxis) {
    if (!group) return;
    var shadow = group.querySelector(".smcbx__cover-shadow");
    var top = group.querySelector(".smcbx__cover-top");
    var ribs = group.querySelector(".smcbx__rollaway-ribs");
    var straps = group.querySelectorAll(".smcbx__rollaway-straps rect");
    var arrows = group.querySelectorAll(".smcbx__measure-arrow");
    var corner = group.querySelector(".smcbx__corner-guide");
    var letters = group.querySelectorAll(".smcbx__measure-letter");
    var connectors = ensureMeasureConnectors(group, 5);
    var radiusPx = clamp(Number.isFinite(rx) ? rx : 16, 0, Math.min(w, h) / 2);
    var longSideIsVertical = lengthValue >= widthValue;
    var ribLinesAreVertical = ribsRunVertical(rollAxis, longSideIsVertical);
    var ribTrack = ribLinesAreVertical ? w : h;
    var ribCount = clamp(Math.round(ribTrack / 48), 4, 8);
    var ribPaths = [];

    setRectAttrs(shadow, x + 16, y + 18, w, h, radiusPx + 4);
    setRectAttrs(top, x, y, w, h, radiusPx);

    for (var i = 1; i <= ribCount; i += 1) {
      if (ribLinesAreVertical) {
        var xx = x + (w / (ribCount + 1)) * i;
        ribPaths.push(linePath(xx, y + 10, xx, y + h - 10));
      } else {
        var yy = y + (h / (ribCount + 1)) * i;
        ribPaths.push(linePath(x + 10, yy, x + w - 10, yy));
      }
    }
    replaceSvgPaths(ribs, ribPaths, "smcbx__rollaway-rib");
    updateRollawayStraps(straps, x, y, w, h);

    updateSimpleRectMeasurements(group, arrows, letters, connectors, x, y, w, h, 74);
    updateCornerRadiusMeasurement(group, arrows[4], corner, letters[2], connectors, x, y, w, h, radiusPx, true);
  }

  function updateRollawayRoundPreviewGroup(group, lengthValue) {
    updateRoundPreviewGroup(group, lengthValue);
    if (!group) return;

    var length = positiveNumber(lengthValue, 84);
    var diameter = clamp(length / 84 * 310, 235, 330);
    var radius = diameter / 2;
    var cx = 280;
    var cy = 226;
    var x = cx - radius;
    var y = cy - radius;
    var ribs = group.querySelector(".smcbx__rollaway-ribs");
    var straps = group.querySelectorAll(".smcbx__rollaway-straps rect");
    var ribCount = clamp(Math.round(diameter / 48), 4, 8);
    var ribPaths = [];

    for (var i = 1; i <= ribCount; i += 1) {
      var offset = -radius + (diameter / (ribCount + 1)) * i;
      var chord = Math.sqrt(Math.max(0, radius * radius - offset * offset));
      ribPaths.push(linePath(cx - chord + 8, cy + offset, cx + chord - 8, cy + offset));
    }

    replaceSvgPaths(ribs, ribPaths, "smcbx__rollaway-rib");
    updateRollawayStraps(straps, x, y, diameter, diameter);
  }

  function updateRollawayOctagonPreviewGroup(group, x, y, w, h, lengthValue, widthValue, rollAxis) {
    updateOctagonPreviewGroup(group, x, y, w, h);
    if (!group) return;

    var ribs = group.querySelector(".smcbx__rollaway-ribs");
    var straps = group.querySelectorAll(".smcbx__rollaway-straps rect");
    var longSideIsVertical = lengthValue >= widthValue;
    var ribLinesAreVertical = ribsRunVertical(rollAxis, longSideIsVertical);
    var ribTrack = ribLinesAreVertical ? w : h;
    var ribCount = clamp(Math.round(ribTrack / 48), 4, 8);
    var cut = octagonCut(w, h);
    var ribPaths = [];

    for (var i = 1; i <= ribCount; i += 1) {
      if (ribLinesAreVertical) {
        var xx = x + (w / (ribCount + 1)) * i;
        var yInset = octagonRibInset(xx - x, w, cut);
        ribPaths.push(linePath(xx, y + yInset + 10, xx, y + h - yInset - 10));
      } else {
        var yy = y + (h / (ribCount + 1)) * i;
        var xInset = octagonRibInset(yy - y, h, cut);
        ribPaths.push(linePath(x + xInset + 10, yy, x + w - xInset - 10, yy));
      }
    }

    replaceSvgPaths(ribs, ribPaths, "smcbx__rollaway-rib");
    updateRollawayStraps(straps, x, y, w, h);
  }

  function octagonRibInset(position, extent, cut) {
    if (position < cut) return cut - position;
    if (position > extent - cut) return position - (extent - cut);
    return 0;
  }

  // A Rollaway has two straps per side and none on the corners. Every strap sits
  // the same distance from its nearest corner, so all four sides match.
  function updateRollawayStraps(straps, x, y, w, h) {
    if (!straps || straps.length < 8) return;
    var straightW = clamp(Math.min(w, h) * 0.05, 10, 13);
    var straightH = clamp(Math.min(w, h) * 0.11, 24, 34);
    var sideW = clamp(Math.min(w, h) * 0.11, 24, 34);
    var sideH = clamp(Math.min(w, h) * 0.05, 9, 12);
    var cornerGap = Math.min(w, h) * 0.3;
    var topY = y - straightH;
    var bottomY = y + h;
    var leftX = x - sideW;
    var rightX = x + w;
    var topA = x + cornerGap - straightW / 2;
    var topB = x + w - cornerGap - straightW / 2;
    var sideA = y + cornerGap - sideH / 2;
    var sideB = y + h - cornerGap - sideH / 2;

    setRectAttrs(straps[0], topA, topY, straightW, straightH, straightW / 2);
    setRectAttrs(straps[1], topB, topY, straightW, straightH, straightW / 2);
    setRectAttrs(straps[2], topA, bottomY, straightW, straightH, straightW / 2);
    setRectAttrs(straps[3], topB, bottomY, straightW, straightH, straightW / 2);
    setRectAttrs(straps[4], leftX, sideA, sideW, sideH, sideH / 2);
    setRectAttrs(straps[5], leftX, sideB, sideW, sideH, sideH / 2);
    setRectAttrs(straps[6], rightX, sideA, sideW, sideH, sideH / 2);
    setRectAttrs(straps[7], rightX, sideB, sideW, sideH, sideH / 2);
  }

  function updateSimpleRectMeasurements(group, arrows, letters, connectors, x, y, w, h, sideGap) {
    var aX = Math.max(42, x - (sideGap || 50));
    var aTop = y;
    var aBottom = y + h;
    var aMid = y + h / 2;
    var aGap = 42;
    setPath(arrows[0], linePath(aX, aTop, aX, Math.max(aTop, aMid - aGap)));
    setPath(arrows[1], linePath(aX, Math.min(aBottom, aMid + aGap), aX, aBottom));
    setConnectorPath(connectors, 0, verticalGapPath(aX, aTop, aBottom, aMid - aGap, aMid + aGap), true);
    setTextPosition(letters[0], aX, aMid - 18);
    setPillTransform(group.querySelector("[data-dim-a-label]"), aX - 29, aMid - 2);

    var bY = Math.min(438, y + h + 58);
    var bMid = x + w / 2;
    var bGap = 40;
    setPath(arrows[2], linePath(x, bY, Math.max(x, bMid - bGap), bY));
    setPath(arrows[3], linePath(Math.min(x + w, bMid + bGap), bY, x + w, bY));
    setConnectorPath(connectors, 1, horizontalGapPath(bY, x, x + w, bMid - bGap, bMid + bGap), true);
    setConnectorPath(connectors, 2, "", false);
    setConnectorPath(connectors, 3, "", false);
    setTextPosition(letters[1], bMid, bY - 8);
    setPillTransform(group.querySelector("[data-dim-b-label]"), bMid - 29, bY + 6);
  }

  function updateCornerRadiusMeasurement(group, arrow, corner, letter, connectors, x, y, w, h, radiusPx, showRadius) {
    var visible = Boolean(showRadius && radiusPx > 0.5);
    var cRadius = Math.max(18, Math.round(radiusPx || 0));
    var cGuideGap = 12;
    var cOuterX = x + w + cGuideGap;
    var cGuideTop = y - cGuideGap;
    var cGuideBottom = y + cRadius - cGuideGap;
    var cMid = cGuideTop + cRadius / 2;

    if (corner) {
      corner.style.display = visible ? "" : "none";
      if (visible) {
        setPath(corner, [
          "M", roundCoord(x + w - cRadius + cGuideGap), roundCoord(cGuideTop),
          "H", roundCoord(cOuterX),
          "V", roundCoord(cGuideBottom)
        ].join(" "));
      }
    }
    if (arrow) {
      arrow.style.display = visible ? "" : "none";
      if (visible) {
        var cX = cOuterX + 24;
        setPath(arrow, linePath(cX, cGuideTop, cX, cGuideBottom));
        setConnectorPath(connectors, 2, linePath(cX, cGuideTop, cX, cGuideBottom), true);
        setConnectorPath(connectors, 3, linePath(cX + 7, cMid, cX + 16, cMid), true);
      }
    }
    if (letter) {
      letter.style.display = visible ? "" : "none";
      if (visible) setTextPosition(letter, cOuterX + 48, cMid + 5);
    }
    var radiusLabel = group.querySelector("[data-radius-label]");
    if (radiusLabel) {
      var radiusPill = radiusLabel.closest(".smcbx__value-pill");
      if (radiusPill) radiusPill.style.display = visible ? "" : "none";
      if (visible) setPillTransform(radiusLabel, cOuterX + 24, cMid + 10);
    }
    if (!visible) {
      setConnectorPath(connectors, 2, "", false);
      setConnectorPath(connectors, 3, "", false);
    }
    setConnectorPath(connectors, 4, "", false);
  }

  function updateSwimSpaStraps(layer, x, y, w, h, longSideIsVertical) {
    if (!layer) return;
    var paths = [];
    var longFractions = [0.27, 0.5, 0.73];
    var shortFractions = [0.35, 0.65];
    var thickness = 10;
    var depth = 23;

    if (longSideIsVertical) {
      longFractions.forEach(function (fraction) {
        var yy = y + h * fraction;
        paths.push(horizontalTabPath(x, yy, thickness, depth, -1));
        paths.push(horizontalTabPath(x + w, yy, thickness, depth, 1));
      });
      shortFractions.forEach(function (fraction) {
        var xx = x + w * fraction;
        paths.push(verticalTabPath(xx, y, thickness, depth, -1));
        paths.push(verticalTabPath(xx, y + h, thickness, depth, 1));
      });
    } else {
      longFractions.forEach(function (fraction) {
        var xx = x + w * fraction;
        paths.push(verticalTabPath(xx, y, thickness, depth, -1));
        paths.push(verticalTabPath(xx, y + h, thickness, depth, 1));
      });
      shortFractions.forEach(function (fraction) {
        var yy = y + h * fraction;
        paths.push(horizontalTabPath(x, yy, thickness, depth, -1));
        paths.push(horizontalTabPath(x + w, yy, thickness, depth, 1));
      });
    }

    replaceSvgPaths(layer, paths, "smcbx__swim-strap");
  }

  function updateSwimSpaHandles(handles, x, y, w, h, longSideIsVertical) {
    updateHandles(handles, x, y, w, h, longSideIsVertical ? "horizontal" : "vertical");
  }

  function verticalTabPath(cx, edgeY, width, depth, direction) {
    var half = width / 2;
    var endY = edgeY + direction * depth;
    var capJoinY = endY - direction * half;
    return [
      "M", roundCoord(cx - half), roundCoord(edgeY),
      "L", roundCoord(cx - half), roundCoord(capJoinY),
      "Q", roundCoord(cx - half), roundCoord(endY), roundCoord(cx), roundCoord(endY),
      "Q", roundCoord(cx + half), roundCoord(endY), roundCoord(cx + half), roundCoord(capJoinY),
      "L", roundCoord(cx + half), roundCoord(edgeY),
      "Z"
    ].join(" ");
  }

  function horizontalTabPath(edgeX, cy, height, depth, direction) {
    var half = height / 2;
    var endX = edgeX + direction * depth;
    var capJoinX = endX - direction * half;
    return [
      "M", roundCoord(edgeX), roundCoord(cy - half),
      "L", roundCoord(capJoinX), roundCoord(cy - half),
      "Q", roundCoord(endX), roundCoord(cy - half), roundCoord(endX), roundCoord(cy),
      "Q", roundCoord(endX), roundCoord(cy + half), roundCoord(capJoinX), roundCoord(cy + half),
      "L", roundCoord(edgeX), roundCoord(cy + half),
      "Z"
    ].join(" ");
  }

  function swimSpaPanelPlan(lengthValue) {
    var length = positiveNumber(lengthValue, 156);
    var panelCount = Math.max(4, Math.ceil(length / 48));
    if (panelCount >= 6) {
      return {
        label: "3 bifold covers with velcro seams",
        hingeFractions: [1 / 6, 3 / 6, 5 / 6],
        velcroFractions: [2 / 6, 4 / 6]
      };
    }
    if (panelCount === 5) {
      return {
        label: "2 bifold covers + center panel",
        hingeFractions: [1 / 5, 4 / 5],
        velcroFractions: [0.4, 0.6]
      };
    }
    return {
      label: "2 bifold covers with velcro seam",
      hingeFractions: [0.25, 0.75],
      velcroFractions: [0.5]
    };
  }

  function updateRectPreviewGroup(group, x, y, w, h, rx, showRadius, foldOrientation) {
    if (!group) return;
    var shadow = group.querySelector(".smcbx__cover-shadow");
    var top = group.querySelector(".smcbx__cover-top");
    var hinge = group.querySelector(".smcbx__hinge-line");
    var arrows = group.querySelectorAll(".smcbx__measure-arrow");
    var corner = group.querySelector(".smcbx__corner-guide");
    var letters = group.querySelectorAll(".smcbx__measure-letter");
    var handles = group.querySelectorAll(".smcbx__handle");
    var radiusPx = clamp(rx, 0, Math.min(w, h) / 2);
    var connectors = ensureMeasureConnectors(group, 5);
    var cGuideGap = 8;

    setRectAttrs(shadow, x + 16, y + 18, w, h, Math.max(0, radiusPx + 6));
    setRectAttrs(top, x, y, w, h, radiusPx);
    updateHingeLine(hinge, x, y, w, h, foldOrientation);

    var aX = Math.max(62, x - 50);
    var aTop = y;
    var aBottom = y + h;
    var aMid = y + h / 2;
    var aGap = 42;
    setPath(arrows[0], linePath(aX, aTop, aX, Math.max(aTop, aMid - aGap)));
    setPath(arrows[1], linePath(aX, Math.min(aBottom, aMid + aGap), aX, aBottom));
    setConnectorPath(connectors, 0, verticalGapPath(aX, aTop, aBottom, aMid - aGap, aMid + aGap), true);
    setTextPosition(letters[0], aX, aMid - 18);
    setPillTransform(group.querySelector("[data-dim-a-label]"), aX - 29, aMid - 2);

    var bY = Math.min(438, y + h + 58);
    var bLeft = x;
    var bRight = x + w;
    var bMid = x + w / 2;
    var bGap = 40;
    setPath(arrows[2], linePath(bLeft, bY, Math.max(bLeft, bMid - bGap), bY));
    setPath(arrows[3], linePath(Math.min(bRight, bMid + bGap), bY, bRight, bY));
    setConnectorPath(connectors, 1, horizontalGapPath(bY, bLeft, bRight, bMid - bGap, bMid + bGap), true);
    setTextPosition(letters[1], bMid, bY - 8);
    setPillTransform(group.querySelector("[data-dim-b-label]"), bMid - 29, bY + 6);

    var showCornerRadius = showRadius && radiusPx > 0.5;
    var cRadius = Math.max(18, Math.round(radiusPx));
    var cOuterX = x + w + cGuideGap;
    var cGuideTop = y - cGuideGap;
    var cGuideBottom = y + cRadius - cGuideGap;
    var cMid = cGuideTop + cRadius / 2;
    if (corner) {
      corner.style.display = showCornerRadius ? "" : "none";
      setPath(corner, [
        "M", roundCoord(x + w - cRadius + cGuideGap), roundCoord(cGuideTop),
        "H", roundCoord(cOuterX),
        "V", roundCoord(cGuideBottom)
      ].join(" "));
    }
    if (arrows[4]) {
      arrows[4].style.display = showCornerRadius ? "" : "none";
      var cX = cOuterX + 24;
      var cY1 = cGuideTop;
      var cY2 = cGuideBottom;
      setPath(arrows[4], linePath(cX, cY1, cX, cY2));
      setConnectorPath(connectors, 2, linePath(cX, cY1, cX, cY2), showCornerRadius);
      setConnectorPath(connectors, 3, linePath(cX + 7, cMid, cX + 16, cMid), showCornerRadius);
    }
    if (letters[2]) {
      letters[2].style.display = showCornerRadius ? "" : "none";
      setTextPosition(letters[2], cOuterX + 48, cMid + 5);
    }
    var radiusLabel = group.querySelector("[data-radius-label]");
    if (radiusLabel) {
      var radiusPill = radiusLabel.closest(".smcbx__value-pill");
      if (radiusPill) radiusPill.style.display = showCornerRadius ? "" : "none";
      setPillTransform(radiusLabel, cOuterX + 24, cMid + 10);
    }
    setConnectorPath(connectors, 4, "", false);
    if (!showCornerRadius) {
      setConnectorPath(connectors, 2, "", false);
      setConnectorPath(connectors, 3, "", false);
    }

    updateHandles(handles, x, y, w, h, foldOrientation);
    updateStraps(group, x, y, w, h, radiusPx, "rect", foldOrientation);
  }

  function updateRoundPreviewGroup(group, lengthValue) {
    if (!group) return;
    var length = positiveNumber(lengthValue, 84);
    var diameter = clamp(length / 84 * 310, 235, 330);
    var radius = diameter / 2;
    var cx = 280;
    var cy = 226;
    var x = cx - radius;
    var y = cy - radius;
    var arrows = group.querySelectorAll(".smcbx__measure-arrow");
    var letters = group.querySelectorAll(".smcbx__measure-letter");
    var circles = group.querySelectorAll("circle");
    var hinge = group.querySelector(".smcbx__hinge-line");
    var handles = group.querySelectorAll(".smcbx__handle");
    var connectors = ensureMeasureConnectors(group, 2);

    setCircleAttrs(circles[0], cx + 14, cy + 18, radius);
    setCircleAttrs(circles[1], cx, cy, radius);
    setPath(hinge, linePath(cx - radius + 2, cy, cx + radius - 2, cy));

    var aX = Math.max(62, x - 50);
    var aTop = y;
    var aBottom = y + diameter;
    var aMid = cy;
    var aGap = 42;
    setPath(arrows[0], linePath(aX, aTop, aX, Math.max(aTop, aMid - aGap)));
    setPath(arrows[1], linePath(aX, Math.min(aBottom, aMid + aGap), aX, aBottom));
    setConnectorPath(connectors, 0, verticalGapPath(aX, aTop, aBottom, aMid - aGap, aMid + aGap), true);
    setConnectorPath(connectors, 1, "", false);
    setTextPosition(letters[0], aX, aMid - 18);
    setPillTransform(group.querySelector("[data-dim-a-label]"), aX - 29, aMid - 2);

    updateHandles(handles, x, y, diameter, diameter, "horizontal");
    updateStraps(group, x, y, diameter, diameter, radius, "round", "horizontal");
  }

  function updateOctagonPreviewGroup(group, x, y, w, h) {
    if (!group) return;
    var shadow = group.querySelector(".smcbx__cover-shadow");
    var top = group.querySelector(".smcbx__cover-top");
    var hinge = group.querySelector(".smcbx__hinge-line");
    var arrows = group.querySelectorAll(".smcbx__measure-arrow");
    var letters = group.querySelectorAll(".smcbx__measure-letter");
    var handles = group.querySelectorAll(".smcbx__handle");
    var connectors = ensureMeasureConnectors(group, 4);
    var cut = octagonCut(w, h);

    setPath(shadow, octagonPath(x + 16, y + 18, w, h, cut));
    setPath(top, octagonPath(x, y, w, h, cut));
    setPath(hinge, linePath(x + 4, y + h / 2, x + w - 4, y + h / 2));

    var aX = Math.max(62, x - 50);
    var aTop = y;
    var aBottom = y + h;
    var aMid = y + h / 2;
    var aGap = 42;
    setPath(arrows[0], linePath(aX, aTop, aX, Math.max(aTop, aMid - aGap)));
    setPath(arrows[1], linePath(aX, Math.min(aBottom, aMid + aGap), aX, aBottom));
    setConnectorPath(connectors, 0, verticalGapPath(aX, aTop, aBottom, aMid - aGap, aMid + aGap), true);
    setTextPosition(letters[0], aX, aMid - 18);
    setPillTransform(group.querySelector("[data-dim-a-label]"), aX - 29, aMid - 2);

    var bY = Math.min(438, y + h + 58);
    var bLeft = x + cut;
    var bRight = x + w - cut;
    var bMid = (bLeft + bRight) / 2;
    var bGap = 40;
    setPath(arrows[2], linePath(bLeft, bY, Math.max(bLeft, bMid - bGap), bY));
    setPath(arrows[3], linePath(Math.min(bRight, bMid + bGap), bY, bRight, bY));
    setConnectorPath(connectors, 1, horizontalGapPath(bY, bLeft, bRight, bMid - bGap, bMid + bGap), true);
    setConnectorPath(connectors, 2, "", false);
    setConnectorPath(connectors, 3, "", false);
    setTextPosition(letters[1], bMid, bY - 8);
    setPillTransform(group.querySelector("[data-dim-b-label]"), bMid - 29, bY + 6);

    updateHandles(handles, x, y, w, h, "horizontal");
    updateStraps(group, x, y, w, h, 0, "octagon", "horizontal");
  }

  function previewBounds(length, width) {
    var maxW = 330;
    var maxH = 330;
    var minW = 205;
    var minH = 205;
    var ratio = Math.max(0.2, width / Math.max(1, length));
    var coverW;
    var coverH;

    if (ratio >= 1) {
      coverW = maxW;
      coverH = clamp(maxW / ratio, minH, maxH);
    } else {
      coverH = maxH;
      coverW = clamp(maxH * ratio, minW, maxW);
    }

    return {
      x: Math.round(280 - coverW / 2),
      y: Math.round(226 - coverH / 2),
      w: Math.round(coverW),
      h: Math.round(coverH)
    };
  }

  function octagonPath(x, y, w, h, cutOverride) {
    var cut = cutOverride != null ? cutOverride : octagonCut(w, h);
    return [
      "M", roundCoord(x + cut), roundCoord(y),
      "H", roundCoord(x + w - cut),
      "L", roundCoord(x + w), roundCoord(y + cut),
      "V", roundCoord(y + h - cut),
      "L", roundCoord(x + w - cut), roundCoord(y + h),
      "H", roundCoord(x + cut),
      "L", roundCoord(x), roundCoord(y + h - cut),
      "V", roundCoord(y + cut),
      "Z"
    ].join(" ");
  }

  function octagonCut(w, h) {
    return clamp(Math.min(w, h) * 0.22, 36, 72);
  }

  // Path for a rectangle whose four corners (clockwise from top-left) are each
  // 'cut' (45-degree bevel, horizontal projection cutPx), 'round' (radius rPx), or 'square'.
  function cornerShapePath(x, y, w, h, cutPx, rPx, corners) {
    var c = Math.max(0, cutPx);
    var r = Math.max(0, rPx);
    function inset(kind) { return kind === "cut" ? c : kind === "round" ? r : 0; }
    var tl = corners[0], tr = corners[1], br = corners[2], bl = corners[3];
    var p = ["M", roundCoord(x + inset(tl)), roundCoord(y), "H", roundCoord(x + w - inset(tr))];
    if (tr === "cut") p.push("L", roundCoord(x + w), roundCoord(y + c));
    else if (tr === "round") p.push("Q", roundCoord(x + w), roundCoord(y), roundCoord(x + w), roundCoord(y + r));
    p.push("V", roundCoord(y + h - inset(br)));
    if (br === "cut") p.push("L", roundCoord(x + w - c), roundCoord(y + h));
    else if (br === "round") p.push("Q", roundCoord(x + w), roundCoord(y + h), roundCoord(x + w - r), roundCoord(y + h));
    p.push("H", roundCoord(x + inset(bl)));
    if (bl === "cut") p.push("L", roundCoord(x), roundCoord(y + h - c));
    else if (bl === "round") p.push("Q", roundCoord(x), roundCoord(y + h), roundCoord(x), roundCoord(y + h - r));
    p.push("V", roundCoord(y + inset(tl)));
    if (tl === "cut") p.push("L", roundCoord(x + c), roundCoord(y));
    else if (tl === "round") p.push("Q", roundCoord(x), roundCoord(y), roundCoord(x + r), roundCoord(y));
    p.push("Z");
    return p.join(" ");
  }

  // Shared updater for fourcut / onecut / twocut diagrams. C (cut) is measured along the
  // diagonal -> horizontal projection C/sqrt(2); D is the radius of remaining corners.
  function updateCutShapePreviewGroup(group, x, y, w, h, cutInches, radiusInches, lengthInches, layout, foldOrientation, isRollaway, widthInches) {
    if (!group) return;
    var shadow = group.querySelector(".smcbx__cover-shadow");
    var top = group.querySelector(".smcbx__cover-top");
    var hinge = group.querySelector(".smcbx__hinge-line");
    var arrows = group.querySelectorAll(".smcbx__measure-arrow");
    var letters = group.querySelectorAll(".smcbx__measure-letter");
    var handles = group.querySelectorAll(".smcbx__handle");
    var connectors = ensureMeasureConnectors(group, 4);

    var hasCut = Number(cutInches) > 0 && Number(lengthInches) > 0;
    var cutPx = hasCut
      ? clamp(Number(cutInches) / Math.SQRT2 / Number(lengthInches) * w, 14, Math.min(w, h) * 0.4)
      : octagonCut(w, h);
    var hasR = Number(radiusInches) > 0 && Number(lengthInches) > 0;
    var rPx = hasR ? clamp(Number(radiusInches) / Number(lengthInches) * w, 6, Math.min(w, h) / 3) : 0;
    var soft = hasR ? "round" : "square";
    var corners = layout === "onecut" ? [soft, "cut", soft, soft]
      : layout === "twocut" ? [soft, "cut", "cut", soft]
      : ["cut", "cut", "cut", "cut"];

    setPath(shadow, cornerShapePath(x + 16, y + 18, w, h, cutPx, rPx, corners));
    setPath(top, cornerShapePath(x, y, w, h, cutPx, rPx, corners));
    updateHingeLine(hinge, x, y, w, h, foldOrientation || "horizontal");

    var aX = Math.max(62, x - 50);
    var aMid = y + h / 2;
    var aGap = 42;
    setPath(arrows[0], linePath(aX, y, aX, Math.max(y, aMid - aGap)));
    setPath(arrows[1], linePath(aX, Math.min(y + h, aMid + aGap), aX, y + h));
    setConnectorPath(connectors, 0, verticalGapPath(aX, y, y + h, aMid - aGap, aMid + aGap), true);
    setTextPosition(letters[0], aX, aMid - 18);
    setPillTransform(group.querySelector("[data-dim-a-label]"), aX - 29, aMid - 2);

    var bY = Math.min(438, y + h + 58);
    // Worksheet convention: A and B are the full bounding envelope (tip to tip) — the
    // cut is captured by C, so B spans the whole width, not just the bottom flat.
    var bLeft = x;
    var bRight = x + w;
    var bMid = (bLeft + bRight) / 2;
    var bGap = 40;
    setPath(arrows[2], linePath(bLeft, bY, Math.max(bLeft, bMid - bGap), bY));
    setPath(arrows[3], linePath(Math.min(bRight, bMid + bGap), bY, bRight, bY));
    setConnectorPath(connectors, 1, horizontalGapPath(bY, bLeft, bRight, bMid - bGap, bMid + bGap), true);
    setConnectorPath(connectors, 2, "", false);
    setConnectorPath(connectors, 3, "", false);
    setTextPosition(letters[1], bMid, bY - 8);
    setPillTransform(group.querySelector("[data-dim-b-label]"), bMid - 29, bY + 6);

    // C measurement along the top-right cut edge (shown once a value is typed)
    var cutGuide = group.querySelector("[data-cut-guide]");
    var cutArrow = group.querySelector("[data-cut-arrow]");
    var cutLetter = group.querySelector("[data-cut-letter]");
    var cutText = group.querySelector("[data-cut-label]");
    var cutPill = cutText ? cutText.closest(".smcbx__value-pill") : null;
    [cutGuide, cutArrow, cutLetter, cutPill].forEach(function (node) {
      if (node) node.style.display = hasCut ? "" : "none";
    });
    if (hasCut) {
      var gGap = 13;
      setPath(cutGuide, "M" + roundCoord(x + w - cutPx) + " " + roundCoord(y) + "l" + gGap + " " + -gGap +
        "M" + roundCoord(x + w) + " " + roundCoord(y + cutPx) + "l" + gGap + " " + -gGap);
      setPath(cutArrow, "M" + roundCoord(x + w - cutPx + gGap) + " " + roundCoord(y - gGap) +
        "L" + roundCoord(x + w + gGap) + " " + roundCoord(y + cutPx - gGap));
      setTextPosition(cutLetter, x + w + 30, y - 4);
      setPillTransform(cutText, x + w + 6, y + 6);
    }

    // D radius bracket at the top-left corner (worksheet style), only when a radius is set
    var rGuide = group.querySelector("[data-cutshape-radius-guide]");
    var rLetter = group.querySelector("[data-cutshape-radius-letter]");
    var rText = group.querySelector("[data-radius-label]");
    var rPill = rText ? rText.closest(".smcbx__value-pill") : null;
    var showR = hasR && layout !== "fourcut";
    [rGuide, rLetter, rPill].forEach(function (node) {
      if (node) node.style.display = showR ? "" : "none";
    });
    if (showR) {
      var bk = Math.max(16, rPx);
      setPath(rGuide, "M" + roundCoord(x) + " " + roundCoord(y - 12) + "h" + roundCoord(bk) +
        "M" + roundCoord(x - 12) + " " + roundCoord(y) + "v" + roundCoord(bk));
      setTextPosition(rLetter, Math.max(30, x - 26), y - 18);
      setPillTransform(rText, Math.max(4, x - 55), y - 12);
    }

    updateHandles(handles, x, y, w, h, "horizontal");
    updateStraps(group, x, y, w, h, 0, "octagon", foldOrientation || "horizontal");
    positionCornerStrapsForCorners(group, x, y, w, h, corners, cutPx, rPx);
    clampStrapsToFlats(group, x, y, w, h, corners, cutPx, rPx);
    updateSpecialShapeConstruction(group, isRollaway, x, y, w, h, Number(lengthInches) >= Number(widthInches), Math.max(cutPx, rPx));
  }

  // Keep handle/hinge straps on the FLAT spans of a cut/rounded-corner shape: a strap may
  // never overlap a bevel, so clamp its position into the straight run of its edge.
  function clampStrapsToFlats(group, x, y, w, h, corners, cutPx, rPx) {
    function inset(kind) { return kind === "cut" ? cutPx : kind === "round" ? rPx : 0; }
    var pad = 6;
    var topFlat = [x + inset(corners[0]) + pad, x + w - inset(corners[1]) - pad];
    var bottomFlat = [x + inset(corners[3]) + pad, x + w - inset(corners[2]) - pad];
    var leftFlat = [y + inset(corners[0]) + pad, y + h - inset(corners[3]) - pad];
    var rightFlat = [y + inset(corners[1]) + pad, y + h - inset(corners[2]) - pad];
    var handleRects = group.querySelectorAll(".smcbx__straps-handle rect");
    handleRects.forEach(function (rect) {
      var rx = Number(rect.getAttribute("x"));
      var ry = Number(rect.getAttribute("y"));
      var rw = Number(rect.getAttribute("width")) || 12;
      var horizontalEdge = ry < y || ry >= y + h - 1;
      if (horizontalEdge) {
        var flat = ry < y ? topFlat : bottomFlat;
        rect.setAttribute("x", roundCoord(clamp(rx, flat[0], flat[1] - rw)));
      }
    });
    var hingeRects = group.querySelectorAll(".smcbx__straps-hinge rect");
    hingeRects.forEach(function (rect) {
      var rx = Number(rect.getAttribute("x"));
      var ry = Number(rect.getAttribute("y"));
      var rh = Number(rect.getAttribute("height")) || 12;
      var verticalEdge = rx < x || rx >= x + w - 1;
      if (verticalEdge) {
        var flat = rx < x ? leftFlat : rightFlat;
        rect.setAttribute("y", roundCoord(clamp(ry, flat[0], flat[1] - rh)));
      }
    });
  }

  // Place the 4 corner straps ON each corner's real edge: cut corners get the strap
  // parallel to the bevel at its midpoint, rounded/square corners keep the classic
  // diagonal placement inset by their radius. Overrides updateStraps' rect-envelope math.
  function positionCornerStrapsForCorners(group, x, y, w, h, corners, cutPx, rPx) {
    var rects = group.querySelectorAll(".smcbx__straps-corners rect");
    if (rects.length < 4) return;
    // markup order: TL, TR, BL, BR
    var defs = [
      { cx: x, cy: y, sx: 1, sy: 1, rot: 40, corner: corners[0] },
      { cx: x + w, cy: y, sx: -1, sy: 1, rot: -40, corner: corners[1] },
      { cx: x, cy: y + h, sx: 1, sy: -1, rot: -40, corner: corners[3] },
      { cx: x + w, cy: y + h, sx: -1, sy: -1, rot: 40, corner: corners[2] }
    ];
    defs.forEach(function (d, i) {
      var inset = d.corner === "cut" ? cutPx / 2 : d.corner === "round" ? Math.max(6, rPx * 0.3) : 8;
      var midX = d.cx + d.sx * inset;
      var midY = d.cy + d.sy * inset;
      var outX = midX + d.sx * -8;
      var outY = midY + d.sy * -8;
      var rect = rects[i];
      rect.setAttribute("x", roundCoord(outX - 21));
      rect.setAttribute("y", roundCoord(outY - 6));
      rect.setAttribute("width", 42);
      rect.setAttribute("height", 12);
      rect.setAttribute("rx", 5);
      rect.setAttribute("transform", "rotate(" + d.rot + " " + roundCoord(outX) + " " + roundCoord(outY) + ")");
    });
  }

  // Bowed Sides / Elliptical, 7-measurement convention (owner 2026-07-20): all four sides
  // bow outward between rounded corners. A = middle-to-middle length (tallest point),
  // B = middle-to-middle width (widest point), C/D/E/F = edge-to-edge chords
  // (top/right/bottom/left, corner to corner), G = corner radius. A/B/G carry values today;
  // the C-F chord guides label the measurement spots (pills populate once fields exist).
  function updateBowedPreviewGroup(group, x, y, w, h, radiusInches, lengthInches, foldOrientation, isRollaway, widthInches) {
    if (!group) return;
    var shadow = group.querySelector(".smcbx__cover-shadow");
    var top = group.querySelector(".smcbx__cover-top");
    var hinge = group.querySelector(".smcbx__hinge-line");
    var arrows = group.querySelectorAll(".smcbx__measure-arrow");
    var letters = group.querySelectorAll(".smcbx__measure-letter");
    var handles = group.querySelectorAll(".smcbx__handle");
    var connectors = ensureMeasureConnectors(group, 4);
    var bulge = Math.min(w, h) * 0.06;
    var hasR = Number(radiusInches) > 0 && Number(lengthInches) > 0;
    var r = hasR ? clamp(Number(radiusInches) / Number(lengthInches) * w, 8, Math.min(w, h) / 3) : Math.min(w, h) * 0.12;
    // A/B measure the envelope at the bulge peaks; the flat chords sit inset by the bulge.
    var ix = x + bulge;
    var iw = w - bulge * 2;
    var iy = y + bulge;
    var ih = h - bulge * 2;
    function bowedPath(bx, by) {
      var x0 = bx + bulge, y0 = by + bulge, x1 = bx + bulge + iw, y1 = by + bulge + ih;
      return ["M", roundCoord(x0 + r), roundCoord(y0),
        "Q", roundCoord((x0 + x1) / 2), roundCoord(y0 - 2 * bulge), roundCoord(x1 - r), roundCoord(y0),
        "Q", roundCoord(x1), roundCoord(y0), roundCoord(x1), roundCoord(y0 + r),
        "Q", roundCoord(x1 + 2 * bulge), roundCoord((y0 + y1) / 2), roundCoord(x1), roundCoord(y1 - r),
        "Q", roundCoord(x1), roundCoord(y1), roundCoord(x1 - r), roundCoord(y1),
        "Q", roundCoord((x0 + x1) / 2), roundCoord(y1 + 2 * bulge), roundCoord(x0 + r), roundCoord(y1),
        "Q", roundCoord(x0), roundCoord(y1), roundCoord(x0), roundCoord(y1 - r),
        "Q", roundCoord(x0 - 2 * bulge), roundCoord((y0 + y1) / 2), roundCoord(x0), roundCoord(y0 + r),
        "Q", roundCoord(x0), roundCoord(y0), roundCoord(x0 + r), roundCoord(y0),
        "Z"].join(" ");
    }
    setPath(shadow, bowedPath(x + 16, y + 18));
    setPath(top, bowedPath(x, y));
    updateHingeLine(hinge, ix, iy, iw, ih, foldOrientation || "horizontal");

    // A: middle-to-middle vertical (bulge peak to bulge peak)
    var aX = Math.max(56, x - 46);
    var aMid = y + h / 2;
    setPath(arrows[0], linePath(aX, y, aX, Math.max(y, aMid - 42)));
    setPath(arrows[1], linePath(aX, Math.min(y + h, aMid + 42), aX, y + h));
    setConnectorPath(connectors, 0, verticalGapPath(aX, y, y + h, aMid - 42, aMid + 42), true);
    setTextPosition(letters[0], aX, aMid - 18);
    setPillTransform(group.querySelector("[data-dim-a-label]"), aX - 29, aMid - 2);

    // B: middle-to-middle horizontal
    var bY = Math.min(438, y + h + 58);
    var bMid = x + w / 2;
    setPath(arrows[2], linePath(x, bY, Math.max(x, bMid - 40), bY));
    setPath(arrows[3], linePath(Math.min(x + w, bMid + 40), bY, x + w, bY));
    setConnectorPath(connectors, 1, horizontalGapPath(bY, x, x + w, bMid - 40, bMid + 40), true);
    setConnectorPath(connectors, 2, "", false);
    setConnectorPath(connectors, 3, "", false);
    setTextPosition(letters[1], bMid, bY - 8);
    setPillTransform(group.querySelector("[data-dim-b-label]"), bMid - 29, bY + 6);

    // C-F edge-to-edge chord guides (corner arc to corner arc on each side)
    var cutGuide = group.querySelector("[data-cut-guide]");
    var cutLetter = group.querySelector("[data-cut-letter]");
    if (cutGuide) {
      cutGuide.style.display = "";
      var g = 10;
      setPath(cutGuide, [
        "M", roundCoord(ix + r), roundCoord(iy - g), "H", roundCoord(ix + iw - r),
        "M", roundCoord(ix + iw + g), roundCoord(iy + r), "V", roundCoord(iy + ih - r),
        "M", roundCoord(ix + r), roundCoord(iy + ih + g), "H", roundCoord(ix + iw - r),
        "M", roundCoord(ix - g), roundCoord(iy + r), "V", roundCoord(iy + ih - r)
      ].join(" "));
    }
    if (cutLetter) {
      cutLetter.style.display = "";
      cutLetter.textContent = "C-F";
      setTextPosition(cutLetter, ix + iw / 2, iy + 24);
    }
    var cutText = group.querySelector("[data-cut-label]");
    if (cutText && cutText.closest(".smcbx__value-pill")) cutText.closest(".smcbx__value-pill").style.display = "none";
    var cutArrow = group.querySelector("[data-cut-arrow]");
    if (cutArrow) cutArrow.style.display = "none";

    // G: corner radius bracket at the top-left corner
    var rGuide = group.querySelector("[data-cutshape-radius-guide]");
    var rLetter = group.querySelector("[data-cutshape-radius-letter]");
    var rText = group.querySelector("[data-radius-label]");
    var rPill = rText ? rText.closest(".smcbx__value-pill") : null;
    [rGuide, rLetter, rPill].forEach(function (n) { if (n) n.style.display = hasR ? "" : "none"; });
    if (hasR) {
      setPath(rGuide, "M" + roundCoord(ix) + " " + roundCoord(iy - 12) + "h" + roundCoord(Math.max(16, r)) +
        "M" + roundCoord(ix - 12) + " " + roundCoord(iy) + "v" + roundCoord(Math.max(16, r)));
      if (rLetter) rLetter.textContent = "G";
      setTextPosition(rLetter, Math.max(30, ix - 26), iy - 18);
      setPillTransform(rText, Math.max(4, ix - 55), iy - 12);
    }

    updateHandles(handles, ix, iy, iw, ih, "horizontal");
    updateStraps(group, x, y, w, h, 0, "rounded", foldOrientation || "horizontal");
    positionCornerStrapsForCorners(group, ix, iy, iw, ih, ["round", "round", "round", "round"], 0, r);
    // Snap handle/hinge straps to the local bowed edge: each side is a quadratic with
    // control offset 2*bulge, so the edge deviates by 4*bulge*t*(1-t) along the side.
    function bowAt(t) { return 4 * bulge * t * (1 - t); }
    group.querySelectorAll(".smcbx__straps-handle rect").forEach(function (rect) {
      var rx = Number(rect.getAttribute("x"));
      var ry = Number(rect.getAttribute("y"));
      var rw = Number(rect.getAttribute("width")) || 12;
      var t = clamp((rx + rw / 2 - (ix + r)) / Math.max(1, iw - 2 * r), 0, 1);
      if (ry < iy) rect.setAttribute("y", roundCoord(iy - bowAt(t) - 24));
      else rect.setAttribute("y", roundCoord(iy + ih + bowAt(t)));
    });
    group.querySelectorAll(".smcbx__straps-hinge rect, .smcbx__straps-one-per-side rect").forEach(function (rect) {
      var rx = Number(rect.getAttribute("x"));
      var ry = Number(rect.getAttribute("y"));
      var rh = Number(rect.getAttribute("height")) || 12;
      var rw2 = Number(rect.getAttribute("width")) || 12;
      var isSide = rx < ix || rx >= ix + iw - 1;
      if (!isSide) {
        var t2 = clamp((rx + rw2 / 2 - (ix + r)) / Math.max(1, iw - 2 * r), 0, 1);
        if (ry < iy) rect.setAttribute("y", roundCoord(iy - bowAt(t2) - 24));
        else if (ry >= iy + ih - 1) rect.setAttribute("y", roundCoord(iy + ih + bowAt(t2)));
        return;
      }
      var t3 = clamp((ry + rh / 2 - (iy + r)) / Math.max(1, ih - 2 * r), 0, 1);
      if (rx < ix) rect.setAttribute("x", roundCoord(ix - bowAt(t3) - 30));
      else rect.setAttribute("x", roundCoord(ix + iw + bowAt(t3)));
    });
    updateSpecialShapeConstruction(group, isRollaway, x, y, w, h, Number(lengthInches) >= Number(widthInches), r);
  }

  // Custom Shape: representative freeform blob, envelope A/B only.
  function updateCustomShapePreviewGroup(group, x, y, w, h, lengthInches, widthInches, isRollaway) {
    if (!group) return;
    var shadow = group.querySelector(".smcbx__cover-shadow");
    var top = group.querySelector(".smcbx__cover-top");
    var arrows = group.querySelectorAll(".smcbx__measure-arrow");
    var letters = group.querySelectorAll(".smcbx__measure-letter");
    var connectors = ensureMeasureConnectors(group, 4);
    function blob(bx, by) {
      return ["M", roundCoord(bx + w * 0.28), roundCoord(by + h * 0.04),
        "C", roundCoord(bx + w * 0.72), roundCoord(by - h * 0.04), roundCoord(bx + w * 1.01), roundCoord(by + h * 0.22), roundCoord(bx + w * 0.94), roundCoord(by + h * 0.5),
        "C", roundCoord(bx + w * 0.87), roundCoord(by + h * 0.78), roundCoord(bx + w * 0.6), roundCoord(by + h * 1.01), roundCoord(bx + w * 0.34), roundCoord(by + h * 0.94),
        "C", roundCoord(bx + w * 0.08), roundCoord(by + h * 0.87), roundCoord(bx - w * 0.02), roundCoord(by + h * 0.58), roundCoord(bx + w * 0.05), roundCoord(by + h * 0.32),
        "C", roundCoord(bx + w * 0.1), roundCoord(by + h * 0.14), roundCoord(bx + w * 0.16), roundCoord(by + h * 0.08), roundCoord(bx + w * 0.28), roundCoord(by + h * 0.04),
        "Z"].join(" ");
    }
    setPath(shadow, blob(x + 16, y + 18));
    setPath(top, blob(x, y));
    var hinge = group.querySelector(".smcbx__hinge-line");
    setPath(hinge, linePath(x + 6, y + h / 2, x + w - 6, y + h / 2));
    var aX = Math.max(60, x - 48);
    var aMid = y + h / 2;
    setPath(arrows[0], linePath(aX, y, aX, Math.max(y, aMid - 42)));
    setPath(arrows[1], linePath(aX, Math.min(y + h, aMid + 42), aX, y + h));
    setConnectorPath(connectors, 0, verticalGapPath(aX, y, y + h, aMid - 42, aMid + 42), true);
    setTextPosition(letters[0], aX, aMid - 18);
    setPillTransform(group.querySelector("[data-dim-a-label]"), aX - 29, aMid - 2);
    var bY = Math.min(438, y + h + 58);
    var bMid = x + w / 2;
    setPath(arrows[2], linePath(x, bY, Math.max(x, bMid - 40), bY));
    setPath(arrows[3], linePath(Math.min(x + w, bMid + 40), bY, x + w, bY));
    setConnectorPath(connectors, 1, horizontalGapPath(bY, x, x + w, bMid - 40, bMid + 40), true);
    setConnectorPath(connectors, 2, "", false);
    setConnectorPath(connectors, 3, "", false);
    setTextPosition(letters[1], bMid, bY - 8);
    setPillTransform(group.querySelector("[data-dim-b-label]"), bMid - 29, bY + 6);
    ["[data-cut-guide]", "[data-cut-arrow]", "[data-cut-letter]", "[data-cutshape-radius-guide]", "[data-cutshape-radius-letter]"].forEach(function (sel) {
      var n = group.querySelector(sel); if (n) n.style.display = "none";
    });
    ["[data-cut-label]", "[data-radius-label]"].forEach(function (sel) {
      var n = group.querySelector(sel); if (n && n.closest(".smcbx__value-pill")) n.closest(".smcbx__value-pill").style.display = "none";
    });
    var handles = group.querySelectorAll(".smcbx__handle");
    updateHandles(handles, x, y, w, h, "horizontal");
    updateStraps(group, x, y, w, h, 0, "rounded", "horizontal");
    updateSpecialShapeConstruction(group, isRollaway, x, y, w, h, Number(lengthInches) >= Number(widthInches), Math.min(w, h) * 0.12);
  }

  function updateSpecialShapeConstruction(group, isRollaway, x, y, w, h, longSideIsVertical, cornerExtent) {
    if (!group) return;

    group.querySelectorAll(".smcbx__hinge-line, .smcbx__strap-set, .smcbx__handle").forEach(function (node) {
      node.style.display = isRollaway ? "none" : "";
    });

    var ribs = group.querySelector(".smcbx__rollaway-ribs");
    var strapLayer = group.querySelector(".smcbx__rollaway-straps");
    if (ribs) ribs.style.display = isRollaway ? "" : "none";
    if (strapLayer) strapLayer.style.display = isRollaway ? "" : "none";
    if (!isRollaway) {
      replaceSvgPaths(ribs, [], "smcbx__rollaway-rib");
      return;
    }

    var ribLinesAreVertical = !longSideIsVertical;
    var ribTrack = ribLinesAreVertical ? w : h;
    var ribCount = clamp(Math.round(ribTrack / 48), 4, 8);
    var extent = clamp(Number(cornerExtent) || 0, 0, Math.min(w, h) * 0.4);
    var ribPaths = [];

    for (var i = 1; i <= ribCount; i += 1) {
      if (ribLinesAreVertical) {
        var xx = x + (w / (ribCount + 1)) * i;
        var yInset = Math.max(0, extent - Math.min(xx - x, x + w - xx));
        ribPaths.push(linePath(xx, y + yInset + 10, xx, y + h - yInset - 10));
      } else {
        var yy = y + (h / (ribCount + 1)) * i;
        var xInset = Math.max(0, extent - Math.min(yy - y, y + h - yy));
        ribPaths.push(linePath(x + xInset + 10, yy, x + w - xInset - 10, yy));
      }
    }

    replaceSvgPaths(ribs, ribPaths, "smcbx__rollaway-rib");
    updateRollawayStraps(group.querySelectorAll(".smcbx__rollaway-straps rect"), x, y, w, h);
  }

  function updateHingeLine(hinge, x, y, w, h, foldOrientation) {
    if (foldOrientation === "vertical") {
      setPath(hinge, "M" + Math.round(x + w / 2) + " " + (y + 2) + "V" + (y + h - 2));
      return;
    }
    setPath(hinge, "M" + (x + 2) + " " + Math.round(y + h / 2) + "H" + (x + w - 2));
  }

  function updateHandles(handles, x, y, w, h, foldOrientation) {
    var handleDepth = 14;
    if (foldOrientation === "vertical") {
      var handleH = clamp(h * 0.18, 44, 60);
      var hy = y + h / 2 - handleH / 2;
      if (handles[0]) setPath(handles[0], "M" + (x - 3) + " " + hy + "h-" + handleDepth + "v" + handleH + "h" + handleDepth);
      if (handles[1]) setPath(handles[1], "M" + (x + w + 3) + " " + hy + "h" + handleDepth + "v" + handleH + "h-" + handleDepth);
      return;
    }

    var handleW = clamp(w * 0.18, 44, 60);
    var hx = x + w / 2 - handleW / 2;
    if (handles[0]) setPath(handles[0], "M" + hx + " " + (y - 3) + "v-" + handleDepth + "h" + handleW + "v" + handleDepth);
    if (handles[1]) setPath(handles[1], "M" + hx + " " + (y + h + 3) + "v" + handleDepth + "h" + handleW + "v-" + handleDepth);
  }

  function updateStraps(group, x, y, w, h, cornerRadius, shapeKind, foldOrientation) {
    if (shapeKind === "round") {
      updateRoundStraps(group, x, y, w, h);
      return;
    }

    var handleStraps = group.querySelectorAll(".smcbx__straps-handle rect");
    var verticalW = 12;
    var verticalH = 24;
    var sideW = 30;
    var sideH = 10;
    var topY = y - verticalH;
    var bottomY = y + h;
    var leftX = x + w * 0.28;
    var rightX = x + w * 0.72 - verticalW;
    if (foldOrientation === "vertical") {
      setRectAttrs(handleStraps[0], x - sideW, y + h * 0.28, sideW, sideH, sideH / 2);
      setRectAttrs(handleStraps[1], x - sideW, y + h * 0.72 - sideH, sideW, sideH, sideH / 2);
      setRectAttrs(handleStraps[2], x + w, y + h * 0.28, sideW, sideH, sideH / 2);
      setRectAttrs(handleStraps[3], x + w, y + h * 0.72 - sideH, sideW, sideH, sideH / 2);
    } else {
      setRectAttrs(handleStraps[0], leftX, topY, verticalW, verticalH, verticalW / 2);
      setRectAttrs(handleStraps[1], rightX, topY, verticalW, verticalH, verticalW / 2);
      setRectAttrs(handleStraps[2], leftX, bottomY, verticalW, verticalH, verticalW / 2);
      setRectAttrs(handleStraps[3], rightX, bottomY, verticalW, verticalH, verticalW / 2);
    }

    var hingeStraps = group.querySelectorAll(".smcbx__straps-hinge rect");
    if (foldOrientation === "vertical") {
      setRectAttrs(hingeStraps[0], x + w * 0.28, topY, verticalW, verticalH, verticalW / 2);
      setRectAttrs(hingeStraps[1], x + w * 0.72 - verticalW, topY, verticalW, verticalH, verticalW / 2);
      setRectAttrs(hingeStraps[2], x + w * 0.28, bottomY, verticalW, verticalH, verticalW / 2);
      setRectAttrs(hingeStraps[3], x + w * 0.72 - verticalW, bottomY, verticalW, verticalH, verticalW / 2);
    } else {
      setRectAttrs(hingeStraps[0], x - sideW, y + h * 0.28, sideW, sideH, sideH / 2);
      setRectAttrs(hingeStraps[1], x - sideW, y + h * 0.72, sideW, sideH, sideH / 2);
      setRectAttrs(hingeStraps[2], x + w, y + h * 0.28, sideW, sideH, sideH / 2);
      setRectAttrs(hingeStraps[3], x + w, y + h * 0.72, sideW, sideH, sideH / 2);
    }

    var sideStraps = group.querySelectorAll(".smcbx__straps-one-per-side rect");
    setRectAttrs(sideStraps[0], x + w / 2 - verticalW / 2, topY, verticalW, verticalH, verticalW / 2);
    setRectAttrs(sideStraps[1], x + w / 2 - verticalW / 2, bottomY, verticalW, verticalH, verticalW / 2);
    setRectAttrs(sideStraps[2], x - sideW, y + h / 2 - sideH / 2, sideW, sideH, sideH / 2);
    setRectAttrs(sideStraps[3], x + w, y + h / 2 - sideH / 2, sideW, sideH, sideH / 2);

    var cornerStraps = group.querySelectorAll(".smcbx__straps-corners rect");
    updateCornerStraps(cornerStraps, x, y, w, h, cornerRadius, shapeKind);
  }

  function updateRoundStraps(group, x, y, w, h) {
    var handleStraps = group.querySelectorAll(".smcbx__straps-handle rect");
    var hingeStraps = group.querySelectorAll(".smcbx__straps-hinge rect");
    var sideStraps = group.querySelectorAll(".smcbx__straps-one-per-side rect");
    var cornerStraps = group.querySelectorAll(".smcbx__straps-corners rect");
    var verticalW = 12;
    var verticalH = 24;
    var sideW = 30;
    var sideH = 10;
    var radius = Math.min(w, h) / 2;
    var cx = x + w / 2;
    var cy = y + h / 2;
    var topPair = [x + w * 0.3, x + w * 0.7];
    var sidePair = [y + h * 0.3, y + h * 0.7];

    topPair.forEach(function (strapCx, index) {
      var topEdge = roundVerticalEdgeY(cx, cy, radius, strapCx, "top");
      var bottomEdge = roundVerticalEdgeY(cx, cy, radius, strapCx, "bottom");
      setRectAttrs(handleStraps[index], strapCx - verticalW / 2, topEdge - verticalH, verticalW, verticalH, verticalW / 2);
      setRectAttrs(handleStraps[index + 2], strapCx - verticalW / 2, bottomEdge, verticalW, verticalH, verticalW / 2);
    });

    sidePair.forEach(function (strapCy, index) {
      var leftEdge = roundHorizontalEdgeX(cx, cy, radius, strapCy, "left");
      var rightEdge = roundHorizontalEdgeX(cx, cy, radius, strapCy, "right");
      setRectAttrs(hingeStraps[index], leftEdge - sideW, strapCy - sideH / 2, sideW, sideH, sideH / 2);
      setRectAttrs(hingeStraps[index + 2], rightEdge, strapCy - sideH / 2, sideW, sideH, sideH / 2);
    });

    setRectAttrs(sideStraps[0], cx - verticalW / 2, y - verticalH, verticalW, verticalH, verticalW / 2);
    setRectAttrs(sideStraps[1], cx - verticalW / 2, y + h, verticalW, verticalH, verticalW / 2);
    setRectAttrs(sideStraps[2], x - sideW, cy - sideH / 2, sideW, sideH, sideH / 2);
    setRectAttrs(sideStraps[3], x + w, cy - sideH / 2, sideW, sideH, sideH / 2);

    updateCornerStraps(cornerStraps, x, y, w, h, radius, "round");
  }

  function updateCornerStraps(straps, x, y, w, h, cornerRadius, shapeKind) {
    if (!straps || !straps.length) return;
    var strapW = clamp(Math.min(w, h) * 0.12, 30, 42);
    var strapH = 10;
    var points;

    if (shapeKind === "octagon") {
      var cut = octagonCut(w, h);
      points = [
        [x + cut / 2, y + cut / 2, 45],
        [x + w - cut / 2, y + cut / 2, -45],
        [x + cut / 2, y + h - cut / 2, -45],
        [x + w - cut / 2, y + h - cut / 2, 45]
      ];
    } else if (shapeKind === "round") {
      var roundRadius = Math.min(w, h) / 2;
      var roundCx = x + w / 2;
      var roundCy = y + h / 2;
      var diagonalOffset = roundRadius / Math.SQRT2;
      points = [
        [roundCx - diagonalOffset, roundCy - diagonalOffset, 45],
        [roundCx + diagonalOffset, roundCy - diagonalOffset, -45],
        [roundCx - diagonalOffset, roundCy + diagonalOffset, -45],
        [roundCx + diagonalOffset, roundCy + diagonalOffset, 45]
      ];
    } else {
      var radius = Math.max(0, cornerRadius || 0);
      var inset = perimeterCornerStrapInset(radius, Math.min(w, h), strapW);
      points = [
        [x + inset, y + inset, 40],
        [x + w - inset, y + inset, -40],
        [x + inset, y + h - inset, -40],
        [x + w - inset, y + h - inset, 40]
      ];
    }

    points.forEach(function (point, index) {
      setRotatedRect(straps[index], point[0], point[1], strapW, strapH, point[2]);
    });
  }

  function roundVerticalEdgeY(cx, cy, radius, xCoord, side) {
    var dx = clamp(xCoord - cx, -radius, radius);
    var offset = Math.sqrt(Math.max(0, radius * radius - dx * dx));
    return side === "bottom" ? cy + offset : cy - offset;
  }

  function roundHorizontalEdgeX(cx, cy, radius, yCoord, side) {
    var dy = clamp(yCoord - cy, -radius, radius);
    var offset = Math.sqrt(Math.max(0, radius * radius - dy * dy));
    return side === "right" ? cx + offset : cx - offset;
  }

  function perimeterCornerStrapInset(cornerRadius, minDimension, strapWidth) {
    var radius = Math.max(0, cornerRadius || 0);
    var minDim = Math.max(1, minDimension || 1);
    var visualInset = Math.max(6, Math.min(11, (strapWidth || 34) * 0.26));
    return clamp(Math.min(radius * 0.18 || visualInset, visualInset), 6, minDim * 0.08);
  }

  function ensureMeasureConnectors(group, count) {
    var layer = group.querySelector(".smcbx__measure-connectors");
    if (!layer) {
      layer = document.createElementNS("http://www.w3.org/2000/svg", "g");
      layer.setAttribute("class", "smcbx__measure-connectors");
      group.insertBefore(layer, group.querySelector(".smcbx__measure-letter") || null);
    }
    while (layer.children.length < count) {
      var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute("class", "smcbx__measure-connector");
      layer.appendChild(path);
    }
    Array.prototype.forEach.call(layer.children, function (path, index) {
      path.style.display = index < count ? "" : "none";
    });
    return Array.prototype.slice.call(layer.children);
  }

  function setConnectorPath(connectors, index, d, visible) {
    var path = connectors && connectors[index];
    if (!path) return;
    path.style.display = visible ? "" : "none";
    if (visible) path.setAttribute("d", d);
  }

  function replaceSvgPaths(group, paths, className) {
    if (!group) return;
    while (group.firstChild) group.removeChild(group.firstChild);
    (paths || []).forEach(function (d) {
      var path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute("class", className);
      path.setAttribute("d", d);
      group.appendChild(path);
    });
  }

  function setRotatedRect(node, cx, cy, width, height, angle) {
    if (!node) return;
    setRectAttrs(node, cx - width / 2, cy - height / 2, width, height, 5);
    node.setAttribute("transform", "rotate(" + angle + " " + roundCoord(cx) + " " + roundCoord(cy) + ")");
  }

  function setCircleAttrs(node, cx, cy, r) {
    if (!node) return;
    node.setAttribute("cx", roundCoord(cx));
    node.setAttribute("cy", roundCoord(cy));
    node.setAttribute("r", roundCoord(r));
  }

  function setRectAttrs(node, x, y, width, height, rx) {
    if (!node) return;
    node.setAttribute("x", roundCoord(x));
    node.setAttribute("y", roundCoord(y));
    node.setAttribute("width", roundCoord(width));
    node.setAttribute("height", roundCoord(height));
    node.setAttribute("rx", roundCoord(rx || 0));
  }

  function setPath(node, d) {
    if (node) node.setAttribute("d", d);
  }

  function linePath(x1, y1, x2, y2) {
    return "M" + roundCoord(x1) + " " + roundCoord(y1) + "L" + roundCoord(x2) + " " + roundCoord(y2);
  }

  function verticalGapPath(x, y1, y2, gapTop, gapBottom) {
    return linePath(x, y1, x, Math.max(y1, gapTop)) + " " + linePath(x, Math.min(y2, gapBottom), x, y2);
  }

  function horizontalGapPath(y, x1, x2, gapLeft, gapRight) {
    return linePath(x1, y, Math.max(x1, gapLeft), y) + " " + linePath(Math.min(x2, gapRight), y, x2, y);
  }

  function setTextPosition(node, x, y) {
    if (!node) return;
    node.setAttribute("x", roundCoord(x));
    node.setAttribute("y", roundCoord(y));
  }

  function setPillTransform(textNode, x, y) {
    var pill = textNode && textNode.closest(".smcbx__value-pill");
    if (pill) pill.setAttribute("transform", "translate(" + roundCoord(x) + " " + roundCoord(y) + ")");
  }

  function positiveNumber(value, fallback, allowZero) {
    var parsed = parseFloat(String(value || "").replace(/[^0-9.]/g, ""));
    if (!Number.isFinite(parsed)) return fallback;
    if (parsed > 0 || allowZero && parsed === 0) return parsed;
    return fallback;
  }

  function parseSizeInches(value) {
    return parseFloat(String(value || "").replace(/[^0-9.]/g, ""));
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function roundCoord(value) {
    return Math.round(value * 10) / 10;
  }

  function updateMeasurementUi(form, template, locale) {
    var panel = form.querySelector('[data-field-id="cover_size"]:not([hidden]), [data-field-id="rollaway_size"]:not([hidden])');
    if (!panel) return;

    var labels = {
      a_b_c_radius: {
        a: "Dimension A / length (in.)",
        b: "Dimension B / width (in.)",
        c: "Dimension C / corner radius (in.)",
        showB: true,
        showC: true,
        showD: false
      },
      a_b: {
        a: "Dimension A / length (in.)",
        b: "Dimension B / width (in.)",
        c: "",
        showB: true,
        showC: false,
        showD: false
      },
      diameter: {
        a: "Diameter A (in.)",
        b: "",
        c: "",
        showB: false,
        showC: false,
        showD: false
      },
      a_b_c: {
        a: "Dimension A / length (in.)",
        b: "Dimension B / width (in.)",
        c: "Dimension C / widest point (in.)",
        showB: true,
        showC: true,
        showD: false
      },
      a_b_c_cut: {
        a: "Dimension A / length (in.) — always the longest side",
        b: "Dimension B / width (in.)",
        c: "Dimension C / cut corner (in.)",
        showB: true,
        showC: true,
        showD: false
      },
      a_b_c_d_cut: {
        a: "Dimension A / length (in.)",
        b: "Dimension B / width (in.)",
        c: "Dimension C / cut corner (in.)",
        d: "Dimension D / corner radius (in.) — leave blank if the other corners are square",
        showB: true,
        showC: true,
        showD: true
      }
    };
    var config = labels[template] || labels.a_b_c_radius;
    var shapeField = checkedField(form, "cover_shape") || checkedField(form, "rollaway_cover_shape");
    var shapeText = shapeField ? String(shapeField.dataset.optionLabel || shapeField.value).toLowerCase() : "";
    if (template === "a_b" && (shapeText.indexOf("octagon") !== -1 || shapeText.indexOf("octogone") !== -1)) {
      config = {
        a: "Dimension A / across (in.) — always the longest",
        b: "Dimension B / side (in.)",
        c: "", showB: true, showC: false, showD: false
      };
    }
    setDimensionLabel(panel, "a", localize(config.a, locale), true);
    setDimensionLabel(panel, "b", localize(config.b, locale), config.showB);
    setDimensionLabel(panel, "c", localize(config.c || "Dimension C (in.)", locale), config.showC);
    setDimensionLabel(panel, "d", localize(config.d || "Dimension D (in.)", locale), config.showD);

    // Property names track SEMANTICS, not letters: Corner Radius is always a radius,
    // Cover Dimension C is always a cut along the diagonal (production packet contract).
    var isCutTemplate = template === "a_b_c_cut" || template === "a_b_c_d_cut";
    var cInput = panel.querySelector('[data-dimension="c"] input');
    var dInput = panel.querySelector('[data-dimension="d"] input');
    if (cInput) {
      cInput.name = "properties[" + (isCutTemplate ? "Cover Dimension C" : "Corner Radius") + "]";
    }
    if (dInput) {
      dInput.name = "properties[" + (template === "a_b_c_d_cut" ? "Corner Radius" : "Cover Dimension D") + "]";
      dInput.required = false;
    }
    syncCornerRadiusMode(panel, template === "a_b_c_radius" && config.showC, locale);
    if (isCutTemplate) setDimensionRequired(panel, "c", true);
  }

  function setDimensionLabel(panel, dimension, text, visible) {
    var label = panel.querySelector('[data-dimension="' + dimension + '"]');
    if (!label) return;
    label.hidden = !visible;
    label.querySelectorAll("input").forEach(function (input) {
      input.disabled = !visible;
    });
    var span = label.querySelector("span");
    if (span && text) span.textContent = text;
  }

  function setDimensionRequired(panel, dimension, required) {
    var label = panel.querySelector('[data-dimension="' + dimension + '"]');
    if (!label) return;

    var input = label.querySelector("input");
    if (input) input.required = required === true;

    var span = label.querySelector("span");
    if (!span) return;
    var marker = span.querySelector("[data-required-marker]");
    if (required) {
      if (!marker) span.appendChild(el("strong", { dataset: { requiredMarker: "" } }, "*"));
    } else if (marker) {
      marker.remove();
    }
  }

  function syncCornerRadiusMode(panel, relevant, locale) {
    var mode = panel.querySelector("[data-corner-radius-mode]");
    var help = panel.querySelector("[data-corner-radius-help]");
    if (!mode) return;

    mode.hidden = !relevant;
    mode.querySelectorAll("input").forEach(function (input) {
      input.disabled = !relevant;
    });

    if (!relevant) {
      if (help) help.hidden = true;
      setDimensionRequired(panel, "c", false);
      return;
    }

    var radiusLabel = panel.querySelector('[data-dimension="c"]');
    var radiusInput = radiusLabel ? radiusLabel.querySelector("input") : null;
    var selectedMode = selectedCornerRadiusMode(panel);
    var hasSelection = Boolean(selectedMode);
    var needsHelp = selectedMode === CORNER_RADIUS_HELP_VALUE;
    setDimensionRequired(panel, "c", hasSelection && !needsHelp);
    if (radiusLabel) radiusLabel.hidden = !hasSelection || needsHelp;
    if (radiusInput) radiusInput.disabled = !hasSelection || needsHelp;
    if (help) {
      help.textContent = localize(CORNER_RADIUS_HELP_MESSAGE, locale);
      help.hidden = !needsHelp;
    }
  }

  function selectedCornerRadiusMode(scope) {
    var selected = scope.querySelector('input[name="properties[Corner Radius Measurement]"]:checked');
    return selected ? selected.value : "";
  }

  function cornerRadiusNeedsHelp(scope) {
    return selectedCornerRadiusMode(scope) === CORNER_RADIUS_HELP_VALUE;
  }

  function updateSpecList(root, form, locale) {
    var list = root.querySelector("[data-spec-list]");
    if (!list) return;
    list.innerHTML = "";
    var rows = selectedPropertyRows(form);
    rows.slice(0, 8).forEach(function (row) {
      list.appendChild(el("div", {}, el("dt", {}, localize(propertyLabel(row.key), locale)), el("dd", {}, localize(row.value, locale))));
    });
  }

  function updateSectionStatuses(form, currency, locale) {
    form.querySelectorAll("[data-section-status]").forEach(function (status) {
      var fieldset = status.closest("fieldset");
      if (!fieldset || fieldset.hidden) return;
      status.textContent = "";
      if (fieldset.dataset.fieldId === "current_lifter_system") return;

      var checked = Array.prototype.slice.call(fieldset.querySelectorAll("input:checked"))
        .filter(isActiveControl);
      var numberInputs = Array.prototype.slice.call(fieldset.querySelectorAll("input[type='number'], input[type='text']"))
        .filter(function (input) { return isActiveControl(input) && String(input.value || "").trim(); });

      var labelText = "";
      var priceText = "";
      if (fieldset.dataset.fieldId === "cover_size" || fieldset.dataset.fieldId === "rollaway_size") {
        var length = propertyValue(form, "Cover Length A");
        var width = propertyValue(form, "Cover Width B");
        var radius = propertyValue(form, "Corner Radius");
        var sizePricingCents = getAutomaticSelections(form, form._smcbxAddonMap || {}).reduce(function (sum, selection) {
          return sum + (selection.priceCents || 0);
        }, 0);
        var cutMeasure = propertyValue(form, "Cover Dimension C");
        if (length && width && cutMeasure) {
          labelText = length + " x " + width + " " + inchUnit(locale) + " / C " + inchesLabel(cutMeasure, locale) +
            (radius ? " / " + radiusInchesLabel(radius, locale) : "");
        } else if (length && width && radius && !fieldset.querySelector('[data-dimension="c"][hidden]')) {
          labelText = length + " x " + width + " " + inchUnit(locale) + " / " + radiusInchesLabel(radius, locale);
        } else if (length && width) {
          labelText = length + " x " + width + " " + inchUnit(locale);
        } else if (numberInputs.length > 0) {
          labelText = inchesLabel(numberInputs[0].value.trim(), locale);
        }
        if (sizePricingCents > 0) priceText = "+" + formatMoney(sizePricingCents, currency, locale);
      } else if (checked.length > 0) {
        var isMultiSelect = checked.some(function (input) { return input.type === "checkbox"; });
        var price = checked.reduce(function (sum, input) {
          return sum + (parseInt(input.dataset.priceCents || "0", 10) || 0);
        }, 0);
        if (isMultiSelect) {
          labelText = checked.length === 1 ? checked[0].dataset.optionLabel || checked[0].value : checked.length + " " + localize("selected", locale);
        } else {
          labelText = checked[0].dataset.optionLabel || checked[0].value;
        }
        if (price > 0) priceText = "+" + formatMoney(price, currency, locale);
      } else if (numberInputs.length > 0) {
        labelText = inchesLabel(numberInputs[0].value.trim(), locale);
      }

      if (!labelText) return;
      status.appendChild(document.createTextNode(labelText));
      if (priceText) status.appendChild(el("span", { className: "smcbx__status-price" }, " " + priceText));
    });
  }

  function setupStepSections(steps, group, locale) {
    var fieldsets = Array.prototype.slice.call(steps.querySelectorAll(".smcbx__fieldset"));
    if (fieldsets.length < 2) return;
    // The optional model lookup stays a standalone helper above the numbered
    // sections (it isn't a required step, so it gets no phase of its own). Phases
    // begin at the first fieldset, and cover type leads "Build your cover".
    var anchor = fieldsets[0];
    if (!anchor || anchor.parentNode !== steps) return;

    var defs = [
      { title: localize({ en: "Build your cover", fr: "Composez votre housse" }, locale), items: [] },
      { title: localize({ en: "Enter dimensions", fr: "Entrez vos dimensions" }, locale), items: [] },
      { title: localize({ en: "Upgrades", fr: "Améliorations" }, locale), items: [] },
      { title: localize({ en: "Add-ons", fr: "Accessoires" }, locale), items: [] }
    ];
    fieldsets.forEach(function (fs) {
      var id = fs.dataset.fieldId || "";
      var index;
      if (fs.querySelector(".smcbx__addons")) index = id.indexOf("upgrade") !== -1 ? 2 : 3;
      // Measurements grouped together: size (+ corner radius), fold, roll, strap,
      // skirt. Roll matches on the full "roll_orientation" rather than "roll" —
      // every field in a rollaway group is prefixed "rollaway_", so a looser test
      // would drag shape and material into the dimensions phase too.
      else if (/size|fold|roll_orientation|strap|skirt/.test(id)) index = 1;
      // Everything else is a design choice: cover type, thickness, shape, material.
      else index = 0;
      defs[index].items.push(fs);
    });

    Array.prototype.slice.call(steps.querySelectorAll(".smcbx__divider")).forEach(function (divider) {
      divider.remove();
    });

    var sections = [];

    // Single-page: sections are always-expanded visual groups. The header is a
    // static label (no collapse toggle) — a shopper can never hide a section and
    // miss its fields.
    var shells = defs.map(function (def) {
      if (!def.items.length) return null;
      var body = el("div", { className: "smcbx__phase-body" });
      var num = el("span", { className: "smcbx__phase-num" });
      var head = el("div", { className: "smcbx__phase-head" },
        num,
        el("span", { className: "smcbx__phase-label" }, el("strong", {}, def.title))
      );
      var section = el("section", { className: "smcbx__phase" }, head, body);
      section._body = body;
      section._items = def.items;
      section._num = num;
      return section;
    });

    shells.forEach(function (section) { if (section) steps.insertBefore(section, anchor); });
    shells.forEach(function (section) {
      if (!section) return;
      section._items.forEach(function (item) { section._body.appendChild(item); });
      section._num.textContent = String(sections.length + 1);
      sections.push(section);
    });

    // "or" connector between the optional model lookup above and the build steps:
    // find your hot tub model — OR — just start customizing your cover.
    var modelSearch = steps.querySelector(".smcbx__model-search");
    if (modelSearch && sections[0]) {
      steps.insertBefore(
        el("div", { className: "smcbx__or" },
          el("span", {}, localize({ en: "Or start customizing your cover", fr: "Ou composez votre housse" }, locale))
        ),
        sections[0]
      );
    }
  }

  // Sticky add-to-cart bar rendered at the document level so it cannot be
  // trapped by builder layout ancestors. It mirrors the real builder submit
  // instead of bypassing validation, line item properties, or bundle handling.
  function setupStickyCart(root, form, locale) {
    var railSubmit = form.querySelector(".smcbx__submit");
    if (!railSubmit || !document.body) return;

    var existing = document.querySelector(".smcbx__atc-bar");
    if (existing && typeof existing._smcbxCleanup === "function") existing._smcbxCleanup();
    if (existing) existing.remove();

    var price = el("strong", { className: "smcbx__atc-price" });
    var compareAt = el("s", { className: "smcbx__atc-compare", hidden: true });
    var buttonText = el("span", { className: "smcbx__atc-button-text" },
      localize({ en: "ADD TO CART", fr: "AJOUTER AU PANIER" }, locale));
    var button = el("button", { type: "button", className: "smcbx__atc-button" }, buttonText);

    var reviewText = el("span", { className: "smcbx__atc-reviewtext" });
    var sub = el("span", { className: "smcbx__atc-sub", hidden: true },
      el("span", { className: "smcbx__atc-stars", ariaHidden: "true" }, "★★★★★"),
      reviewText
    );

    var thumbSrc = (root.dataset.productImage || "").trim();
    if (!thumbSrc) {
      var refPhoto = document.querySelector(".smcbx__reference-photo");
      thumbSrc = refPhoto ? (refPhoto.currentSrc || refPhoto.getAttribute("src") || "") : "";
    }
    var thumb = thumbSrc
      ? el("img", { className: "smcbx__atc-thumb", src: thumbSrc, alt: "", loading: "lazy" })
      : null;

    var bar = el("div", { className: "smcbx__atc-bar is-visible" },
      el("div", { className: "smcbx__atc-inner" },
        thumb,
        el("div", { className: "smcbx__atc-info" },
          el("span", { className: "smcbx__atc-name" }, root.dataset.productTitle || ""),
          sub
        ),
        el("div", { className: "smcbx__atc-actions" },
          el("div", { className: "smcbx__atc-pricewrap" },
            compareAt,
            el("div", { className: "smcbx__atc-pricerow" },
              price,
              el("span", { className: "smcbx__atc-currency" }, String(root.dataset.currency || "CAD").toUpperCase())
            )
          ),
          button
        )
      )
    );
    document.body.appendChild(bar);
    document.body.classList.add("smcbx-has-sticky-atc");

    // Mirror this product's on-page Loox rating so the bar matches the widget
    // shown by the product title. Loox injects its widget asynchronously, so
    // poll briefly until it's populated; stay hidden if the product has none.
    var reviewTries = 0;
    function readProductRating() {
      var w = document.querySelector(".loox-rating[data-rating]") || document.querySelector(".loox-rating");
      if (!w) return null;
      var rating = (w.getAttribute("data-rating") || "").trim();
      var count = (w.getAttribute("data-raters") || w.getAttribute("data-count") || "").trim();
      var text = (w.textContent || "").replace(/\s+/g, " ").trim();
      if (!rating) { var m = text.match(/[0-9]+(?:\.[0-9]+)?/); if (m) rating = m[0]; }
      if (!count) { var c = text.match(/\(([\d,]+)\s*review/i); if (c) count = c[1].replace(/,/g, ""); }
      return rating ? { rating: rating, count: count } : null;
    }
    function syncReviews() {
      var r = readProductRating();
      if (!r) { if (reviewTries++ < 16) window.setTimeout(syncReviews, 500); return; }
      var isFr = normalizeToken(locale || "en").split("-")[0] === "fr";
      var ratingStr = isFr ? r.rating.replace(".", ",") : r.rating;
      var countNum = parseInt((r.count || "").replace(/[^0-9]/g, ""), 10);
      var label = ratingStr;
      if (countNum) {
        var word = isFr ? "avis" : (countNum === 1 ? "review" : "reviews");
        label = ratingStr + " · " + r.count + " " + word;
      }
      reviewText.textContent = label;
      sub.hidden = false;
    }
    syncReviews();

    var priceObserver = null;
    var submitObserver = null;
    var labelObserver = null;
    var syncFrame = 0;
    var lateSync = 0;

    function syncPrice() {
      var total = form.querySelector("[data-total-price]");
      if (total) price.textContent = total.textContent;
      var cmp = form.querySelector("[data-compare-total]");
      if (cmp) { compareAt.textContent = cmp.textContent; compareAt.hidden = cmp.hidden; }
    }

    function syncSubmitState() {
      var label = railSubmit.querySelector(".smcbx__submit-text") || railSubmit;
      var text = String(label.textContent || "").trim() || railSubmit.dataset.defaultText || localize({ en: "ADD TO CART", fr: "AJOUTER AU PANIER" }, locale);
      var disabled = railSubmit.disabled || railSubmit.getAttribute("aria-disabled") === "true";

      buttonText.textContent = text;
      button.disabled = disabled;
      button.classList.toggle("is-loading", railSubmit.classList.contains("is-loading"));
      button.classList.toggle("is-added", railSubmit.classList.contains("is-added"));
      if (disabled) button.setAttribute("aria-disabled", "true");
      else button.removeAttribute("aria-disabled");
    }

    function syncHeight() {
      var height = Math.ceil(bar.getBoundingClientRect().height || 0);
      document.documentElement.style.setProperty("--smcbx-sticky-atc-height", height + "px");
    }

    // Only lift the bar above Shopify's own preview / admin bar — dev-time
    // chrome pinned to the viewport bottom. Deliberately narrow: a broad
    // "anything matching /shopify/" scan also catches #shopify-chat and tall
    // page sections, which would shove the fixed bar up toward the top.
    function syncBottomOffset() {
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var nodes = document.querySelectorAll("#preview-bar-iframe, #admin-bar-iframe, iframe[src*='preview_bar'], iframe[src*='preview-bar']");
      var offset = 0;
      Array.prototype.forEach.call(nodes, function (node) {
        if (!node || node === bar) return;
        var style = window.getComputedStyle ? window.getComputedStyle(node) : null;
        if (style && (style.display === "none" || style.visibility === "hidden")) return;
        var rect = node.getBoundingClientRect();
        if (rect.height < 1 || rect.height > viewportHeight * 0.4) return;
        if (Math.abs(viewportHeight - rect.bottom) > 16) return;
        if (rect.height > offset) offset = Math.ceil(rect.height);
      });
      document.documentElement.style.setProperty("--smcbx-sticky-atc-bottom", offset + "px");
    }

    function syncAll() {
      syncPrice();
      syncSubmitState();
      syncBottomOffset();
      syncHeight();
    }

    function queueSync() {
      if (syncFrame) return;
      syncFrame = window.requestAnimationFrame(function () {
        syncFrame = 0;
        syncAll();
      });
    }

    button.addEventListener("click", function () {
      if (button.disabled) return;
      railSubmit.click();
      queueSync();
    });

    form.addEventListener("change", queueSync);
    form.addEventListener("input", queueSync);
    window.addEventListener("resize", queueSync);

    if (window.MutationObserver) {
      var total = form.querySelector("[data-total-price]");
      if (total) {
        priceObserver = new window.MutationObserver(queueSync);
        priceObserver.observe(total, { childList: true, characterData: true, subtree: true });
      }

      submitObserver = new window.MutationObserver(queueSync);
      submitObserver.observe(railSubmit, { attributes: true, attributeFilter: ["class", "disabled", "aria-disabled"] });

      var label = railSubmit.querySelector(".smcbx__submit-text");
      if (label) {
        labelObserver = new window.MutationObserver(queueSync);
        labelObserver.observe(label, { childList: true, characterData: true, subtree: true });
      }
    }

    bar._smcbxCleanup = function () {
      if (priceObserver) priceObserver.disconnect();
      if (submitObserver) submitObserver.disconnect();
      if (labelObserver) labelObserver.disconnect();
      if (syncFrame) window.cancelAnimationFrame(syncFrame);
      if (lateSync) window.clearTimeout(lateSync);
      form.removeEventListener("change", queueSync);
      form.removeEventListener("input", queueSync);
      window.removeEventListener("resize", queueSync);
      if (document.querySelector(".smcbx__atc-bar") === bar && document.body) {
        document.body.classList.remove("smcbx-has-sticky-atc", "smcbx-atc-visible");
        document.documentElement.style.removeProperty("--smcbx-sticky-atc-height");
        document.documentElement.style.removeProperty("--smcbx-sticky-atc-bottom");
      }
    };

    syncAll();
    // Shopify's preview bar mounts after our script; re-measure once it lands.
    lateSync = window.setTimeout(syncAll, 1500);
  }

  // Below 768px, entering measurements with the native keyboard hides the
  // diagram. Instead, tapping a dimension opens a focused full-screen measure
  // screen (à la Covers & All): the live diagram on top, the dimension rows and
  // fold/strap options in the middle, a "Next" button that walks you through one
  // option at a time (scrolling each into view), and a CUSTOM number pad at the
  // bottom. Mobile only; readonly inputs keep the native keyboard away.
  function setupMobilePreview(root, form, locale) {
    var visual = root._smcbxVisualColumn || form.querySelector(".smcbx__visual-column") || document.querySelector(".smcbx__visual-column");
    if (!visual || !document.body) return;
    var source = visual.querySelector(".smcbx__media") || visual;
    var formSteps = form.querySelector(".smcbx__steps") || form;
    var sizeFs = formSteps.querySelector('[data-field-id$="_size"]');
    var dims = sizeFs ? [].slice.call(sizeFs.querySelectorAll('input[type="number"]')) : [];
    // Custom mode opens the pop-up to TYPE dimensions, so it needs number inputs.
    // Model mode has a locked factory size (no inputs) but still wants the same
    // tap-to-preview pop-up for fold/strap so the shopper can watch the cover
    // update without the inline preview scrolling away.
    var isModelPreview = builderModeForRoot(root) === "model";
    if (!dims.length && !isModelPreview) return;
    var sheetTitle = localize(isModelPreview
      ? { en: "Customize your cover", fr: "Personnalisez votre housse" }
      : { en: "Measure your spa", fr: "Mesurez votre spa" }, locale);

    ["smcbx__measure", "smcbx__measure-trigger", "smcbx__dock-preview", "smcbx__sticky-preview", "smcbx__preview-sheet", "smcbx__preview-fab"].forEach(function (cls) {
      var n = document.querySelector("." + cls);
      if (n) n.remove();
    });

    function shortLabel(inp) {
      var lab = inp.id ? document.querySelector('label[for="' + inp.id + '"]') : null;
      if (!lab) lab = inp.closest("label");
      if (!lab && inp.previousElementSibling && /label|span|div|b/i.test(inp.previousElementSibling.tagName)) lab = inp.previousElementSibling;
      var t = lab ? (lab.textContent || "").trim() : (inp.name || "");
      return t.replace(/\s*\(in\.?\)\s*$/i, "").trim();
    }

    var diagram = el("div", { className: "smcbx__measure-diagram" });
    var listEl = el("div", { className: "smcbx__measure-body" });
    var closeBtn = el("button", { type: "button", className: "smcbx__measure-close", ariaLabel: localize({ en: "Close and go back", fr: "Fermer et revenir" }, locale) }, "×");
    var doneBtn = el("button", { type: "button", className: "smcbx__measure-next" }, localize({ en: "Done", fr: "Terminé" }, locale));
    var keypad = el("div", { className: "smcbx__measure-keypad" });
    var handle = el("button", { type: "button", className: "smcbx__measure-handle", ariaLabel: localize({ en: "Close and go back", fr: "Fermer et revenir" }, locale) });
    var sheet = el("div", { className: "smcbx__measure-sheet" },
      handle,
      el("div", { className: "smcbx__measure-head" },
        el("span", { className: "smcbx__measure-title" }, sheetTitle),
        closeBtn
      ),
      diagram,
      listEl,
      el("div", { className: "smcbx__measure-foot" }, doneBtn),
      keypad
    );
    var overlay = el("div", { className: "smcbx__measure", hidden: true, role: "dialog", ariaModal: "true", ariaLabel: sheetTitle }, sheet);
    document.body.appendChild(overlay);

    var mirrorFrame = 0;
    function mirror() {
      var live = source.querySelector("[data-live-preview]");
      if (live) {
        var clone = live.cloneNode(true);
        clone.removeAttribute("data-live-preview");
        clone.removeAttribute("hidden");
        diagram.innerHTML = "";
        diagram.appendChild(clone);
      }
    }
    function queueMirror() { if (mirrorFrame) return; mirrorFrame = window.requestAnimationFrame(function () { mirrorFrame = 0; mirror(); refresh(); }); }

    var stepList = [];
    var activeStep = null;


    function addDimStep(inp) {
      var valEl = el("span", { className: "smcbx__measure-row-val" });
      var row = el("button", { type: "button", className: "smcbx__measure-row" },
        el("span", { className: "smcbx__measure-row-label" }, shortLabel(inp)),
        valEl
      );
      var step = { el: row, type: "dim", input: inp, valEl: valEl, visible: function () { return inp.offsetParent !== null; } };
      row.addEventListener("click", function () { setActive(step); });
      inp.addEventListener("click", function () { openOverlay(step); });
      inp.addEventListener("focus", function () { openOverlay(step); });
      listEl.appendChild(row);
      stepList.push(step);
    }
    // The fold/strap pop-up shows a CLONE of the builder's own options markup
    // (`.smcbx__pills`/`.smcbx__cards`) so the layout matches the inline builder
    // exactly (same pills, same columns). The clone's radios are stripped — the
    // real ones stay in the form and get submitted; clicking a cloned pill checks
    // the matching real radio.
    function addChoiceFromFieldset(matchId, title) {
      var fs = formSteps.querySelector('[data-field-id*="' + matchId + '"]');
      if (!fs) return;
      var realRadios = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (!realRadios.length) return;
      var source = fs.querySelector(".smcbx__pills") || fs.querySelector(".smcbx__cards") || fs.querySelector(".smcbx__choice-stack");
      if (!source) return;
      var group = el("div", { className: "smcbx__measure-group" }, el("span", { className: "smcbx__measure-group-title" }, title));
      // Carry the fieldset's identity (data-field-id + fold-description flag) so its
      // scoped pill CSS (e.g. fold → 1 column with descriptions) styles the clone
      // even though the overlay lives outside the builder container.
      var wrap = el("div", { className: "smcbx__fieldset smcbx__measure-choice-clone" });
      ["data-field-id", "data-fold-dimension-descriptions"].forEach(function (attr) {
        if (fs.getAttribute(attr) != null) wrap.setAttribute(attr, fs.getAttribute(attr));
      });
      var clone = source.cloneNode(true);
      var cloneOpts = [];
      [].slice.call(clone.querySelectorAll('input[type="radio"]')).forEach(function (input, i) {
        var label = input.closest("label") || input.parentNode;
        var real = realRadios[i];
        if (input.parentNode) input.parentNode.removeChild(input);
        if (!label) return;
        label.removeAttribute("for");
        label.addEventListener("click", function (event) {
          event.preventDefault();
          if (!real) return;
          real.checked = true;
          real.dispatchEvent(new Event("change", { bubbles: true }));
          refresh();
          queueMirror();
        });
        cloneOpts.push({ label: label, radio: real });
      });
      wrap.appendChild(clone);
      group.appendChild(wrap);
      var step = { el: group, type: "choice", cloneOpts: cloneOpts, visible: function () { return fs.offsetParent !== null; } };
      listEl.appendChild(group);
      stepList.push(step);
      // On mobile, tapping the inline option also opens this pop-up.
      realRadios.forEach(function (r) {
        (r.closest("label") || r).addEventListener("click", function () {
          if (window.matchMedia("(max-width: 767px)").matches) openOverlay(step);
        });
      });
    }
    // The corner-radius MODE ("I measured it" / "I need help") stays INLINE on the
    // builder (it's a normal radio group in the form). Only the corner-radius
    // VALUE entry is a pop-up — its own value-only screen, opened from the C input,
    // and only reachable once "I measured it" un-hides that input. Owner: "radius
    // question on builder, dimension entering in pop up only if they measured."
    function addRadiusValueStep(inp) {
      var valEl = el("span", { className: "smcbx__measure-row-val" });
      var row = el("button", { type: "button", className: "smcbx__measure-row smcbx__measure-row--radius" },
        el("span", { className: "smcbx__measure-row-label" }, shortLabel(inp)),
        valEl
      );
      var group = el("div", { className: "smcbx__measure-group smcbx__measure-group--radius" },
        el("span", { className: "smcbx__measure-group-title" }, localize({ en: "Corner radius", fr: "Rayon du coin" }, locale)),
        row
      );
      var step = { el: group, type: "radius", opts: [], dimInput: inp, dimRow: row, dimValEl: valEl, visible: function () { return inp.offsetParent !== null; } };
      row.addEventListener("click", function () { setActive(step); });
      inp.addEventListener("click", function () { openOverlay(step); });
      inp.addEventListener("focus", function () { openOverlay(step); });
      listEl.appendChild(group);
      stepList.push(step);
    }

    // Walk the size NUMBER inputs only: length/width become dimension rows; the
    // corner-radius value gets its own value-only pop-up. The radio groups (the
    // corner-radius mode) are left INLINE on the builder — no overlay step.
    dims.forEach(function (inp) {
      if (/corner radius/i.test(inp.name)) addRadiusValueStep(inp);
      else addDimStep(inp);
    });
    // Colour/material is NOT a pop-up step — the swatch already shows the colour,
    // so (like the custom builder) it stays inline. Only fold/strap open the
    // pop-up, where the abstract choice needs the live cover to make sense.
    addChoiceFromFieldset("fold", localize({ en: "Fold orientation", fr: "Orientation du pli" }, locale));
    addChoiceFromFieldset("strap", localize({ en: "Strap placement", fr: "Emplacement des sangles" }, locale));
    // Seed the freshly-cloned fold pills with the real dimension text right away
    // (the form's recompute fires on changes; on a locked model size it may not
    // run again, leaving the clone on the generic placeholder otherwise).
    updateFoldDimensionDescriptions(form, locale);
    updateRollDimensionDescriptions(form, locale);

    function visibleSteps() { return stepList.filter(function (s) { return s.visible(); }); }
    // Re-anchor to a valid visible step when the active one disappears (fields
    // show/hide as the build changes), so navigation never dead-ends.
    function currentIndex() {
      var vs = visibleSteps(), idx = vs.indexOf(activeStep);
      if (idx === -1 && vs.length) {
        var pos = stepList.indexOf(activeStep);
        var anchor = null;
        for (var i = 0; i < vs.length; i++) { if (stepList.indexOf(vs[i]) >= pos) { anchor = vs[i]; break; } }
        activeStep = anchor || vs[vs.length - 1];
        idx = vs.indexOf(activeStep);
      }
      return idx;
    }
    function refresh() {
      // Focus one screen at a time: the size step shows the dimension rows; the
      // corner-radius and fold/strap screens show only their own options. The
      // keypad rides the dimension screens (and the radius screen once a value is
      // being entered) and is hidden elsewhere so the options get the room.
      currentIndex();
      var activeIsDim = activeStep && activeStep.type === "dim";
      // The radius screen also gets the keypad, but only once "I measured it"
      // reveals the corner-radius input (the form un-hides it).
      var radiusInput = activeStep && activeStep.type === "radius" ? activeStep.dimInput : null;
      var radiusEntry = !!(radiusInput && radiusInput.offsetParent !== null);
      stepList.forEach(function (s) {
        var show = (s.type === "dim") ? (activeIsDim && s.visible()) : (s === activeStep);
        s.el.style.display = show ? "" : "none";
        s.el.classList.toggle("is-active", s === activeStep);
        if (s.type === "dim") {
          s.valEl.textContent = s.input.value !== "" ? s.input.value + "″" : "—";
        } else {
          if (s.opts) s.opts.forEach(function (o) { o.classList.toggle("is-selected", o._radio.checked); });
          if (s.cloneOpts) s.cloneOpts.forEach(function (o) { o.label.classList.toggle("is-selected", !!(o.radio && o.radio.checked)); });
          if (s.type === "radius" && s.dimRow) {
            var cVisible = s.dimInput.offsetParent !== null;
            s.dimRow.style.display = cVisible ? "" : "none";
            s.dimRow.classList.toggle("is-active", s === activeStep && cVisible);
            s.dimValEl.textContent = s.dimInput.value !== "" ? s.dimInput.value + "″" : "—";
          }
        }
      });
      var hasKeypad = activeIsDim || radiusEntry;
      keypad.style.display = hasKeypad ? "" : "none";
      // No-keyboard screens (fold orientation, strap placement, corner-radius
      // mode) have no number pad, so let the sheet shrink-wrap its content and
      // rest at the bottom instead of stretching a few pills across the full
      // 94vh — which otherwise leaves a big empty gap below them.
      sheet.classList.toggle("smcbx__measure-sheet--compact", !hasKeypad);
      // On the corner-radius screen, zoom the diagram into the corner being
      // measured by narrowing the clone's viewBox to the top-right region.
      var dsvg = diagram.querySelector("svg");
      if (dsvg) {
        if (activeStep && activeStep.type === "radius") {
          if (!dsvg.dataset.smcbxFullVb) dsvg.dataset.smcbxFullVb = dsvg.getAttribute("viewBox") || "";
          var vp = (dsvg.dataset.smcbxFullVb || "0 0 560 500").split(/[ ,]+/).map(Number);
          var vw = vp[2] || 560, vh = vp[3] || 500;
          dsvg.setAttribute("viewBox", Math.round(vw * 0.57) + " 0 " + Math.round(vw * 0.43) + " " + Math.round(vh * 0.48));
        } else if (dsvg.dataset.smcbxFullVb) {
          dsvg.setAttribute("viewBox", dsvg.dataset.smcbxFullVb);
        }
      }
    }
    function setActive(step) {
      activeStep = step;
      refresh();
      if (step && step.el && step.el.scrollIntoView) step.el.scrollIntoView({ block: "nearest" });
    }
    // Each question is its own pop-up now (no back-to-back stepping): "Done" just
    // closes and returns to the form, where the shopper taps the next question.
    doneBtn.addEventListener("click", closeOverlay);

    ["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "del"].forEach(function (k) {
      var key = el("button", { type: "button", className: "smcbx__measure-key" }, k === "del" ? "⌫" : k);
      key.addEventListener("click", function () { press(k); });
      keypad.appendChild(key);
    });
    // The dimension fields are <input type="number">, which silently discards any
    // value that isn't a complete number — assigning "84." yields "". So a pad
    // that builds the string by reading .value back loses the decimal (and every
    // digit before it: "84." -> "" -> next tap "5" -> "5"). Strip a trailing dot
    // before writing to the field; the buffer keeps it so the next digit lands.
    function keypadFieldValue(buf) {
      return buf.charAt(buf.length - 1) === "." ? buf.slice(0, -1) : buf;
    }
    function press(k) {
      var inp = (activeStep && activeStep.type === "dim") ? activeStep.input
        : (activeStep && activeStep.type === "radius" && activeStep.dimInput && activeStep.dimInput.offsetParent !== null) ? activeStep.dimInput
        : null;
      if (!inp) return;
      // Authoritative keystroke buffer, kept on the element so a pending "." (which
      // the number field can't hold) survives between taps. Re-sync from the field
      // only when something other than this pad changed it.
      var buf = inp._smcbxKeypadBuffer;
      if (buf == null || keypadFieldValue(buf) !== (inp.value || "")) buf = inp.value || "";
      if (k === "del") buf = buf.slice(0, -1);
      else if (k === ".") { if (buf.indexOf(".") === -1) buf = (buf === "" ? "0" : buf) + "."; }
      else buf += k;
      inp._smcbxKeypadBuffer = buf;
      inp.value = keypadFieldValue(buf);
      inp.dispatchEvent(new Event("input", { bubbles: true }));
      inp.dispatchEvent(new Event("change", { bubbles: true }));
      queueMirror();
    }

    var closeTimer = 0;
    var overlayScrollY = 0;
    function openOverlay(step) {
      if (!window.matchMedia("(max-width: 767px)").matches) return;
      if (!overlay.hidden) { if (step) setActive(step); return; }
      overlayScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      window.clearTimeout(closeTimer);
      mirror();
      var vs = visibleSteps();
      activeStep = (step && step.visible()) ? step : (vs[0] || null);
      sheet.style.transform = "";
      overlay.hidden = false;
      document.body.classList.add("smcbx-measure-open");
      refresh();
      // Two frames so the off-screen start paints before we animate the slide-up.
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { overlay.classList.add("is-open"); });
      });
      if (activeStep && activeStep.el && activeStep.el.scrollIntoView) activeStep.el.scrollIntoView({ block: "nearest" });
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    }
    function closeOverlay() {
      if (overlay.hidden) return;
      sheet.style.transform = "";
      overlay.classList.remove("is-open");
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        overlay.hidden = true;
        document.body.classList.remove("smcbx-measure-open");
        // iOS Safari can jump the page to the top when body overflow:hidden is
        // removed — restore the scroll position the shopper opened the sheet at.
        window.requestAnimationFrame(function () { window.scrollTo(0, overlayScrollY); });
      }, 300);
    }
    closeBtn.addEventListener("click", closeOverlay);
    handle.addEventListener("click", closeOverlay);
    // Tap the dimmed strip above the sheet to dismiss back to the product page.
    overlay.addEventListener("click", function (e) { if (e.target === overlay) closeOverlay(); });

    // Swipe the sheet down (grab the handle) to dismiss.
    var dragStart = null;
    handle.addEventListener("touchstart", function (e) {
      var t = e.touches && e.touches[0]; if (!t) return;
      dragStart = t.clientY; sheet.style.transition = "none";
    }, { passive: true });
    handle.addEventListener("touchmove", function (e) {
      if (dragStart === null) return;
      var t = e.touches && e.touches[0]; if (!t) return;
      sheet.style.transform = "translateY(" + Math.max(0, t.clientY - dragStart) + "px)";
    }, { passive: true });
    function dragEnd(e) {
      if (dragStart === null) return;
      var t = e.changedTouches && e.changedTouches[0];
      var dy = t ? Math.max(0, t.clientY - dragStart) : 0;
      dragStart = null;
      sheet.style.transition = "";
      if (dy > 90) closeOverlay();
      else sheet.style.transform = "";
    }
    handle.addEventListener("touchend", dragEnd);
    handle.addEventListener("touchcancel", dragEnd);

    if (window.MutationObserver) {
      new window.MutationObserver(queueMirror).observe(source, { subtree: true, childList: true, characterData: true, attributes: true });
    }
    form.addEventListener("change", queueMirror);

    // Keep the native keyboard off the dimension inputs while on mobile.
    var mq = window.matchMedia("(max-width: 767px)");
    function applyMobile() { dims.forEach(function (inp) { if (mq.matches) inp.setAttribute("readonly", "readonly"); else inp.removeAttribute("readonly"); }); }
    applyMobile();
    if (mq.addEventListener) mq.addEventListener("change", applyMobile);
    else window.addEventListener("resize", applyMobile);
  }

  function validate(root, form, scope) {
    clearErrors(root);
    var locale = root.dataset.locale || "en";
    var valid = true;
    var firstInvalidFieldset = null;
    var firstInvalidControl = null;
    var area = scope || form;

    function rememberInvalid(fieldset, control) {
      if (firstInvalidFieldset) return;
      firstInvalidFieldset = fieldset;
      firstInvalidControl = control || fieldset.querySelector("input, select, textarea, button");
    }

    area.querySelectorAll("fieldset:not([hidden])").forEach(function (fieldset) {
      var fieldId = fieldset.dataset.fieldId || "";
      var requiredRadios = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"][required], input[type="radio"]')).filter(isActiveControl);
      var requiredInputs = Array.prototype.slice.call(fieldset.querySelectorAll("input[required], select[required], textarea[required]")).filter(function (input) {
        return isActiveControl(input) && input.type !== "radio";
      });

      if (fieldset.querySelector("[data-required-field]") && requiredRadios.length > 0) {
        var checked = requiredRadios.some(function (input) { return input.checked; });
        if (!checked) {
          valid = false;
          rememberInvalid(fieldset, requiredRadios[0]);
          setError(root, requiredInputErrorKey(fieldset, requiredRadios[0]), localize("This field is required.", locale));
        }
      }

      requiredInputs.forEach(function (input) {
        var missing = input.type === "checkbox" ? !input.checked : !String(input.value || "").trim();
        if (missing) {
          valid = false;
          rememberInvalid(fieldset, input);
          setError(root, requiredInputErrorKey(fieldset, input), localize("This field is required.", locale));
        }
      });

      if (!validateCornerRadiusChoice(root, fieldset, locale, rememberInvalid, false)) valid = false;
      if (!validateNumberConstraints(root, fieldset, locale, rememberInvalid, false)) valid = false;
    });

    var sizeFieldset = sizeFieldsetForForm(form);
    if (!scope || (sizeFieldset && scope.contains(sizeFieldset))) {
      if (!validateSizeRules(root, form, locale, rememberInvalid)) valid = false;
    }

    if (!valid) scrollToField(root, firstInvalidFieldset, firstInvalidControl);
    return valid;
  }

  function validateLive(root, form, target) {
    var locale = root.dataset.locale || "en";
    var fieldset = target && target.closest ? target.closest("fieldset") : null;
    var sizeFieldset = sizeFieldsetForForm(form);
    if (fieldset && !fieldset.hidden) {
      fieldset.dataset.liveTouched = "true";
      setError(root, fieldset.dataset.fieldId || "", "");
    }
    if (target && sizeFieldset && sizeFieldset.contains(target)) sizeFieldset.dataset.liveTouched = "true";
    clearSizeErrors(root, form);
    validateLiveRequiredField(root, fieldset, locale);
    validateCornerRadiusChoice(root, sizeFieldset, locale, function () {}, true);
    validateLiveSizeCompleteness(root, form, locale);
    validateNumberConstraints(root, fieldset, locale, function () {}, true);
    if (sizeFieldset && sizeFieldset !== fieldset) validateNumberConstraints(root, sizeFieldset, locale, function () {}, true);
    validateSizeRules(root, form, locale, function () {});
  }

  function validateLiveRequiredField(root, fieldset, locale) {
    if (!fieldset || fieldset.hidden || fieldset.dataset.liveTouched !== "true") return true;
    var fieldId = fieldset.dataset.fieldId || "";
    if (!fieldId) return true;

    var requiredRadios = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"][required], input[type="radio"]')).filter(isActiveControl);
    if (fieldset.querySelector("[data-required-field]") && requiredRadios.length > 0) {
      var checked = requiredRadios.some(function (input) { return input.checked; });
      if (!checked) {
        setError(root, requiredInputErrorKey(fieldset, requiredRadios[0]), localize("This field is required.", locale));
        return false;
      }
    }

    var requiredInputs = Array.prototype.slice.call(fieldset.querySelectorAll("input[required], select[required], textarea[required]")).filter(function (input) {
      return isActiveControl(input) && input.type !== "radio";
    });
    var missing = requiredInputs.find(function (input) {
      if (input.type === "checkbox") return !input.checked;
      return !String(input.value || "").trim();
    });
    if (missing) {
      setError(root, requiredInputErrorKey(fieldset, missing), localize("This field is required.", locale));
      return false;
    }

    setError(root, fieldId, "");
    return true;
  }

  function validateCornerRadiusChoice(root, fieldset, locale, rememberInvalid, onlyTouched) {
    if (!fieldset || fieldset.hidden) return true;
    var mode = fieldset.querySelector("[data-corner-radius-mode]");
    if (!mode || mode.hidden) return true;
    // Don't nag about the corner-radius choice while the shopper is still filling
    // in dimensions. The corner mode carries its OWN touched flag (not the whole
    // size fieldset's), set the first time it fails — i.e. on Add to Cart. After
    // that the error persists live until a mode is picked, then clears for good.
    if (onlyTouched && mode.dataset.liveTouched !== "true") return true;

    var radios = Array.prototype.slice.call(mode.querySelectorAll('input[type="radio"]')).filter(isActiveControl);
    if (radios.length === 0 || radios.some(function (input) { return input.checked; })) return true;

    mode.dataset.liveTouched = "true";
    if (rememberInvalid) rememberInvalid(fieldset, radios[0]);
    setError(root, cornerRadiusModeErrorKey(fieldset), localize("This field is required.", locale));
    return false;
  }

  function validateNumberConstraints(root, fieldset, locale, rememberInvalid, onlyTouched) {
    if (!fieldset || fieldset.hidden || onlyTouched && fieldset.dataset.liveTouched !== "true") return true;
    var fieldId = fieldset.dataset.fieldId || "";
    if (!fieldId) return true;
    var form = fieldset.closest ? fieldset.closest("form") : null;
    var groupId = form && form.dataset ? form.dataset.builderGroupId || "" : "";
    var numberInputs = Array.prototype.slice.call(fieldset.querySelectorAll("input[type='number']")).filter(isActiveControl);

    for (var i = 0; i < numberInputs.length; i++) {
      var input = numberInputs[i];
      var value = numericInputValue(input);
      if (!Number.isFinite(value)) continue;

      var min = parseFloat(input.min);
      if (Number.isFinite(min) && value < min) {
        rememberInvalid(fieldset, input);
        setError(root, requiredInputErrorKey(fieldset, input), numberMinMessage(min, locale));
        return false;
      }

      var max = parseFloat(input.max);
      if (Number.isFinite(max) && value > max) {
        if (shouldDeferHotTubSizeMax(fieldset, input, groupId)) continue;
        rememberInvalid(fieldset, input);
        setError(root, requiredInputErrorKey(fieldset, input), numberMaxMessage(max, locale));
        return false;
      }
    }

    return true;
  }

  function numericInputValue(input) {
    if (!input || !String(input.value || "").trim()) return NaN;
    if (typeof input.valueAsNumber === "number" && Number.isFinite(input.valueAsNumber)) return input.valueAsNumber;
    return parseFloat(String(input.value || "").trim());
  }

  function numberMinMessage(min, locale) {
    return localize({
      en: "Enter at least " + inchesLabel(formatInchNumber(min), locale) + ".",
      fr: "Entrez au moins " + inchesLabel(formatInchNumber(min), locale) + "."
    }, locale);
  }

  function numberMaxMessage(max, locale) {
    return localize({
      en: "Enter " + inchesLabel(formatInchNumber(max), locale) + " or less.",
      fr: "Entrez " + inchesLabel(formatInchNumber(max), locale) + " ou moins."
    }, locale);
  }

  function formatInchNumber(value) {
    var numeric = parseFloat(value);
    if (!Number.isFinite(numeric)) return "";
    return Number.isInteger(numeric) ? String(numeric) : String(Math.round(numeric * 100) / 100);
  }

  function clearSizeErrors(root, form) {
    Array.prototype.slice.call(form.querySelectorAll('[data-field-id="cover_size"], [data-field-id="rollaway_size"]')).forEach(function (fieldset) {
      var fieldId = fieldset.dataset.fieldId || "cover_size";
      setError(root, fieldId, "");
      setError(root, fieldScopedErrorKey(fieldId, "primary"), "");
      setError(root, fieldScopedErrorKey(fieldId, "corner_mode"), "");
      setError(root, fieldScopedErrorKey(fieldId, "corner_radius"), "");
    });
  }

  function validateLiveSizeCompleteness(root, form, locale) {
    var sizeFieldset = sizeFieldsetForForm(form);
    if (!sizeFieldset || sizeFieldset.dataset.liveTouched !== "true") return true;
    var requiredSizeInputs = primarySizeInputs(sizeFieldset).filter(function (input) {
      return input.required && isActiveControl(input);
    });
    var missing = requiredSizeInputs.find(function (input) {
      return !String(input.value || "").trim();
    });
    if (!missing) return true;
    setError(root, sizePrimaryErrorKey(sizeFieldset), localize("This field is required.", locale));
    return false;
  }

  function validateSizeRules(root, form, locale, rememberInvalid) {
    var valid = true;
    if (isFixedSpecBuilderGroup(form._smcbxGroup)) return valid;

    var groupId = form.dataset.builderGroupId;
    if (isHotTubSizeCappedGroupId(groupId)) {
      var sizeFieldset = form.querySelector('[data-field-id="cover_size"]:not([hidden]), [data-field-id="rollaway_size"]:not([hidden])');
      var oversizedControl = sizeFieldset ? Array.prototype.slice.call(sizeFieldset.querySelectorAll("input[type='number']"))
        .filter(isActiveControl)
        .find(function (input) {
          if (!isPrimarySizeInput({ property: propertyNameFromInput(input) })) return false;
          var value = parseFloat(String(input.value || "").replace(/[^0-9.]/g, ""));
          return Number.isFinite(value) && value > HOT_TUB_COVER_MAX_SIZE_INCHES;
        }) : null;

      if (oversizedControl) {
        // Still block the order, but don't print a message here: the live size
        // notice (updateSizeContext) already shows the richer "swim spa size —
        // switch to the swim spa builder / request a quote" guidance under the
        // dimensions. Setting an error too would duplicate it at the bottom.
        valid = false;
        rememberInvalid(sizeFieldset, oversizedControl);
      } else {
        var hotTubLength = parseSizeInches(propertyValue(form, "Cover Length A"));
        var hotTubWidth = parseSizeInches(propertyValue(form, "Cover Width B"));
        if (Number.isFinite(hotTubLength) && Number.isFinite(hotTubWidth) &&
            hotTubLength > REGULAR_SIZE_MAX_INCHES && hotTubWidth > REGULAR_SIZE_MAX_INCHES) {
          // Same one-oversized-side rule as swim spas: only one side may exceed
          // the regular 96 in. Block silently — updateSizeContext shows the
          // custom-quote notice under the inputs.
          valid = false;
          rememberInvalid(sizeFieldset, sizeFieldset ? sizeFieldset.querySelector("input[type='number']") : null);
        }
      }
    }

    if (isSwimSpaGroupId(groupId)) {
      var swimSpaSizeFieldset = form.querySelector('[data-field-id="cover_size"]:not([hidden]), [data-field-id="rollaway_size"]:not([hidden])');
      var swimSpaLength = parseSizeInches(propertyValue(form, "Cover Length A"));
      var swimSpaWidth = parseSizeInches(propertyValue(form, "Cover Width B"));

      var hasSwimSpaLength = Number.isFinite(swimSpaLength);
      var hasSwimSpaWidth = Number.isFinite(swimSpaWidth);
      if (hasSwimSpaLength || hasSwimSpaWidth) {
        var swimSpaLongestSide = Math.max(hasSwimSpaLength ? swimSpaLength : 0, hasSwimSpaWidth ? swimSpaWidth : 0);
        if (swimSpaLongestSide > SWIM_SPA_MAX_LONG_SIDE_INCHES) {
          valid = false;
          rememberInvalid(swimSpaSizeFieldset, swimSpaSizeFieldset ? swimSpaSizeFieldset.querySelector("input[type='number']") : null);
          setError(root, sizePrimaryErrorKey(swimSpaSizeFieldset), localize(SWIM_SPA_MAX_LONG_SIDE_MESSAGE, locale));
        } else if (hasSwimSpaLength && hasSwimSpaWidth && swimSpaLongestSide < swimSpaMinimumLongSide(groupId)) {
          valid = false;
          rememberInvalid(swimSpaSizeFieldset, swimSpaSizeFieldset ? swimSpaSizeFieldset.querySelector("input[type='number']") : null);
          setError(root, sizePrimaryErrorKey(swimSpaSizeFieldset), localize(swimSpaMinimumLongSideMessage(groupId), locale));
        } else if (hasSwimSpaLength && hasSwimSpaWidth && swimSpaLength > REGULAR_SIZE_MAX_INCHES && swimSpaWidth > REGULAR_SIZE_MAX_INCHES) {
          // Only one side may exceed the regular 96 in. — the shorter side has to
          // stay within regular width or the cover can't be manufactured as-is.
          valid = false;
          rememberInvalid(swimSpaSizeFieldset, swimSpaSizeFieldset ? swimSpaSizeFieldset.querySelector("input[type='number']") : null);
          setError(root, sizePrimaryErrorKey(swimSpaSizeFieldset), localize(SWIM_SPA_TWO_OVERSIZED_SIDES_MESSAGE, locale));
        }
      }
    }

    return valid;
  }

  function sizeFieldsetForForm(form) {
    return form.querySelector('[data-field-id="cover_size"]:not([hidden]), [data-field-id="rollaway_size"]:not([hidden])');
  }

  function isSizeFieldset(fieldset) {
    return Boolean(fieldset && isSizeField({ id: fieldset.dataset.fieldId || "" }));
  }

  function fieldScopedErrorKey(fieldId, suffix) {
    return (fieldId || "field") + "__" + suffix;
  }

  function sizePrimaryErrorKey(fieldset) {
    return fieldScopedErrorKey(fieldset && fieldset.dataset.fieldId || "cover_size", "primary");
  }

  function cornerRadiusModeErrorKey(fieldset) {
    return fieldScopedErrorKey(fieldset && fieldset.dataset.fieldId || "cover_size", "corner_mode");
  }

  function cornerRadiusInputErrorKey(fieldset) {
    return fieldScopedErrorKey(fieldset && fieldset.dataset.fieldId || "cover_size", "corner_radius");
  }

  function requiredInputErrorKey(fieldset, input) {
    if (!isSizeFieldset(fieldset)) return fieldset.dataset.fieldId || "";
    var property = propertyNameFromInput(input);
    if (property === "Cover Length A" || property === "Cover Width B") return sizePrimaryErrorKey(fieldset);
    // Corner Radius and cut/radius dimensions share the secondary grid; keep their
    // errors under that grid, not at the catch-all node at the bottom of the step.
    if (property === "Corner Radius" || property === "Cover Dimension C" || property === "Cover Dimension D") return cornerRadiusInputErrorKey(fieldset);
    return fieldset.dataset.fieldId || "cover_size";
  }

  function primarySizeInputs(fieldset) {
    if (!fieldset) return [];
    return Array.prototype.slice.call(fieldset.querySelectorAll("input[type='number']")).filter(function (input) {
      return isPrimarySizeInput({ property: propertyNameFromInput(input) });
    });
  }

  function shouldDeferHotTubSizeMax(fieldset, input, groupId) {
    return isHotTubSizeCappedGroupId(groupId) &&
      isSizeFieldset(fieldset) &&
      isPrimarySizeInput({ property: propertyNameFromInput(input) });
  }

  function scrollToField(root, fieldset, control) {
    if (!fieldset) return;
    var offset = stickyScrollOffset();
    var top = fieldset.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: "smooth"
    });
    window.setTimeout(function () {
      var focusTarget = control || fieldset.querySelector("input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])");
      if (!focusTarget || typeof focusTarget.focus !== "function") return;
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (error) {
        focusTarget.focus();
      }
    }, 280);
  }

  function stickyScrollOffset() {
    var offset = 112;
    var selectors = [
      ".shopify-section-header-sticky",
      "theme-header",
      ".header-section",
      "header[role='banner']"
    ];
    selectors.forEach(function (selector) {
      var node = document.querySelector(selector);
      if (!node) return;
      var rect = node.getBoundingClientRect();
      if (rect.height <= 0) return;
      offset = Math.max(offset, Math.ceil(rect.bottom + 18));
    });
    return offset;
  }

  function getSelectedOptions(form, addonMap) {
    var selected = Array.prototype.slice.call(form.querySelectorAll("input:checked[data-option-key], input:checked[data-price-cents]"))
      .filter(isActiveControl)
      .map(function (input) {
        var key = input.dataset.optionKey || "";
        var config = key ? addonMap[key] : null;
        return {
          key: key,
          label: input.dataset.optionLabel || input.value,
          listName: input.dataset.listName || "",
          priceCents: getConfiguredPriceCents(input, config),
          compareAtPriceCents: getConfiguredCompareAtPriceCents(input, config),
          addonVariantId: input.dataset.variantId || (config && typeof config === "object"
            ? String(config.variant_id || config.variantId || config.id || "")
            : config ? String(config) : "")
        };
      });
    return selected.concat(getAutomaticSelections(form, addonMap));
  }

  function getAutomaticSelections(form, addonMap) {
    return getSizePricingSelection(form, addonMap).filter(Boolean);
  }

  function getSizePricingSelection(form, addonMap) {
    var group = form._smcbxGroup || {};
    // Model swim spas carry their complete length-based price on the selected
    // product variant. Keep the automatic length add-on for the custom swim-spa
    // builder only, so model products cannot be charged for their size twice.
    if (isModelLikeBuilderGroup(group) && isRegularSwimSpaGroupId(group.id)) return [];
    var sizePricing = group.sizePricing || {};
    var variants = Array.isArray(sizePricing.variants) ? sizePricing.variants : [];
    if (variants.length === 0) return [];

    var length = parseSizeInches(propertyValue(form, "Cover Length A"));
    var width = parseSizeInches(propertyValue(form, "Cover Width B"));
    var isRound = shapeKind(selectedValue(form, "Cover Shape", "")) === "round";
    // Round covers store only their diameter in A. Price that measurement
    // directly; B is hidden and may contain an old rectangular selection.
    if (!Number.isFinite(length) || (!isRound && !Number.isFinite(width))) return [];

    // Both sides over 96 in. is quote-only territory (validateSizeRules blocks
    // it) — don't bill an oversize/length fee on a config that can't be ordered.
    if (!isRound && length > REGULAR_SIZE_MAX_INCHES && width > REGULAR_SIZE_MAX_INCHES) return [];

    var longestSide = isRound ? length : Math.max(length, width);
    var variant = pickSizePricingVariant(variants, longestSide);
    if (!variant) return [];

    var key = variant.key || sizePricing.key || "length:" + normalizeToken(variant.label || sizePricing.label || "swim-spa-length");
    var config = key ? addonMap[key] : null;
    var fallbackPrice = parseInt(variant.priceCents || variant.price_cents || 0, 10) || 0;
    var fallbackCompareAt = parseInt(variant.compareAtPriceCents || variant.compare_at_price_cents || 0, 10) || 0;
    var label = variant.label || sizePricing.label || "Swim Spa Cover Length";

    return [{
      key: key,
      label: label,
      listName: variant.listName || sizePricing.listName || "",
      priceCents: getConfigCents(config, ["price_cents", "priceCents"], fallbackPrice),
      compareAtPriceCents: getConfigCents(config, ["compare_at_price_cents", "compareAtPriceCents"], fallbackCompareAt),
      addonVariantId: variant.variantId || variant.variant_id || (config && typeof config === "object"
        ? String(config.variant_id || config.variantId || config.id || "")
        : config ? String(config) : "")
    }];
  }

  function pickSizePricingVariant(variants, longestSide) {
    return variants.find(function (variant) {
      var min = parseFloat(variant.minLongestSide || variant.min_longest_side || variant.min || 0);
      var max = parseFloat(variant.maxLongestSide || variant.max_longest_side || variant.max || 0);
      return longestSide >= min && (!max || longestSide <= max);
    }) || null;
  }

  // Oversized hot-tub covers (longest side over 96 in., up to 119) carry an auto
  // fee via the shared size-pricing path (same mechanism as swim-spa length). The
  // tiers come from the section's data-*-fee attributes so the fee amounts and
  // variant ids stay configurable without code changes.
  function parseSizeFeeTiers(root, datasetKey, label) {
    var tiers = [];
    try {
      var raw = (root && root.dataset ? root.dataset[datasetKey] : "") || "";
      if (raw.trim()) tiers = JSON.parse(raw);
    } catch (e) { tiers = []; }
    return Array.isArray(tiers) && tiers.length ? { label: label, variants: tiers } : null;
  }

  function oversizedFeePricing(root) {
    if (root._smcbxOversizedFee !== undefined) return root._smcbxOversizedFee;
    root._smcbxOversizedFee = parseSizeFeeTiers(root, "oversizedFee", "Oversized Cover Fee");
    return root._smcbxOversizedFee;
  }

  // Rollaway covers carry their own oversized schedule (the rollaway premium doubles
  // on big covers) instead of the regular cover fee — data-rollaway-oversized-fee.
  function rollawayOversizedFeePricing(root) {
    if (root._smcbxRollawayOversizedFee !== undefined) return root._smcbxRollawayOversizedFee;
    root._smcbxRollawayOversizedFee = parseSizeFeeTiers(root, "rollawayOversizedFee", "Oversized Rollaway Fee");
    return root._smcbxRollawayOversizedFee;
  }

  // The standalone rollaway builder bills the rollaway schedule; every other custom
  // hot-tub builder bills the regular oversized fee. (Model pages don't use sizePricing
  // at all — they price the rollaway upgrade by size on the cover-type option itself,
  // see rollawayUpgradeTierForLongestSide.)
  function sizeFeePricingForGroup(root, groupId) {
    if (isRollawayHotTubGroupId(groupId)) return rollawayOversizedFeePricing(root) || oversizedFeePricing(root);
    return oversizedFeePricing(root);
  }

  // Custom hot-tub / rollaway hot-tub builders only. Models are pre-priced (their
  // variant already reflects oversize); swim spas keep their own length pricing.
  function attachOversizedFeePricing(root, group) {
    if (!group || group.sizePricing) return;
    if (!isHotTubSizeCappedGroupId(group.id) || isFixedSpecBuilderGroup(group)) return;
    var pricing = sizeFeePricingForGroup(root, group.id);
    if (pricing) {
      pricing.addonProductHandle = pricing.addonProductHandle || "oversized-cover-fee";
      group.sizePricing = pricing;
    }
  }

  // On model pages "Rollaway" is an in-place priced option (a +$525 upgrade line),
  // NOT a link to the standalone rollaway product — owner 2026-06-20: "just an
  // add-on for rollaway." Config (variant id + price) comes from the section's
  // data-rollaway-upgrade attribute.
  function rollawayUpgradeConfig(root) {
    if (root._smcbxRollawayUpgrade !== undefined) return root._smcbxRollawayUpgrade;
    var cfg = null;
    try {
      var raw = (root && root.dataset ? root.dataset.rollawayUpgrade : "") || "";
      if (raw.trim()) cfg = JSON.parse(raw);
    } catch (e) { cfg = null; }
    if (cfg && !(cfg.variantId && cfg.priceCents)) cfg = null;
    root._smcbxRollawayUpgrade = cfg;
    return cfg;
  }

  function rollawaySwimSpaUpgradePricing(root) {
    if (root._smcbxRollawaySwimSpaUpgrades !== undefined) return root._smcbxRollawaySwimSpaUpgrades;
    root._smcbxRollawaySwimSpaUpgrades = parseSizeFeeTiers(root, "rollawaySwimSpaUpgrades", "Rollaway Swim Spa Upgrade");
    return root._smcbxRollawaySwimSpaUpgrades;
  }

  function hasModelRollawayUpgrade(root, groupId) {
    if (isRegularSwimSpaGroupId(groupId)) return Boolean(rollawaySwimSpaUpgradePricing(root));
    return Boolean(rollawayUpgradeConfig(root));
  }

  // The rollaway upgrade is the base premium for covers up to 104 in.; on bigger
  // covers (104.5–119 in.) it doubles, matching the standalone rollaway builder's
  // oversized schedule. Reuse that schedule as the single source: pick its tier for
  // this size and only upgrade the variant/price when the tier exceeds the base
  // premium (the 96.5–104 tier equals the base, so it stays the base upgrade).
  function rollawayUpgradeTierForLongestSide(root, longest) {
    var cfg = rollawayUpgradeConfig(root) || {};
    var base = { priceCents: parseInt(cfg.priceCents, 10) || 0, variantId: String(cfg.variantId || ""), key: cfg.key || "cover-type-rollaway" };
    if (!Number.isFinite(longest) || longest <= 0) return base;
    var pricing = rollawayOversizedFeePricing(root);
    if (!pricing) return base;
    var tier = pickSizePricingVariant(pricing.variants, longest);
    if (!tier) return base;
    var tierCents = parseInt(tier.priceCents || tier.price_cents || 0, 10) || 0;
    if (tierCents <= base.priceCents) return base;
    return { priceCents: tierCents, variantId: String(tier.variantId || tier.variant_id || ""), key: base.key };
  }

  function modelRollawayUpgradeTier(root, groupId, longest) {
    if (!isRegularSwimSpaGroupId(groupId)) return rollawayUpgradeTierForLongestSide(root, longest);
    var pricing = rollawaySwimSpaUpgradePricing(root);
    if (!pricing || !Number.isFinite(longest) || longest <= 0) return null;
    var tier = pickSizePricingVariant(pricing.variants, longest);
    if (!tier) return null;
    return {
      priceCents: parseInt(tier.priceCents || tier.price_cents || 0, 10) || 0,
      variantId: String(tier.variantId || tier.variant_id || ""),
      key: tier.key || "cover-type-rollaway"
    };
  }

  // Longest side of the currently-selected model variant (model pages price the
  // rollaway upgrade off the model's fixed cover size, not a typed-in size).
  function selectedModelLongestSide(root) {
    var specs = modelVariantSpecs(root);
    if (!Array.isArray(specs) || !specs.length) return NaN;
    var selectedId = String(root.dataset.variantId || "");
    var spec = specs.filter(function (s) { return String(s.variantId) === selectedId; })[0] || specs[0];
    if (!spec) return NaN;
    var longest = Math.max(parseFloat(spec.length) || 0, parseFloat(spec.width) || 0);
    return longest > 0 ? longest : NaN;
  }

  function formLongestSide(form) {
    var length = parseSizeInches(propertyValue(form, "Cover Length A"));
    var width = parseSizeInches(propertyValue(form, "Cover Width B"));
    if (!Number.isFinite(length) && !Number.isFinite(width)) return NaN;
    return Math.max(Number.isFinite(length) ? length : 0, Number.isFinite(width) ? width : 0);
  }

  // Re-price the live Rollaway cover-type option for the current model size (its size
  // can change on multi-size models). Mutates the radio's dataset + pill price so the
  // existing total/cart/summary machinery picks up the doubled premium with no special
  // casing. No-op when there's no cover-type field (i.e. not a model page).
  function retierRollawayUpgrade(root, form, currency, locale) {
    var input = form.querySelector('input[data-field-id="cover_type"][value="Rollaway"]');
    if (!input) return;
    var groupId = form._smcbxGroup && form._smcbxGroup.id;
    var tier = modelRollawayUpgradeTier(root, groupId, formLongestSide(form));
    if (!tier || !tier.variantId) return;
    input.dataset.priceCents = String(tier.priceCents);
    input.dataset.variantId = tier.variantId;
    input.dataset.optionKey = tier.key;
    var pill = input.closest(".smcbx__cover-type-pill");
    var priceSpan = pill ? pill.querySelector(".smcbx__cover-type-pill-price") : null;
    if (priceSpan) priceSpan.textContent = tier.priceCents > 0 ? "+" + formatMoney(tier.priceCents, currency, locale) : "";
  }

  // A normal pills field so the existing option/price/cart machinery handles it:
  // picking Rollaway flags the parent line "Cover Type: Rollaway" and adds the
  // upgrade variant as a bundled premium line (doubled on oversized covers; see
  // retierRollawayUpgrade, which keeps it in sync when the model size changes).
  function rollawayCoverTypeField(root, groupId) {
    if (!hasModelRollawayUpgrade(root, groupId)) return null;
    var tier = modelRollawayUpgradeTier(root, groupId, selectedModelLongestSide(root));
    if (!tier || !tier.variantId) return null;
    return {
      id: "cover_type",
      title: "Select cover type",
      type: "cover_type_choice",
      property: "Cover Type",
      required: true,
      options: [
        { id: "traditional", label: "Traditional", value: "Traditional", key: "cover-type-traditional", selected: true },
        { id: "rollaway", label: "Rollaway", value: "Rollaway", key: tier.key || "cover-type-rollaway", priceCents: tier.priceCents, variantId: tier.variantId }
      ]
    };
  }

  // Fields that don't apply to a rollaway cover (it doesn't fold, has no separate
  // foam thickness tiers, no strap placement, and its own upgrade/accessory set).
  // Hidden — not removed — so switching back to Traditional restores them with
  // their prior state intact. Their inputs disable while hidden, so they drop out
  // of pricing, the cart, and the on-page summary (see isActiveControl).
  var ROLLAWAY_HIDDEN_FIELD_IDS = {
    cover_thickness: true,
    fold_orientation: true,
    strap_placement: true,
    cover_upgrades: true,
    accessories: true,
    current_lifter_system: true
  };

  function withRollawayCoverType(root, group, fields, groups) {
    var coverTypeField = rollawayCoverTypeField(root, group && group.id);
    if (!coverTypeField) return fields;
    if ((fields || []).some(function (f) { return f && f.id === "cover_type"; })) return fields;

    var construction = rollawayConstructionFields(groups, group && group.id);
    var output = [coverTypeField];
    (fields || []).forEach(function (field) {
      if (field && field.id === "material_color" && construction.material) {
        output.push(mergeRollawayOptions(field, construction.material));
        return;
      }
      if (field && field.id === "skirt_length" && construction.skirt) {
        output.push(mergeRollawayOptions(field, construction.skirt));
        return;
      }
      if (field && ROLLAWAY_HIDDEN_FIELD_IDS[field.id]) {
        output.push(Object.assign({}, field, { hideForRollaway: true }));
        // A rollaway does not fold, but it does roll, and the roll question
        // belongs exactly where the fold question just went away.
        if (field.id === "fold_orientation" && construction.roll) output.push(construction.roll);
        if (field.id === "accessories" && construction.accessories) output.push(construction.accessories);
        return;
      }
      output.push(field);
    });
    if (construction.roll && output.indexOf(construction.roll) === -1) {
      output.push(construction.roll);
    }
    if (construction.accessories && output.indexOf(construction.accessories) === -1) {
      output.push(construction.accessories);
    }
    return output;
  }

  // Pull the standalone rollaway builder's material + accessory fields so a model
  // page in "Rollaway" mode mirrors that builder (AquaTEX-included colours, rollaway
  // accessories) without re-rendering or navigating away.
  function rollawayConstructionFields(groups, sourceGroupId) {
    var targetGroupId = isRegularSwimSpaGroupId(sourceGroupId) ? "rollaway-swim-spa-covers" : "rollaway-hot-tub-covers";
    var group = (Array.isArray(groups) ? groups : []).find(function (g) {
      return g && g.id === targetGroupId;
    });
    var sourceFields = group && Array.isArray(group.fields) ? group.fields : [];
    var material = cloneBuilderField(findBuilderField(sourceFields, "rollaway_material_color"));
    var skirt = cloneBuilderField(findBuilderField(sourceFields, "rollaway_skirt_length"));
    var accessories = cloneBuilderField(findBuilderField(sourceFields, "rollaway_accessories"));
    if (accessories) accessories.showForRollaway = true;
    var roll = withModelRollOrientationField(cloneBuilderField(findBuilderField(sourceFields, "rollaway_roll_orientation")));
    if (roll) roll.showForRollaway = true;
    return { material: material, skirt: skirt, accessories: accessories, roll: roll };
  }

  // Keep a single "Material & Color" field (so the existing name-keyed machinery —
  // cart property, preview swatch, summary — keeps working) but show the traditional
  // swatches only for Traditional and the rollaway AquaTEX swatches only for Rollaway,
  // via per-option visibleWhen on cover_type. ensureVisibleSelection re-defaults the
  // pick when the active set changes.
  function mergeRollawayOptions(traditionalField, rollawayField) {
    var merged = cloneBuilderField(traditionalField);
    merged.options = (merged.options || []).map(function (option) {
      return Object.assign({}, option, { visibleWhen: { field: "cover_type", in: ["Traditional"] } });
    });
    (rollawayField.options || []).forEach(function (option) {
      merged.options.push(Object.assign({}, option, {
        selected: false,
        isDefault: option.selected === true,
        visibleWhen: { field: "cover_type", in: ["Rollaway"] }
      }));
    });
    return merged;
  }

  function getConfiguredPriceCents(input, config) {
    return getConfigCents(config, ["price_cents", "priceCents"], parseInt(input.dataset.priceCents || "0", 10) || 0);
  }

  function getConfiguredCompareAtPriceCents(input, config) {
    return getConfigCents(
      config,
      ["compare_at_price_cents", "compareAtPriceCents"],
      parseInt(input.dataset.compareAtPriceCents || "0", 10) || 0
    );
  }

  function getConfigCents(config, keys, fallback) {
    if (config && typeof config === "object") {
      for (var i = 0; i < keys.length; i += 1) {
        if (config[keys[i]] === undefined) continue;
        var parsed = parseInt(config[keys[i]], 10);
        if (Number.isFinite(parsed)) return parsed;
      }
    }
    return fallback || 0;
  }

  function calculateTotals(form, addonMap, basePriceCents, baseCompareAtPriceCents) {
    var paidSelections = getSelectedOptions(form, addonMap).filter(function (selection) {
      return selection.priceCents > 0;
    });
    var addonCents = paidSelections.reduce(function (sum, selection) {
      return sum + selection.priceCents;
    }, 0);
    var totalCents = basePriceCents + addonCents;
    var compareAtBaseCents = baseCompareAtPriceCents > basePriceCents ? baseCompareAtPriceCents : basePriceCents;
    var compareAtAddonCents = paidSelections.reduce(function (sum, selection) {
      return sum + (selection.compareAtPriceCents > selection.priceCents ? selection.compareAtPriceCents : selection.priceCents);
    }, 0);
    var compareAtTotalCents = compareAtBaseCents + compareAtAddonCents;
    var savingsCents = compareAtTotalCents > totalCents ? compareAtTotalCents - totalCents : 0;
    return {
      paidSelections: paidSelections,
      addonCents: addonCents,
      totalCents: totalCents,
      compareAtTotalCents: compareAtTotalCents,
      savingsCents: savingsCents
    };
  }

  function buildBaseSummary(form, locale) {
    var model = selectedValue(form, "Hot Tub Make & Model", "");
    var thickness = selectedValue(form, "Cover Thickness", "");
    var shape = selectedValue(form, "Cover Shape", "");
    var material = selectedValue(form, "Material & Color", "");
    var skirt = selectedValue(form, "Skirt Length", "");
    var fold = cutValue(selectedValue(form, "Fold Orientation", ""));
    var length = selectedValue(form, "Cover Length A", "");
    var width = selectedValue(form, "Cover Width B", "");
    var dimensionC = selectedValue(form, "Cover Dimension C", "");
    var radius = selectedValue(form, "Corner Radius", "");
    var dimensionD = selectedValue(form, "Cover Dimension D", "");
    var radiusMode = selectedValue(form, "Corner Radius Measurement", "");
    var radiusHelp = radiusMode === CORNER_RADIUS_HELP_VALUE;
    var measurementTemplate = measurementTemplateFor(shape);
    var radiusLetter = measurementTemplate === "a_b_c_d_cut" ? "D" : "C";
    var coverChoices = [thickness, material, skirt ? skirt + " " + localize("skirt", locale) : ""].filter(Boolean).join(" / ");
    var measurements = [];

    if (length) measurements.push("A " + inchesLabel(length, locale));
    if (width) measurements.push("B " + inchesLabel(width, locale));
    if (dimensionC) measurements.push("C " + inchesLabel(dimensionC, locale));
    if (radius) measurements.push(radiusLetter + " " + radiusInchesLabel(radius, locale));
    if (dimensionD) measurements.push("D " + inchesLabel(dimensionD, locale));
    if (!radius && radiusHelp) measurements.push(radiusLetter + " " + localize(CORNER_RADIUS_HELP_SUMMARY, locale));
    if (fold) measurements.push(localize("Cut", locale) + " " + fold);

    return [model, shape, coverChoices, measurements.join(" / ")].filter(Boolean).join("||");
  }

  function buildCartDetails(form, addonMap, currency, locale) {
    var selections = getSelectedOptions(form, addonMap);
    var rows = [];
    var model = selectedValue(form, "Hot Tub Make & Model", "");
    var selectedSize = selectedValue(form, "Selected Size", "");
    var shape = selectedValue(form, "Cover Shape", "");
    var length = selectedValue(form, "Cover Length A", "");
    var width = selectedValue(form, "Cover Width B", "");
    var dimensionC = selectedValue(form, "Cover Dimension C", "");
    var radius = selectedValue(form, "Corner Radius", "");
    var dimensionD = selectedValue(form, "Cover Dimension D", "");
    var radiusMode = selectedValue(form, "Corner Radius Measurement", "");
    var radiusHelp = radiusMode === CORNER_RADIUS_HELP_VALUE;
    var measurementTemplate = measurementTemplateFor(shape);
    var radiusLabel = measurementTemplate === "a_b_c_d_cut" ? "D corner radius" : "C corner radius";
    var fold = cutValue(selectedValue(form, "Fold Orientation", ""));
    var roll = rollCartValue(selectedValue(form, "Roll Orientation", ""), length, width, locale);
    var strap = selectedValue(form, "Strap Placement", "");
    var lifterSystem = selectedValue(form, "Lifter Plates", "");
    var speakerPocketCount = selectedValue(form, "Speaker Pocket Count", "");

    addCartSection(rows, localize("Measurements & build", locale));
    addCartRow(rows, localize("Hot tub model", locale), model);
    addCartRow(rows, localize("Selected size", locale), selectedSize);
    addCartRow(rows, localize("Shape", locale), shape);
    addCartRow(rows, localize("A length", locale), length ? inchesLabel(length, locale) : "");
    addCartRow(rows, localize("B width", locale), width ? inchesLabel(width, locale) : "");
    addCartRow(rows, localize("C dimension", locale), dimensionC ? inchesLabel(dimensionC, locale) : "");
    addCartRow(rows, localize(radiusLabel, locale), radius ? inchesLabel(radius, locale) : radiusHelp ? localize(CORNER_RADIUS_HELP_SUMMARY, locale) : "");
    addCartRow(rows, localize("D dimension", locale), dimensionD ? inchesLabel(dimensionD, locale) : "");
    addCartRow(rows, localize("Speaker pockets", locale), speakerPocketCount);
    addCartRow(rows, localize("Cut", locale), fold);
    addCartRow(rows, localize("Roll direction", locale), roll);
    addCartRow(rows, localize("Strap placement", locale), strap);
    addCartRow(rows, localize("Lifter Plates", locale), lifterSystem);

    // On model configurators "Rollaway" is a paid upgrade bundled into the parent
    // line (its own line is hidden in cart), and the product title stays the model
    // name — so without this row nothing tells the shopper they picked a rollaway
    // cover. Surface it (with the +fee) whenever the rollaway upgrade is selected.
    addPricedSelections(rows, selections, localize("Cover type", locale), function (selection) {
      return selection.priceCents > 0 && selection.key.indexOf("cover-type-") === 0;
    }, currency, locale);

    addPricedSelections(rows, selections, localize("Cover choices", locale), function (selection) {
      return selection.priceCents > 0 && (
        selection.key.indexOf("thickness:") === 0 ||
        selection.key.indexOf("length:") === 0 ||
        selection.key.indexOf("material:") === 0 ||
        selection.key.indexOf("skirt:") === 0
      );
    }, currency, locale);

    addPricedSelections(rows, selections, localize("Cover upgrades", locale), function (selection) {
      return selection.priceCents > 0 && (
        selection.key.indexOf("upgrade:") === 0 ||
        selection.listName === "Cover Upgrades"
      );
    }, currency, locale);

    addPricedSelections(rows, selections, localize("Added items", locale), function (selection) {
      return selection.priceCents > 0 && (
        selection.key.indexOf("accessory:") === 0 ||
        selection.key.indexOf("rollaway-accessory:") === 0 ||
        selection.listName.indexOf("Accessories") !== -1
      );
    }, currency, locale);

    return rows.join("|||");
  }

  function addPricedSelections(rows, selections, title, predicate, currency, locale) {
    var matches = selections.filter(predicate);
    if (matches.length === 0) return;
    addCartSection(rows, title);
    matches.forEach(function (selection) {
      addPricedCartRow(rows, cartDetailLabel(selection, locale), selection.priceCents, selection.compareAtPriceCents, currency, locale);
    });
  }

  function addCartSection(rows, title) {
    if (title) rows.push(["section", title].join("::"));
  }

  function addCartRow(rows, label, value) {
    if (!label || !value) return;
    rows.push([label, value].join("::"));
  }

  function addPricedCartRow(rows, label, priceCents, compareAtPriceCents, currency, locale) {
    if (!label || priceCents <= 0) return;
    var price = "+" + formatMoney(priceCents, currency, locale);
    var compareAt = compareAtPriceCents > priceCents ? "+" + formatMoney(compareAtPriceCents, currency, locale) : "";
    rows.push([label, price, compareAt].join("::"));
  }

  function cartDetailLabel(selection, locale) {
    if (selection.key.indexOf("thickness:") === 0) return selection.label + " " + localize("thickness", locale);
    if (selection.key.indexOf("skirt:") === 0) return selection.label + " " + localize("skirt", locale);
    return selection.label;
  }

  function rollCartValue(label, length, width, locale) {
    var letter = String(label || "").replace(/^roll\s*/i, "").trim();
    if (!letter) return "";
    var measurement = letter.toLowerCase() === "a" ? length : width;
    if (!measurement) return letter;
    // Matches the pill the shopper picked, so the cart summary and the
    // builder never disagree about which side they chose.
    return localize("Along", locale) + " " + inchesLabel(measurement, locale);
  }

  function cutValue(label) {
    return String(label || "").replace(/^fold\s*/i, "").trim();
  }

  function selectedValue(form, propertyName, fallback) {
    var controls = Array.prototype.slice.call(form.querySelectorAll('[name="properties[' + cssEscape(propertyName) + ']"]'))
      .filter(isActiveControl);
    var selected = controls.find(function (control) {
      return control.type === "radio" || control.type === "checkbox" ? control.checked : String(control.value || "").trim();
    });
    if (!selected) return fallback || "";
    return selected.dataset.optionLabel || String(selected.value || "").trim();
  }

  function getFieldState(form) {
    var state = {};
    Array.prototype.slice.call(form.querySelectorAll("[data-field-id]")).forEach(function (control) {
      if (!isActiveControl(control)) return;
      var id = control.dataset.fieldId;
      if (!id) return;
      if ((control.type === "checkbox" || control.type === "radio") && !control.checked) return;
      if (state[id]) {
        if (!Array.isArray(state[id])) state[id] = [state[id]];
        state[id].push(control.value);
      } else {
        state[id] = control.value;
      }
    });
    return state;
  }

  function updateClassicThicknessWarnings(form, locale) {
    Array.prototype.slice.call(form.querySelectorAll("[data-thickness-warning]")).forEach(function (warning) {
      var fieldset = warning.closest("fieldset");
      var classic = fieldset ? fieldset.querySelector('input[data-option-key="thickness:classic"]:checked') : null;
      warning.textContent = localize(CLASSIC_THICKNESS_WARNING_MESSAGE, locale);
      warning.hidden = !classic || !isActiveControl(classic);
    });
  }

  function isClassicThicknessOption(option) {
    var key = String(option && option.key || "");
    var id = String(option && option.id || "").toLowerCase();
    var value = String(option && option.value || "");
    return key === "thickness:classic" || id === "classic" || value.indexOf("Classic (4 in. - 2 in.)") !== -1;
  }

  // Live, size-driven guidance under the hot-tub size inputs. Regular (<=96 in.)
  // shows nothing; oversized (over 96, up to the 119 in. cap) confirms the fee that
  // was added; swim-spa territory (over the cap) routes them to the right builder.
  // Only hot-tub-capped custom builders render the [data-size-context] node, so this
  // is a no-op everywhere else.
  function updateSizeContext(root, form, currency, locale) {
    var nodes = Array.prototype.slice.call(form.querySelectorAll("[data-size-context]"));
    if (!nodes.length) return;

    var groupId = form.dataset.builderGroupId || "";
    var length = parseSizeInches(propertyValue(form, "Cover Length A"));
    var width = parseSizeInches(propertyValue(form, "Cover Width B"));
    var hasValue = Number.isFinite(length) || Number.isFinite(width);
    var longest = Math.max(Number.isFinite(length) ? length : 0, Number.isFinite(width) ? width : 0);
    var state = hasValue ? sizeContextState(length, width, longest) : "";

    nodes.forEach(function (node) {
      var fieldset = node.closest ? node.closest("fieldset") : null;
      if (!state || !fieldset || fieldset.hidden || !isHotTubSizeCappedGroupId(groupId)) {
        clearSizeContextNode(node);
        return;
      }
      node.textContent = "";
      if (state === "swim-spa") {
        var rollaway = isRollawayHotTubGroupId(groupId);
        node.className = "smcbx__size-context smcbx__size-context--swim-spa";
        node.appendChild(el("span", { className: "smcbx__size-context-text" }, localize(SWIM_SPA_SIZE_CONTEXT_MESSAGE, locale)));
        var actions = el("span", { className: "smcbx__hint-actions" });
        actions.appendChild(el("a", { href: localizedUrl(rollaway ? ROLLAWAY_SWIM_SPA_PRODUCT_URL : SWIM_SPA_PRODUCT_URL) },
          localize(rollaway ? "Open the rollaway swim spa builder" : "Open the swim spa builder", locale)));
        actions.appendChild(document.createTextNode("/"));
        actions.appendChild(el("a", { href: localizedUrl("/pages/contact") }, localize("Request a quote", locale)));
        node.appendChild(actions);
      } else if (state === "two-oversized") {
        node.className = "smcbx__size-context smcbx__size-context--two-oversized";
        node.appendChild(el("span", { className: "smcbx__size-context-text" }, localize(HOT_TUB_TWO_OVERSIZED_SIDES_MESSAGE, locale)));
        var quoteActions = el("span", { className: "smcbx__hint-actions" });
        quoteActions.appendChild(el("a", { href: localizedUrl("/pages/contact") }, localize("Request a quote", locale)));
        node.appendChild(quoteActions);
      } else {
        node.className = "smcbx__size-context smcbx__size-context--oversized";
        node.appendChild(el("span", { className: "smcbx__size-context-text" },
          oversizedContextMessage(oversizedFeeText(root, longest, currency, locale, groupId), locale)));
      }
      node.hidden = false;
    });
  }

  function clearSizeContextNode(node) {
    node.hidden = true;
    node.textContent = "";
    node.className = "smcbx__size-context";
  }

  function sizeContextState(length, width, longest) {
    if (!Number.isFinite(longest) || longest <= 0) return "";
    if (longest > HOT_TUB_COVER_MAX_SIZE_INCHES) return "swim-spa";
    if (Number.isFinite(length) && Number.isFinite(width) &&
        length > REGULAR_SIZE_MAX_INCHES && width > REGULAR_SIZE_MAX_INCHES) return "two-oversized";
    if (longest > REGULAR_SIZE_MAX_INCHES) return "oversized";
    return "";
  }

  function oversizedFeeText(root, longest, currency, locale, groupId) {
    var pricing = sizeFeePricingForGroup(root, groupId);
    var variants = pricing && Array.isArray(pricing.variants) ? pricing.variants : [];
    var tier = pickSizePricingVariant(variants, longest);
    var cents = tier ? (parseInt(tier.priceCents || tier.price_cents || 0, 10) || 0) : 0;
    return cents > 0 ? formatMoney(cents, currency, locale) : "";
  }

  function oversizedContextMessage(feeText, locale) {
    if (feeText) {
      return localize({
        en: "Oversized cover — over 96 in. on the longest side. A " + feeText + " oversized fee has been added to your total.",
        fr: "Couverture surdimensionnée — plus de 96 po sur le côté le plus long. Des frais de surdimension de " + feeText + " ont été ajoutés à votre total."
      }, locale);
    }
    return localize({
      en: "Oversized cover — over 96 in. on the longest side. An oversized fee applies and has been added to your total.",
      fr: "Couverture surdimensionnée — plus de 96 po sur le côté le plus long. Des frais de surdimension s’appliquent et ont été ajoutés à votre total."
    }, locale);
  }

  function hasClassicThicknessOption(options) {
    return Array.isArray(options) && options.some(isClassicThicknessOption);
  }

  function matchesCondition(condition, state) {
    if (!condition || !condition.field) return true;
    var value = state[condition.field];
    var values = Array.isArray(value) ? value : value !== undefined ? [value] : [];

    if (condition.exists !== undefined) return condition.exists ? values.length > 0 : values.length === 0;
    if (condition.equals !== undefined) return values.indexOf(condition.equals) !== -1;
    if (condition.notEquals !== undefined) return values.indexOf(condition.notEquals) === -1;
    if (Array.isArray(condition.in)) return values.some(function (item) { return condition.in.indexOf(item) !== -1; });
    return true;
  }

  function buildCoverDetails(form, grouped) {
    var details = {};
    var order = [];
    var model = propertyValue(form, "Hot Tub Make & Model");

    if (model) {
      details["Hot Tub Make & Model"] = [model];
      order.push("Hot Tub Make & Model");
    }
    var hiddenShape = propertyValue(form, "Cover Shape");
    if (hiddenShape && !checkedField(form, "cover_shape") && !checkedField(form, "rollaway_cover_shape")) {
      details["Cover Shape"] = [hiddenShape];
      order.push("Cover Shape");
    }
    modelLockedMeasurementRows(form).forEach(function (row) {
      details[row.key] = [row.value];
      order.push(row.key);
    });

    Array.prototype.slice.call(form.querySelectorAll("input, select, textarea")).forEach(function (control) {
      // Hidden inputs are internal plumbing (bundle ids, totals) — except one
      // the builder answers on the shopper’s behalf, which is a real cover spec
      // and has to read the same on the summary as an answered one does.
      if (!isActiveControl(control)) return;
      if (control.type === "hidden" && control.dataset.coverDetail !== "true") return;
      if ((control.type === "checkbox" || control.type === "radio") && !control.checked) return;

      var match = String(control.name || "").match(/^properties\[(.+)\]$/);
      if (!match) return;

      var key = match[1];
      var value = String(control.value || "").trim();
      if (!value || isInternalProperty(key)) return;

      if (!details[key]) {
        details[key] = [];
        order.push(key);
      }
      if (details[key].indexOf(value) === -1) details[key].push(value);
    });

    Object.keys(grouped || {}).forEach(function (key) {
      var values = grouped[key] || [];
      if (values.length === 0) return;
      if (!details[key]) {
        details[key] = [];
        order.push(key);
      }
      values.forEach(function (value) {
        if (details[key].indexOf(value) === -1) details[key].push(value);
      });
    });

    return order.map(function (key) {
      return key + ": " + details[key].join(", ");
    }).join("; ");
  }

  function isInternalProperty(key) {
    return key.indexOf("_") === 0 ||
      key === "Builder Bundle ID" ||
      key === "Estimated Builder Total" ||
      key === "Cover Details";
  }

  function collectProperties(form) {
    var properties = {};
    Array.prototype.slice.call(form.querySelectorAll("input, select, textarea")).forEach(function (control) {
      if (!isActiveControl(control)) return;
      if ((control.type === "checkbox" || control.type === "radio") && !control.checked) return;
      if (control.dataset.listName) return;

      var match = String(control.name || "").match(/^properties\[(.+)\]$/);
      var value = String(control.value || "").trim();
      if (!match || !value) return;

      var key = match[1];
      if (!properties[key]) properties[key] = [];
      if (properties[key].indexOf(value) === -1) properties[key].push(value);
    });

    Object.keys(properties).forEach(function (key) {
      properties[key] = properties[key].join(", ");
    });
    return properties;
  }

  function syncSelectedClasses(root) {
    root.querySelectorAll("label").forEach(function (label) {
      var input = label.querySelector("input");
      if (input && (input.type === "radio" || input.type === "checkbox")) {
        label.classList.toggle("is-selected", input.checked && !input.disabled);
      }
    });
  }

  function readJson(root, selector, fallback) {
    var script = root.querySelector(selector);
    if (!script) return fallback;
    return parseJson(script.textContent.trim(), fallback);
  }

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value || "");
    } catch {
      return fallback;
    }
  }

  function localize(value, locale) {
    if (value && typeof value === "object") {
      var normalizedLocale = normalizeToken(locale || "en");
      var base = normalizedLocale.split("-")[0];
      var matchingKey = Object.keys(value).find(function (key) {
        return normalizeToken(key) === normalizedLocale;
      });
      var baseKey = Object.keys(value).find(function (key) {
        return normalizeToken(key) === base;
      });
      return localize(value[matchingKey] || value[baseKey] || value.en || value["en-CA"] || value[Object.keys(value)[0]] || "", locale);
    }
    var text = String(value || "");
    var baseLocale = normalizeToken(locale || "en").split("-")[0];
    var translations = localeTranslations[baseLocale];
    if (!translations) return text;
    return translations[text] || translations[text.trim()] || text;
  }

  function translateBuilderNode(root, locale) {
    var baseLocale = normalizeToken(locale || "en").split("-")[0];
    if (!root || !localeTranslations[baseLocale]) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue || "";
      var trimmed = value.trim();
      if (!trimmed) continue;
      var translated = localize(trimmed, locale);
      if (translated !== trimmed) node.nodeValue = value.replace(trimmed, translated);
    }

    Array.prototype.slice.call(root.querySelectorAll("[aria-label], [placeholder], [alt], [title]")).forEach(function (element) {
      ["aria-label", "placeholder", "alt", "title"].forEach(function (attribute) {
        if (!element.hasAttribute(attribute)) return;
        var original = element.getAttribute(attribute);
        var translated = localize(original, locale);
        if (translated !== original) element.setAttribute(attribute, translated);
      });
    });
  }

  function savingsLabel(amount, locale) {
    return localize({ en: "Save", fr: "Économisez" }, locale) + " " + amount;
  }

  function inchUnit(locale) {
    return normalizeToken(locale || "en").split("-")[0] === "fr" ? "po" : "in.";
  }

  function inchesLabel(value, locale) {
    return String(value || "").trim() + " " + inchUnit(locale);
  }

  function radiusInchesLabel(value, locale) {
    var normalized = String(value || "").trim();
    return normalizeToken(locale || "en").split("-")[0] === "fr"
      ? normalized + " po de rayon"
      : normalized + " in. radius";
  }

  function priceFor(option, currency) {
    if (option.prices && option.prices[currency] !== undefined) {
      return parseInt(option.prices[currency], 10) || 0;
    }
    return parseInt(option.priceCents || 0, 10) || 0;
  }

  function compareAtPriceFor(option, currency) {
    if (option.compareAtPrices && option.compareAtPrices[currency] !== undefined) {
      return parseInt(option.compareAtPrices[currency], 10) || 0;
    }
    if (option.compare_at_price_cents !== undefined) {
      return parseInt(option.compare_at_price_cents, 10) || 0;
    }
    return parseInt(option.compareAtPriceCents || 0, 10) || 0;
  }

  function getListNames(fields, group) {
    var names = new Set();
    fields.forEach(function (field) {
      (field.options || []).forEach(function (option) {
        if (option.listName) names.add(option.listName);
      });
    });
    if (group && group.sizePricing && group.sizePricing.listName) names.add(group.sizePricing.listName);
    return Array.from(names);
  }

  function getHiddenListNames(form) {
    return Array.prototype.slice.call(form.querySelectorAll("[data-hidden-key]"))
      .map(function (input) { return input.dataset.hiddenKey || ""; })
      .filter(function (key) { return key.indexOf("list:") === 0; })
      .map(function (key) { return key.slice(5); });
  }

  function hasSelected(options) {
    return (options || []).some(function (option) { return option.selected === true; });
  }

  function isActiveControl(control) {
    return !control.disabled && !control.closest("[hidden]");
  }

  function errorNode(key) {
    return el("p", { className: "smcbx__error", dataset: { errorFor: key } });
  }

  function setError(root, key, message) {
    var node = root.querySelector('[data-error-for="' + cssEscape(key) + '"]');
    if (node) node.textContent = message;
  }

  function clearErrors(root) {
    root.querySelectorAll("[data-error-for]").forEach(function (node) {
      node.textContent = "";
    });
    showMessage(root, "", true);
  }

  function setText(root, selector, value) {
    var node = builderQuery(root, selector);
    if (node) node.textContent = value;
  }

  function setFoldLabel(root, value, visible) {
    var node = builderQuery(root, "[data-fold-label]");
    if (!node) return;
    node.textContent = value;
    node.hidden = !visible;
  }

  function setTextAll(root, selector, value) {
    builderQueryAll(root, selector).forEach(function (node) {
      node.textContent = value;
    });
  }

  function setMeasurementLabel(root, selector, value, locale) {
    var normalized = String(value || "").trim();
    builderQueryAll(root, selector).forEach(function (node) {
      node.textContent = normalized ? inchesLabel(normalized, locale) : "";
      var pill = node.closest(".smcbx__value-pill");
      if (pill) pill.classList.toggle("is-empty", !normalized);
    });
  }

  function showMessage(root, message, success) {
    var node = root.querySelector("[data-form-message]");
    if (!node) return;
    node.textContent = message || "";
    node.classList.toggle("is-visible", Boolean(message));
    node.classList.toggle("is-success", Boolean(success));
  }

  function setSubmitState(root, state) {
    var button = root.querySelector(".smcbx__submit");
    if (!button) return;
    var label = button.querySelector(".smcbx__submit-text");
    var text = button.dataset.defaultText || button.textContent || "";

    button.classList.remove("is-loading", "is-added");
    button.disabled = false;
    button.removeAttribute("aria-disabled");

    if (state === "loading") {
      button.classList.add("is-loading");
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
      text = button.dataset.loadingText || text;
    } else if (state === "added") {
      button.classList.add("is-added");
      button.disabled = true;
      button.setAttribute("aria-disabled", "true");
      text = button.dataset.addedText || text;
    }

    if (label) {
      label.textContent = text;
    } else {
      button.textContent = text;
    }
  }

  function hiddenInput(name, value, key) {
    return el("input", {
      type: "hidden",
      name: name,
      value: value,
      dataset: key ? { hiddenKey: key } : {}
    });
  }

  function setHidden(form, key, value) {
    var input = form.querySelector('[data-hidden-key="' + cssEscape(key) + '"]');
    if (input) input.value = value;
  }

  function createDivider(locale) {
    return el("div", { className: "smcbx__divider" }, el("span", {}, localize({ en: "or", fr: "ou" }, locale)));
  }

  function handleGalleryClick(root, form, event) {
    var expand = event.target.closest(".smcbx__expand");
    if (expand) {
      event.preventDefault();
      openGalleryLightbox(root);
      return;
    }

    var nav = event.target.closest("[data-gallery-nav]");
    if (nav) {
      event.preventDefault();
      stepGallery(root, nav.dataset.galleryNav === "next" ? 1 : -1);
      return;
    }

    var button = event.target.closest("[data-gallery-button]");
    var visual = root._smcbxVisualColumn;
    if (!button || (!form.contains(button) && !(visual && visual.contains(button)))) return;
    var thumbs = galleryThumbs(root);
    var fromIndex = currentGalleryIndex(root, thumbs);
    var toIndex = thumbs.indexOf(button);
    var direction = toIndex > fromIndex ? "next" : (toIndex < fromIndex ? "prev" : "");
    setGalleryMode(root, button.dataset.galleryMode || "build", button.dataset.gallerySrc || "", button.dataset.galleryFull || "", direction);
  }

  function galleryThumbs(root) {
    return builderQueryAll(root, "[data-gallery-button]");
  }

  function currentGalleryIndex(root, thumbs) {
    thumbs = thumbs || galleryThumbs(root);
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains("is-active")) return i;
    }
    return 0;
  }

  function stepGallery(root, delta) {
    var thumbs = galleryThumbs(root);
    if (!thumbs.length) return;
    var count = thumbs.length;
    var index = (currentGalleryIndex(root, thumbs) + delta + count) % count;
    var button = thumbs[index];
    if (!button) return;
    setGalleryMode(root, button.dataset.galleryMode || "build", button.dataset.gallerySrc || "", button.dataset.galleryFull || "", delta > 0 ? "next" : "prev");
  }

  function animateGalleryIn(node, direction) {
    if (!node || !direction) return;
    var name = direction === "prev" ? "smcbxSlideInLeft" : "smcbxSlideInRight";
    node.style.animation = "none";
    void node.offsetWidth;
    node.style.animation = name + " 0.38s cubic-bezier(0.4, 0, 0.2, 1)";
  }

  function activateBuildPreview(root) {
    setGalleryMode(root, "build", "", "");
  }

  // Model pages offer Traditional and Rollaway as inline choices. Swap the
  // photo rail to the selected product family and keep the first product photo
  // visible, instead of leaving the model's traditional photos on screen.
  function syncCoverTypeGallery(root, target) {
    if (!target || !target.checked || !target.dataset || target.dataset.fieldId !== "cover_type") return false;
    var family = target.value === "Rollaway" ? "rollaway" : "traditional";
    var media = builderQuery(root, ".smcbx__media");
    if (media && media.dataset.coverGalleryFamily === family) return true;

    var images = family === "rollaway" ? rollawayProductGalleryImages(root) : productGalleryImages(root);
    replaceGalleryImages(root, images, family);
    return true;
  }

  function replaceGalleryImages(root, images, family) {
    var thumbs = builderQuery(root, ".smcbx__thumbs");
    var media = builderQuery(root, ".smcbx__media");
    if (!thumbs || !media) return;

    Array.prototype.slice.call(thumbs.querySelectorAll('[data-gallery-mode="image"]')).forEach(function (button) {
      button.remove();
    });

    var buildButton = thumbs.querySelector('[data-gallery-mode="build"]');
    images = uniqueGalleryImages(images || []);
    images.forEach(function (image, index) {
      thumbs.insertBefore(el("button", {
        type: "button",
        className: index === 0 ? "is-active" : "",
        dataset: {
          galleryButton: "",
          galleryMode: "image",
          gallerySrc: image.src,
          galleryFull: image.full || image.src
        }
      }, el("img", { src: image.thumb || image.src, alt: image.alt || "", loading: "lazy" })), buildButton);
    });

    builderQueryAll(root, "[data-gallery-nav]").forEach(function (button) {
      button.hidden = images.length === 0;
    });
    media.dataset.coverGalleryFamily = family;

    var first = images[0];
    var photo = builderQuery(root, ".smcbx__reference-photo");
    if (photo && first) photo.alt = first.alt || "";
    if (first) setGalleryMode(root, "image", first.src, first.full || first.src);
    else activateBuildPreview(root);
  }

  // Picking a material colour (traditional or rollaway) swaps the gallery to
  // that colour's cover photo instead of the build diagram; every other change
  // still brings the diagram back. Prefers the matching product-media thumb so
  // the rail highlights; falls back to the option's own image when the photo
  // isn't in the product gallery. Returns true when it handled the change so
  // the caller skips activateBuildPreview.
  function showMaterialColorPhoto(root, form, target) {
    if (!target || !target.checked || !target.dataset) return false;
    var fieldId = target.dataset.fieldId || "";
    if (fieldId !== "rollaway_material_color" && fieldId !== "material_color") return false;
    var src = target.dataset.galleryImage || "";
    if (!src) return false;
    var key = galleryImageFileKey(src);
    var thumbs = galleryThumbs(root);
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].dataset.galleryMode !== "image") continue;
      if (galleryImageFileKey(thumbs[i].dataset.gallerySrc) !== key) continue;
      setGalleryMode(root, "image", thumbs[i].dataset.gallerySrc || src, thumbs[i].dataset.galleryFull || src);
      return true;
    }
    setGalleryMode(root, "image", src, src);
    return true;
  }

  function galleryImageFileKey(url) {
    var path = String(url || "").split("?")[0];
    return path.slice(path.lastIndexOf("/") + 1).toLowerCase();
  }

  function setGalleryMode(root, mode, src, full, direction) {
    var livePreview = builderQuery(root, "[data-live-preview]");
    var photo = builderQuery(root, ".smcbx__reference-photo");
    if (!livePreview || !photo) return;
    var meta = builderQuery(root, ".smcbx__live-cover-meta");
    var media = builderQuery(root, ".smcbx__media");

    builderQueryAll(root, "[data-gallery-button]").forEach(function (button) {
      button.classList.toggle("is-active", button.dataset.galleryMode === mode && (mode !== "image" || button.dataset.gallerySrc === src));
    });

    if (mode === "image" && src) {
      photo.src = src;
      photo.hidden = false;
      livePreview.hidden = true;
      if (meta) meta.hidden = true;
      if (media) {
        media.dataset.galleryMode = "image";
        media.dataset.gallerySrc = src;
        media.dataset.galleryFull = full || src;
      }
      animateGalleryIn(photo, direction);
      return;
    }

    photo.hidden = true;
    livePreview.hidden = false;
    if (meta) meta.hidden = false;
    if (media) {
      media.dataset.galleryMode = "build";
      media.dataset.gallerySrc = "";
      media.dataset.galleryFull = "";
    }
    animateGalleryIn(livePreview, direction);
  }

  function builderQuery(root, selector) {
    var node = root.querySelector(selector);
    if (node) return node;
    var visual = root._smcbxVisualColumn;
    if (!visual) return null;
    if (visual.matches && visual.matches(selector)) return visual;
    return visual.querySelector(selector);
  }

  function builderQueryAll(root, selector) {
    var nodes = Array.prototype.slice.call(root.querySelectorAll(selector));
    var visual = root._smcbxVisualColumn;
    if (visual) {
      if (visual.matches && visual.matches(selector)) nodes.push(visual);
      nodes = nodes.concat(Array.prototype.slice.call(visual.querySelectorAll(selector)));
    }
    return nodes.filter(function (node, index, list) {
      return list.indexOf(node) === index;
    });
  }

  function coverTypeLabel(group, locale) {
    var groupId = group && group.id;
    if (groupId === "swim-spa-covers") return localize("Traditional swim spa cover", locale);
    if (groupId === "rollaway-swim-spa-covers") return localize("Rollaway swim spa cover", locale);
    if (groupId === "hot-tub-covers") return localize("Traditional hot tub cover", locale);
    if (groupId === "rollaway-hot-tub-covers") return localize("Rollaway hot tub cover", locale);
    return localize(isRollawayGroup(group) ? "Rollaway cover" : "Regular cover", locale);
  }

  function coverTypeThumb(group, root, locale) {
    var groupId = typeof group === "string" ? group : group && group.id;
    var image = coverTypeImage(root, group);
    var alt = groupId === "swim-spa-covers"
      ? "Traditional swim spa cover"
      : groupId === "rollaway-swim-spa-covers"
        ? "Rollaway swim spa cover"
        : groupId === "hot-tub-covers"
          ? "Traditional hot tub cover"
          : groupId === "rollaway-hot-tub-covers"
            ? "Rollaway hot tub cover"
            : isRollawayGroupId(groupId) ? "Rollaway cover" : "Regular insulated cover";
    return el("img", {
      className: "smcbx__cover-type-photo",
      src: image,
      alt: localize(alt, locale),
      loading: "lazy"
    });
  }

  function coverTypeImage(root, group) {
    var groupId = typeof group === "string" ? group : group && group.id;
    var product = group && Array.isArray(group.products) ? group.products[0] || {} : {};
    var productImage = product.imageUrl || product.image_url || product.featuredImage || product.featured_image || "";
    if (productImage) return productImage;

    if (isRollawayGroupId(groupId)) {
      return root.dataset.rollawayProductImage || assetUrl(root, "rollaway-hot-tub-cover-product.jpg");
    }
    var traditionalImages = productGalleryImages(root);
    return root.dataset.regularCoverImage || (traditionalImages[0] && traditionalImages[0].src) || "";
  }

  function coverGalleryImages(root, group) {
    // Standalone Rollaway product pages already expose the correct product
    // media. The shared Rollaway fallback is only for an explicit cover-type
    // switch on model pages (handled by syncCoverTypeGallery).
    return uniqueGalleryImages(productGalleryImages(root));
  }

  function coverTypeFamily(group) {
    var groupId = group && group.id;
    if (groupId === "swim-spa-covers" || groupId === "rollaway-swim-spa-covers") {
      return ["swim-spa-covers", "rollaway-swim-spa-covers"];
    }
    if (groupId === "hot-tub-covers" || groupId === "rollaway-hot-tub-covers") {
      return ["hot-tub-covers", "rollaway-hot-tub-covers"];
    }
    return [groupId].filter(Boolean);
  }

  function previewFamilyForGroupId(groupId) {
    if (groupId === "swim-spa-covers") return "swim-spa";
    if (isRollawayGroupId(groupId)) return "rollaway";
    return "hot-tub";
  }

  function defaultPreviewDimensions(previewFamily, groupId) {
    if (previewFamily === "swim-spa" || groupId === "rollaway-swim-spa-covers") {
      return { length: 149, width: 92 };
    }
    return { length: 84, width: 84 };
  }

  function isRollawayGroup(group) {
    return isRollawayGroupId(group && group.id);
  }

  function isRegularSwimSpaGroupId(groupId) {
    return groupId === "swim-spa-covers";
  }

  function isSwimSpaGroupId(groupId) {
    return groupId === "swim-spa-covers" || groupId === "rollaway-swim-spa-covers";
  }

  function isHotTubSizeCappedGroupId(groupId) {
    return groupId === "hot-tub-covers" || groupId === "rollaway-hot-tub-covers";
  }

  function isRollawayHotTubGroupId(groupId) {
    return groupId === "rollaway-hot-tub-covers";
  }

  function isRollawaySwimSpaGroupId(groupId) {
    return groupId === "rollaway-swim-spa-covers";
  }

  function swimSpaMinimumLongSide(groupId) {
    return SWIM_SPA_MIN_LONG_SIDE_INCHES;
  }

  function swimSpaMinimumLongSideMessage(groupId) {
    return isRollawaySwimSpaGroupId(groupId) ? ROLLAWAY_SWIM_SPA_MIN_LONG_SIDE_MESSAGE : SWIM_SPA_MIN_LONG_SIDE_MESSAGE;
  }

  function isRollawayGroupId(groupId) {
    return groupId === "rollaway-hot-tub-covers" || groupId === "rollaway-swim-spa-covers";
  }

  function productGalleryImages(root) {
    var media = readJson(root, "[data-product-media]", []);
    if (!Array.isArray(media)) return [];
    return media.map(normalizeGalleryImage).filter(function (image) {
      return image && image.src;
    });
  }

  function rollawayProductGalleryImages(root) {
    var media = readJson(root, "[data-rollaway-product-media]", []);
    var images = Array.isArray(media) ? media.map(normalizeGalleryImage).filter(function (image) {
      return image && image.src;
    }) : [];
    if (images.length) return uniqueGalleryImages(images);

    var isSwimSpa = normalizeToken(root && root.dataset ? root.dataset.spaType || "" : "") === "swim spa";
    var alt = isSwimSpa ? "Rollaway swim spa cover" : "Rollaway hot tub cover";
    return uniqueGalleryImages([
      { src: root.dataset.rollawayProductImage || "", alt: alt },
      { src: root.dataset.rollawayClosedImage || "", alt: alt + " closed" },
      { src: root.dataset.rollawayOpenImage || "", alt: alt + " open" }
    ].map(normalizeGalleryImage).filter(function (image) {
      return image && image.src;
    }));
  }

  function normalizeGalleryImage(item) {
    if (typeof item === "string") {
      return { src: item, thumb: item, full: item, alt: "" };
    }
    if (!item) return null;
    var src = item.src || item.url || item.image || item.full || item.thumb || "";
    if (!src) return null;
    return {
      src: String(src),
      thumb: String(item.thumb || src),
      full: String(item.full || src),
      alt: String(item.alt || "")
    };
  }

  function uniqueGalleryImages(images) {
    var seen = {};
    return (images || []).filter(function (image) {
      var key = image && image.src ? String(image.src).trim() : "";
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function openGalleryLightbox(root) {
    var media = builderQuery(root, ".smcbx__media");
    if (!media) return;

    var canStep = galleryThumbs(root).length > 1;
    var contentHost = el("div", { className: "smcbx__lightbox-content" });

    function renderContent() {
      contentHost.innerHTML = "";
      if (media.dataset.galleryMode === "build") {
        var preview = builderQuery(root, "[data-live-preview]");
        if (preview) contentHost.appendChild(el("div", { className: "smcbx__lightbox-preview" }, preview.cloneNode(true)));
      } else {
        var src = media.dataset.galleryFull || media.dataset.gallerySrc || "";
        if (src) contentHost.appendChild(el("img", { className: "smcbx__lightbox-image", src: src, alt: root.dataset.productTitle || "Product image" }));
      }
    }
    renderContent();

    var closeButton = el("button", { type: "button", className: "smcbx__lightbox-close", ariaLabel: "Close image preview" }, closeIcon());
    var prevButton = canStep ? el("button", { type: "button", className: "smcbx__lightbox-nav smcbx__lightbox-nav--prev", ariaLabel: "Previous image" }, chevronIcon()) : null;
    var nextButton = canStep ? el("button", { type: "button", className: "smcbx__lightbox-nav smcbx__lightbox-nav--next", ariaLabel: "Next image" }, chevronIcon()) : null;
    var overlay = el("div", { className: "smcbx__lightbox", role: "dialog", "aria-modal": "true" },
      el("div", { className: "smcbx__lightbox-backdrop" }),
      el("div", { className: "smcbx__lightbox-panel" }, closeButton, prevButton, nextButton, contentHost)
    );

    function step(delta) {
      stepGallery(root, delta);
      renderContent();
    }

    function close() {
      document.removeEventListener("keydown", onKeyDown);
      overlay.remove();
    }

    function onKeyDown(event) {
      if (event.key === "Escape") close();
      else if (canStep && event.key === "ArrowLeft") step(-1);
      else if (canStep && event.key === "ArrowRight") step(1);
    }

    overlay.addEventListener("click", function (event) {
      if (event.target === overlay || event.target.className === "smcbx__lightbox-backdrop") close();
    });
    closeButton.addEventListener("click", close);
    if (prevButton) prevButton.addEventListener("click", function (event) { event.stopPropagation(); step(-1); });
    if (nextButton) nextButton.addEventListener("click", function (event) { event.stopPropagation(); step(1); });
    document.addEventListener("keydown", onKeyDown);
    document.body.appendChild(overlay);
    (nextButton || closeButton).focus();
  }

  function assetUrl(root, filename) {
    var base = root.dataset.assetBase || "";
    return base ? base.replace(/\/?$/, "/") + filename : filename;
  }

  function thicknessArt(option) {
    var text = String(option.description || option.value || "");
    var left = text.match(/(\d+(?:\.\d+)?)\s*in\.\s*-\s*(\d+(?:\.\d+)?)\s*in\./i);
    var high = left ? left[1] : option.id === "extreme" ? "6" : option.id === "premium" ? "5" : "4";
    var isExtreme = parseFloat(high) >= 6 || option.id === "extreme";
    var isPremium = !isExtreme && (parseFloat(high) >= 5 || option.id === "premium");
    var node = el("span", { className: "smcbx__thickness-art", ariaHidden: "true" });
    if (isExtreme) {
      node.innerHTML = '<svg width="128" height="21" viewBox="0 0 128 21" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation"><path class="smcbx__configurator-fill" d="M0 0.5L128 11.8333V20.5H0V0.5Z"></path><path class="smcbx__configurator-outline" d="M127.5 12.291V20H0.5V1.04623L127.5 12.291Z"></path></svg>';
    } else if (isPremium) {
      node.innerHTML = '<svg width="128" height="16" viewBox="0 0 128 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation"><path class="smcbx__configurator-fill-outline" d="M127.5 10.9625V15H0.5V1.04059L127.5 10.9625Z"></path></svg>';
    } else {
      node.innerHTML = '<svg width="128" height="9" viewBox="0 0 128 9" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation"><path class="smcbx__configurator-fill" d="M0 0L128 6V9H0V0Z"></path><path class="smcbx__configurator-outline" d="M127.5 6.47711V8.5H0.5V0.523987L127.5 6.47711Z"></path></svg>';
    }
    return node;
  }

  function materialFamilyFor(option) {
    var text = String((option.label || "") + " " + (option.value || "")).toLowerCase();
    if (text.indexOf("aquatex") !== -1 || text.indexOf("pro-tex") !== -1 || text.indexOf("protex") !== -1) return "premium";
    return "vinyl";
  }

  function materialTone(label, family) {
    var text = String(label || "").toLowerCase();
    var suffix = family === "premium" ? "aquatex" : "vinyl";
    if (text.indexOf("charcoal") !== -1 || text.indexOf("charbon") !== -1 || text.indexOf("grey") !== -1 || text.indexOf("gray") !== -1 || text.indexOf("gris") !== -1) return "charcoal-" + suffix;
    if (text.indexOf("chestnut") !== -1 || text.indexOf("chataigne") !== -1 || text.indexOf("châtaigne") !== -1 || text.indexOf("brown") !== -1 || text.indexOf("brun") !== -1) return "chestnut-" + suffix;
    return "black-" + suffix;
  }

  function checkedField(form, fieldId) {
    return Array.prototype.slice.call(form.querySelectorAll('input[data-field-id="' + cssEscape(fieldId) + '"]:checked'))
      .find(isActiveControl) || null;
  }

  function propertyValue(form, property) {
    var input = form.elements["properties[" + property + "]"];
    if (input && input.length && !input.tagName) {
      input = Array.prototype.slice.call(input).find(isActiveControl) || input[0];
    }
    if (!input || !isActiveControl(input)) return "";
    return String(input.value || "").trim();
  }

  function propertyNameFromInput(input) {
    var match = String(input && input.name || "").match(/^properties\[(.+)\]$/);
    return match ? match[1] : "";
  }

  function selectedPropertyRows(form) {
    var rows = [];
    var seen = {};
    var swimSpaModel = propertyValue(form, "Swim Spa Make & Model");
    var hotTubModel = propertyValue(form, "Hot Tub Make & Model");
    if (swimSpaModel) rows.push({ key: "Swim Spa Model", value: swimSpaModel });
    if (hotTubModel) rows.push({ key: "Hot Tub Model", value: hotTubModel });
    var hiddenShape = propertyValue(form, "Cover Shape");
    if (hiddenShape && !checkedField(form, "cover_shape") && !checkedField(form, "rollaway_cover_shape")) {
      rows.push({ key: "Cover Shape", value: hiddenShape });
    }
    modelLockedMeasurementRows(form).forEach(function (row) {
      var id = row.key + ":" + row.value;
      if (seen[id]) return;
      seen[id] = true;
      rows.push(row);
    });

    Array.prototype.slice.call(form.querySelectorAll("input, select, textarea")).forEach(function (control) {
      if (!isActiveControl(control) || control.type === "hidden") return;
      if ((control.type === "checkbox" || control.type === "radio") && !control.checked) return;
      var match = String(control.name || "").match(/^properties\[(.+)\]$/);
      if (!match) return;
      var key = match[1];
      if (isInternalProperty(key)) return;
      var value = control.dataset.optionLabel || String(control.value || "").trim();
      if (!value) return;
      var id = key + ":" + value;
      if (seen[id]) return;
      seen[id] = true;
      rows.push({ key: key, value: value });
    });
    return rows;
  }

  function modelLockedMeasurementRows(form) {
    if (!form.querySelector('[data-hidden-key="model-length-a"]')) return [];
    return [
      { key: "Cover Length A", value: propertyValue(form, "Cover Length A") },
      { key: "Cover Width B", value: propertyValue(form, "Cover Width B") },
      { key: "Cover Dimension C", value: propertyValue(form, "Cover Dimension C") },
      { key: "Corner Radius", value: propertyValue(form, "Corner Radius") },
      { key: "Cover Dimension D", value: propertyValue(form, "Cover Dimension D") },
      { key: "Speaker Pocket Count", value: propertyValue(form, "Speaker Pocket Count") }
    ].filter(function (row) {
      return row.value;
    });
  }

  function propertyLabel(key) {
    return String(key || "")
      .replace(/^Cover\s+/, "")
      .replace(/\s+A$/, " A")
      .replace(/\s+B$/, " B");
  }

  function measurementTemplateFor(label) {
    var text = String(label || "").toLowerCase();
    if (text.indexOf("round") !== -1 && text.indexOf("rounded") === -1) return "diameter";
    if (text.indexOf("bowed") !== -1 || text.indexOf("ellipt") !== -1) return "a_b_c";
    if ((text.indexOf("four") !== -1 || /\b4\b/.test(text)) && (text.indexOf("cut") !== -1 || text.indexOf("coup") !== -1)) return "a_b_c_cut";
    if (text.indexOf("cut") !== -1 || text.indexOf("coup") !== -1) return "a_b_c_d_cut";
    if (text.indexOf("octagon") !== -1 || text.indexOf("octogone") !== -1) return "a_b";
    if (text.indexOf("radius") !== -1 || text.indexOf("rounded") !== -1) return "a_b_c_radius";
    return "a_b";
  }

  function isFoldOrientationVisibilityNode(node) {
    var id = String(node && node.dataset && node.dataset.fieldId || "").toLowerCase();
    return id === "fold_orientation" || id === "rollaway_fold_orientation";
  }

  function isRollOrientationVisibilityNode(node) {
    var id = String(node && node.dataset && node.dataset.fieldId || "").toLowerCase();
    return id === "roll_orientation" || id === "rollaway_roll_orientation";
  }

  // Past this, the cover always rolls the long way — the roller bar cannot
  // practically span the longer side — so there is nothing to choose and the
  // builder answers for the shopper (owner, 2026-09-01).
  var ROLL_CHOICE_MAX_INCHES = 120;

  /**
   * The roll question is only real for a cover that is genuinely rectangular
   * AND no more than 120 in. on either side.
   *
   * Unlike the fold field, blank dimensions do not qualify: matchingDimensions
   * answers false when a side is empty, which would show the question before
   * the shopper has measured anything. Both sides must be known and different.
   *
   * On a true square the two answers build the identical cover, and over
   * 120 in. it always rolls the long way — in both cases there is no choice to
   * offer. The oversized case still has an answer, though, so
   * rollOrientationDefault fills it in rather than leaving the factory to guess.
   */
  function rollOrientationFieldApplies(form) {
    var shapeInput = checkedField(form, "cover_shape") || checkedField(form, "rollaway_cover_shape");
    var shapeLabel = shapeInput ? shapeInput.dataset.optionLabel || shapeInput.value : propertyValue(form, "Cover Shape");
    var kind = shapeKind(shapeLabel);
    // Allowlist, not "not round": rolling covers are sold only in the plain
    // rectangular shapes, and a model page can be octagon, bowed or cut-corner.
    if (kind !== "rounded" && kind !== "square") return false;
    var a = numericPropertyValue(form, "Cover Length A");
    var b = numericPropertyValue(form, "Cover Width B");
    if (a === null || b === null) return false;
    if (Math.abs(a - b) < 0.001) return false;
    return a <= ROLL_CHOICE_MAX_INCHES && b <= ROLL_CHOICE_MAX_INCHES;
  }

  /**
   * The answer for a cover too big to be asked about: it rolls along its longer
   * side. Returns "" whenever the shopper is being asked instead, or when the
   * sides are equal (no longer side, and a square rolls the same either way).
   *
   * Kept deliberately separate from the preview's long-side fallback: that one
   * is a drawing default for an unanswered question, this one is a recorded
   * answer that reaches the supplier.
   */
  function rollOrientationDefault(form) {
    var shapeInput = checkedField(form, "cover_shape") || checkedField(form, "rollaway_cover_shape");
    var shapeLabel = shapeInput ? shapeInput.dataset.optionLabel || shapeInput.value : propertyValue(form, "Cover Shape");
    var kind = shapeKind(shapeLabel);
    if (kind !== "rounded" && kind !== "square") return "";
    var a = numericPropertyValue(form, "Cover Length A");
    var b = numericPropertyValue(form, "Cover Width B");
    if (a === null || b === null) return "";
    if (Math.abs(a - b) < 0.001) return "";
    if (a <= ROLL_CHOICE_MAX_INCHES && b <= ROLL_CHOICE_MAX_INCHES) return "";
    return a > b ? "Roll A" : "Roll B";
  }

  /**
   * Only ever one live answer: the radio group when the question is shown, this
   * hidden input when the size decides it. The input is disabled while unused so
   * it submits nothing at all rather than an empty property.
   */
  function applyRollOrientationDefault(form) {
    var input = form.querySelector('[data-hidden-key="roll-orientation-default"]');
    if (!input) return;
    var coverTypeInput = checkedField(form, "cover_type");
    var isRollaway = isRollawayGroupId(form.dataset.builderGroupId || "") ||
      Boolean(coverTypeInput && coverTypeInput.value === "Rollaway");
    var hasVisibleField = Array.prototype.slice
      .call(form.querySelectorAll("fieldset[data-field-id]"))
      .some(function (fieldset) {
        return isRollOrientationVisibilityNode(fieldset) && !fieldset.hidden;
      });
    var value = isRollaway && !hasVisibleField ? rollOrientationDefault(form) : "";
    input.value = value;
    input.disabled = !value;
  }

  function foldOrientationFieldApplies(form) {
    var shapeInput = checkedField(form, "cover_shape") || checkedField(form, "rollaway_cover_shape");
    var shapeLabel = shapeInput ? shapeInput.dataset.optionLabel || shapeInput.value : propertyValue(form, "Cover Shape");
    if (shapeKind(shapeLabel) === "round") return false;
    return !matchingDimensions(form, "Cover Length A", "Cover Width B");
  }

  function matchingDimensions(form, propertyA, propertyB) {
    var a = numericPropertyValue(form, propertyA);
    var b = numericPropertyValue(form, propertyB);
    return a !== null && b !== null && Math.abs(a - b) < 0.001;
  }

  function numericPropertyValue(form, propertyName) {
    var value = parseFloat(String(propertyValue(form, propertyName) || "").replace(",", "."));
    return Number.isFinite(value) ? value : null;
  }

  function previewSizeLabel(template, length, width, radius, cut, locale) {
    var a = String(length || "").trim();
    var b = String(width || "").trim();
    var c = String(radius || "").trim();
    var cutText = String(cut || "").trim();
    if (template === "diameter") return a ? (normalizeToken(locale || "en").split("-")[0] === "fr" ? a + " po de diamètre" : a + " in. diameter") : "";
    if (!a || !b) return "";
    if (template === "a_b_c_radius") {
      return a + " x " + b + " " + inchUnit(locale) + (c ? " / " + radiusInchesLabel(c, locale) : "");
    }
    if (template === "a_b_c_cut" || template === "a_b_c_d_cut") {
      return a + " x " + b + " " + inchUnit(locale) +
        (cutText ? " / C " + inchesLabel(cutText, locale) : "") +
        (template === "a_b_c_d_cut" && c ? " / " + radiusInchesLabel(c, locale) : "");
    }
    return a + " x " + b + " " + inchUnit(locale);
  }

  function shapeKind(label) {
    var text = String(label || "").toLowerCase();
    if ((text.indexOf("round") !== -1 && text.indexOf("rounded") === -1) || (text.indexOf("rond") !== -1 && text.indexOf("arrondi") === -1)) return "round";
    if (text.indexOf("cut") !== -1 || text.indexOf("coup") !== -1) {
      if (text.indexOf("one") !== -1 || text.indexOf("un ") !== -1 || /\b1\b/.test(text)) return "onecut";
      if (text.indexOf("two") !== -1 || text.indexOf("deux") !== -1 || /\b2\b/.test(text)) return "twocut";
      return "fourcut";
    }
    if (text.indexOf("bowed") !== -1 || text.indexOf("ellipt") !== -1 || text.indexOf("arqu") !== -1) return "bowed";
    if (text.indexOf("custom") !== -1 || text.indexOf("personnalis") !== -1) return "custom";
    if (text.indexOf("octagon") !== -1 || text.indexOf("octogone") !== -1) return "octagon";
    if ((text.indexOf("square") !== -1 && text.indexOf("rounded") === -1) || (text.indexOf("carr") !== -1 && text.indexOf("arrondi") === -1)) return "square";
    if (text.indexOf("rectangle") !== -1 && text.indexOf("rounded") === -1) return "square";
    return "rounded";
  }

  function foldKind(label) {
    var text = String(label || "").toLowerCase();
    if (/\blength\b|\ba\b/.test(text)) return "horizontal";
    if (/\bwidth\b|\bb\b/.test(text)) return "vertical";
    return "horizontal";
  }

  // Which dimension the cover travels along as it rolls up: "a" (it rolls
  // along Length A, so the roller bar lies parallel to Width B) or "b". Empty
  // means unanswered, and the preview keeps its long-side default.
  function rollKind(label) {
    var text = String(label || "").toLowerCase();
    if (/\blength\b|\ba\b/.test(text)) return "a";
    if (/\bwidth\b|\bb\b/.test(text)) return "b";
    return "";
  }

  function strapKind(label) {
    var text = String(label || "").toLowerCase();
    if (text.indexOf("hinge") !== -1 || text.indexOf("charni") !== -1 || text.indexOf("joint") !== -1) return "hinge";
    if (text.indexOf("corner") !== -1 || text.indexOf("coin") !== -1) return "corners";
    if (text.indexOf("one") !== -1 || text.indexOf("une") !== -1) return "one-per-side";
    return "handle";
  }

  function groupClassFor(type) {
    if (type === "addons") return "smcbx__addons";
    if (type === "image_choices") return "smcbx__addons smcbx__addons--choice";
    if (type === "pills") return "smcbx__pills";
    if (type === "choices") return "smcbx__choice-stack";
    if (type === "shapes") return "smcbx__cards smcbx__cards--four";
    if (type === "swatches") return "smcbx__material-grid";
    return "smcbx__cards smcbx__cards--three";
  }

  function optionClassFor(type) {
    if (type === "addons") return "";
    if (type === "image_choices") return "";
    if (type === "pills") return "";
    if (type === "choices") return "smcbx__choice";
    if (type === "shapes") return "smcbx__shape";
    if (type === "swatches") return "smcbx__material-card";
    return "smcbx__card smcbx__card--thickness";
  }

  function shapeSvg(id) {
    var normalized = normalizeToken(id);
    var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("width", "44");
    svg.setAttribute("height", "44");
    svg.setAttribute("viewBox", "0 0 44 44");
    svg.setAttribute("fill", "none");
    if (normalized.indexOf("four") !== -1 && normalized.indexOf("cut") !== -1) {
      svg.innerHTML = '<path class="smcbx__configurator-fill" d="M13 4H31L40 13V31L31 40H13L4 31V13Z"></path><path class="smcbx__configurator-outline" d="M13.2 4.5H30.8L39.5 13.2V30.8L30.8 39.5H13.2L4.5 30.8V13.2Z"></path>';
    } else if (normalized.indexOf("one") !== -1 && normalized.indexOf("cut") !== -1) {
      svg.innerHTML = '<path class="smcbx__configurator-fill" d="M4 4H29L40 15V40H4Z"></path><path class="smcbx__configurator-outline" d="M4.5 4.5H28.8L39.5 15.2V39.5H4.5Z"></path>';
    } else if (normalized.indexOf("two") !== -1 && normalized.indexOf("cut") !== -1) {
      svg.innerHTML = '<path class="smcbx__configurator-fill" d="M4 4H29L40 15V29L29 40H4Z"></path><path class="smcbx__configurator-outline" d="M4.5 4.5H28.8L39.5 15.2V28.8L28.8 39.5H4.5Z"></path>';
    } else if (normalized.indexOf("custom") !== -1) {
      svg.innerHTML = '<path class="smcbx__configurator-fill-outline" d="M12 6C22 2 34 6 38 14C42 22 36 26 34 32C32 38 22 42 14 38C6 34 4 26 6 18C7.5 12 8 8 12 6Z"></path>';
    } else if (normalized.indexOf("octagon") !== -1) {
      svg.innerHTML = '<path class="smcbx__configurator-fill" d="M22 0L37.5563 6.44365L44 22L37.5563 37.5563L22 44L6.44365 37.5563L0 22L6.44365 6.44365L22 0Z"></path><path class="smcbx__configurator-outline" d="M6.82633 6.82633L22 0.541196L37.1737 6.82633L43.4588 22L37.1737 37.1737L22 43.4588L6.82633 37.1737L0.541196 22L6.82633 6.82633Z"></path>';
    } else if (normalized.indexOf("quatrefoil") !== -1 || normalized.indexOf("clover") !== -1) {
      svg.innerHTML = '<path class="smcbx__configurator-fill" d="M22 0C16.1615 0 11.4286 4.73299 11.4286 10.5714C11.4286 11.0448 11.0448 11.4286 10.5714 11.4286C4.73299 11.4286 0 16.1615 0 22C0 27.8385 4.73299 32.5715 10.5714 32.5715C11.0448 32.5715 11.4286 32.9552 11.4286 33.4285C11.4286 39.267 16.1615 44 22 44C27.8385 44 32.5715 39.267 32.5715 33.4285C32.5715 32.9552 32.9552 32.5715 33.4285 32.5715C39.267 32.5715 44 27.8385 44 22C44 16.1615 39.267 11.4286 33.4285 11.4286C32.9552 11.4286 32.5715 11.0448 32.5715 10.5714C32.5715 4.73299 27.8385 0 22 0Z"></path><path class="smcbx__configurator-outline" d="M11.9286 10.5714C11.9286 5.00913 16.4377 0.5 22 0.5C27.5623 0.5 32.0715 5.00913 32.0715 10.5714C32.0715 11.3209 32.679 11.9286 33.4285 11.9286C38.9908 11.9286 43.5 16.4377 43.5 22C43.5 27.5623 38.9908 32.0715 33.4285 32.0715C32.6791 32.0715 32.0715 32.6791 32.0715 33.4285C32.0715 38.9908 27.5623 43.5 22 43.5C16.4377 43.5 11.9286 38.9908 11.9286 33.4285C11.9286 32.679 11.3209 32.0715 10.5714 32.0715C5.00913 32.0715 0.5 27.5623 0.5 22C0.5 16.4377 5.00913 11.9286 10.5714 11.9286C11.3209 11.9286 11.9286 11.3209 11.9286 10.5714Z"></path>';
    } else if (normalized.indexOf("circle") !== -1 || normalized.indexOf("round") !== -1 && normalized.indexOf("rounded") === -1) {
      svg.innerHTML = '<rect class="smcbx__configurator-fill" width="44" height="44" rx="22"></rect><rect class="smcbx__configurator-outline" x="0.458333" y="0.458333" width="43.0833" height="43.0833" rx="21.5417"></rect>';
    } else if (normalized.indexOf("square") !== -1 && normalized.indexOf("rounded") === -1) {
      svg.dataset.shapeIcon = "square";
      svg.innerHTML = '<rect class="smcbx__configurator-fill" x="4" y="4" width="36" height="36"></rect><rect class="smcbx__configurator-outline" x="4.5" y="4.5" width="35" height="35"></rect>';
    } else if (normalized.indexOf("rounded") !== -1 || normalized.indexOf("rectangle") !== -1) {
      svg.innerHTML = '<rect class="smcbx__configurator-fill-outline" x="0.458333" y="0.458333" width="43.0833" height="43.0833" rx="7.54167"></rect>';
    } else {
      svg.innerHTML = '<rect class="smcbx__configurator-fill-outline" x="0.458333" y="0.458333" width="43.0833" height="43.0833" rx="7.54167"></rect>';
    }
    return svg;
  }

  function formatMoney(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: "currency",
        currency: currency || "CAD",
        currencyDisplay: "narrowSymbol"
      }).format((parseInt(cents, 10) || 0) / 100);
    } catch {
      return "$" + (((parseInt(cents, 10) || 0) / 100).toFixed(2));
    }
  }

  function formatSignedMoney(cents, currency) {
    return "+" + (((parseInt(cents, 10) || 0) / 100).toFixed(2)) + " " + currencySymbol(currency);
  }

  function currencySymbol(currency) {
    var code = String(currency || "CAD").toUpperCase();
    if (code === "CAD" || code === "USD") return "$";
    if (code === "EUR") return "€";
    if (code === "GBP") return "£";
    return code;
  }

  function buildCartAddFormData(items) {
    var data = new FormData();
    var indexed = items.length > 1;
    items.forEach(function (item, index) {
      var prefix = indexed ? "items[" + index + "]" : "";
      data.append(prefix ? prefix + "[id]" : "id", String(item.id));
      data.append(prefix ? prefix + "[quantity]" : "quantity", String(item.quantity || 1));
      Object.keys(item.properties || {}).forEach(function (key) {
        var value = item.properties[key];
        if (value === undefined || value === null || String(value).trim() === "") return;
        data.append(prefix ? prefix + "[properties][" + key + "]" : "properties[" + key + "]", String(value));
      });
    });
    return data;
  }

  function submitCartAddForm(url, items) {
    var form = document.createElement("form");
    form.method = "post";
    form.action = cartAddFormUrl(url);
    form.hidden = true;

    var data = buildCartAddFormData(items);
    data.append("return_to", cartUrlFromAddUrl(url));
    data.forEach(function (value, key) {
      form.appendChild(hiddenInput(key, String(value)));
    });

    document.body.appendChild(form);
    form.submit();
  }

  function cartAddFormUrl(url) {
    return url || "/cart/add";
  }

  function cartUrlFromAddUrl(url) {
    return (url || "/cart/add").replace(/\/cart\/add(\.js)?(\?.*)?$/, "/cart$2");
  }

  function normalizeToken(value) {
    return String(value || "").trim().toLowerCase();
  }

  function cssEscape(value) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (character) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[character];
    });
  }

  function withHidden(node, hidden) {
    node.hidden = Boolean(hidden);
    return node;
  }

  function zoomIcon() {
    var node = el("span", { className: "smcbx__zoom-icon", ariaHidden: "true" });
    node.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.125 3.75H16.25V6.875" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.875 8.125L16.25 3.75" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6.875 16.25H3.75V13.125" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.125 11.875L3.75 16.25" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M16.25 13.125V16.25H13.125" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.875 11.875L16.25 16.25" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.75 6.875V3.75H6.875" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.125 8.125L3.75 3.75" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    return node;
  }

  function closeIcon() {
    var node = el("span", { className: "smcbx__close-icon", ariaHidden: "true" });
    node.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 4.5L13.5 13.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path><path d="M13.5 4.5L4.5 13.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path></svg>';
    return node;
  }

  function chevronIcon() {
    var node = el("span", { className: "smcbx__chevron-icon", ariaHidden: "true" });
    node.innerHTML = '<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 4.5L13 10L7.5 15.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    return node;
  }

  function buildIcon() {
    var node = el("span", { className: "smcbx__build-thumb-icon", ariaHidden: "true" });
    node.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2.5" y="8.5" width="19" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"></rect><path d="M7 8.5v2.6M11 8.5v3.4M15 8.5v2.6M19 8.5v3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path></svg>';
    return node;
  }

  function el(tag, props) {
    var node = document.createElement(tag);
    var children = Array.prototype.slice.call(arguments, 2);
    Object.keys(props || {}).forEach(function (key) {
      var value = props[key];
      if (value === false || value === null || value === undefined) return;
      if (key === "className") node.className = value;
      else if (key === "dataset") {
        Object.keys(value).forEach(function (dataKeyName) {
          node.dataset[dataKeyName] = value[dataKeyName];
        });
      } else if (key === "style") node.setAttribute("style", value);
      else if (key in node) node[key] = value;
      else node.setAttribute(key, value === true ? "" : value);
    });
    children.flat().forEach(function (child) {
      if (child === null || child === undefined || child === false) return;
      node.appendChild(typeof child === "string" ? document.createTextNode(child) : child);
    });
    return node;
  }
})();
